import {
    AssessmentConfiguration, AWSEC2Pricing, AWSEC2RightSize, AWSLaborSupport, AWSNetwork, AWSOptimizationAndLicensing, AWSRDSPricing, AWSRDSRightSize,
    AWSStorage, DatabaseLicense, DatabaseMigrationEffort, DatabaseSprintTeamComposition, DescriptionItem, GeneralStorage, Mainframe, MainframeMigrationCost,
    MainframeOnPrem, MigrationLevelOfEffort, MigrationResourceCosts, MigrationSprintTeamComposition, MigrationStrategy, MigrationToolsAndSchedule, OnPremAdmin,
    OnPremDiscount, OnPremITOperation, OnPremNetwork, OnPremPower, OnPremServerCost, OnPremSoftware, OnPremStorage, TCOAssumptions, VMWareCloud
} from '@amzn/awscat-portfolio-assessment-types';

const emptyTCOAssumptions: TCOAssumptions = {
    tcoAssumptions: '',
    awsRegion: '',
    refreshmentDurationYears: 0,
    durationYears: 0,
    onpremEnvironment: '',
    relocateOn: false,
    enableMainframes: false,
};
const emptyAWSEC2RightSize: AWSEC2RightSize = {
    awsEC2RightSize: '',
    meridianExcludedInstanceTypes: '',
    awsCPUBuffer: 0,
    awsRamBuffer: 0,
    awsAvgCpuUtilizationPct: 0,
    useAvgCpuUtilizationForAllServers: false,
    awsAvgRamUtilizationPct: 0,
    useAvgRamUtilizationForAllServers: false,
    awsPeakCpuUtilizationPct: 0,
    usePeakCpuUtilizationForAllServers: false,
    awsPeakRamUtilizationPct: 0,
    usePeakRamUtilizationForAllServers: false,
    awsThreadsPerCore: 0,
    useThreadsPerCoreForAllServers: false,
    physicalToEC2Factor: false,
};
const emptyAWSEC2Pricing: AWSEC2Pricing = {
    awsEC2Pricing: '',
    awsRightSizePolicy: '',
    awsEC2Tenancy: '',
    awsServerUptime: 0,
    awsNonProductionServerUptime: 0,
    awsEC2PaymentTypes: [],
    awsEC2AdjustmentAmt: 0,
    awsEC2AdjustmentDesc: '',
    applyUnusedCapacity: false,
};
const emptyAWSRDSRightSize: AWSRDSRightSize = {
    awsRDSRightSize: '',
    enableEC2Recommendations: false,
    enableRDSRightSize: false,
    excludedRDSInstanceTypes: '',
    defaultTargetDatabase: '',
    defaultDatabaseEdition: '',
    defaultDatabaseLicenseModel: '',
    defaultTargetDeploymentOption: '',
    databaseAvgCpuPct: 0,
    useDatabaseAvgCpuForAll: false,
    databaseAvgRamPct: 0,
    useDatabaseAvgRamForAll: false,
    databasePeakCpuPct: 0,
    useDatabasePeakCpuForAll: false,
    databasePeakRamPct: 0,
    useDatabasePeakRamForAll: false,
    databaseThreadsPerCore: 0,
    useDatabaseThreadsPerCoreForAll: false,
};
const emptyAWSRDSPricing: AWSRDSPricing = {
    awsRDSPricing: '',
    awsRDSRecommendation: '',
    awsDatabaseUptime: 0,
    awsNonProdDatabaseUptime: 0,
    awsRDSPaymentTypes: [],
    awsRDSAdjustmentAmt: 0,
    awsRDSAdjustmentDesc: '',
};
const emptyDatabaseLicense: DatabaseLicense = {
    databaseLicense: '',
    includeDBLicenseInTCO: false,
    oracleStandardLicenseCost: 0,
    oracleStandardDiscount: 0,
    oracleStandardSupportCostRatio: 0,
    oracleEnterpriseLicenseCost: 0,
    oracleEnterpriseDiscount: 0,
    oracleEnterpriseSupportCostRatio: 0,
    oracleEnterpriseCoreFactor: '',
    useCoreFactorForAllOracle: false,
    sqlServerStandardLicenseCost: 0,
    sqlServerStandardDiscount: 0,
    sqlServerStandardSupportCostRatio: 0,
    sqlServerEnterpriseLicenseCost: 0,
    sqlServerEnterpriseDiscount: 0,
    sqlServerEnterpriseSupportCostRatio: 0,
};
const emptyDatabaseSprintTeamComposition: DatabaseSprintTeamComposition = {
    databaseSprintTeamComposition: {},
    retainPartnerOffshoreResources: 0,
    retireCustomerSrResources: 0,
    retireCustomerResources: 0,
    retireCustomerSrOffshoreResources: 0,
    retireCustomerOffshoreResources: 0,
    retireAWSSrResources: 0,
    retireAWSResources: 0,
    retireAWSSrOffshoreResources: 0,
    retireAWSOffshoreResources: 0,
    retirePartnerSrResources: 0,
    retirePartnerSrOffshoreResources: 0,
    retirePartnerResources: 0,
    retainCustomerSrResources: 0,
    retirePartnerOffshoreResources: 0,
    retainCustomerResources: 0,
    retainCustomerSrOffshoreResources: 0,
    retainCustomerOffshoreResources: 0,
    retainAWSSrResources: 0,
    retainAWSResources: 0,
    retainAWSSrOffshoreResources: 0,
    retainAWSOffshoreResources: 0,
    retainPartnerSrResources: 0,
    retainPartnerResources: 0,
    retainPartnerSrOffshoreResources: 0,
    relocateCustomerResources: 0,
    relocateCustomerSrResources: 0,
    relocateCustomerSrOffshoreResources: 0,
    relocateCustomerOffshoreResources: 0,
    relocateAWSSrResources: 0,
    relocateAWSResources: 0,
    relocateAWSSrOffshoreResources: 0,
    relocateAWSOffshoreResources: 0,
    relocatePartnerSrResources: 0,
    relocatePartnerResources: 0,
    relocatePartnerSrOffshoreResources: 0,
    relocatePartnerOffshoreResources: 0,
    repurchaseCustomerSrResources: 0,
    repurchaseCustomerResources: 0,
    repurchaseCustomerSrOffshoreResources: 0,
    repurchaseCustomerOffshoreResources: 0,
    repurchaseAWSSrResources: 0,
    repurchaseAWSResources: 0,
    repurchaseAWSSrOffshoreResources: 0,
    repurchaseAWSOffshoreResources: 0,
    repurchasePartnerSrResources: 0,
    repurchasePartnerResources: 0,
    repurchasePartnerSrOffshoreResources: 0,
    repurchasePartnerOffshoreResources: 0,
    rehostCustomerSrResources: 0,
    rehostCustomerResources: 0,
    rehostCustomerSrOffshoreResources: 0,
    rehostCustomerOffshoreResources: 0,
    rehostAWSSrResources: 0,
    rehostAWSResources: 0,
    rehostAWSSrOffshoreResources: 0,
    rehostAWSOffshoreResources: 0,
    rehostPartnerSrResources: 0,
    rehostPartnerResources: 0,
    rehostPartnerSrOffshoreResources: 0,
    rehostPartnerOffshoreResources: 0,
    replatformCustomerSrResources: 0,
    replatformCustomerResources: 0,
    replatformCustomerSrOffshoreResources: 0,
    replatformCustomerOffshoreResources: 0,
    replatformAWSSrResources: 0,
    replatformAWSResources: 0,
    replatformAWSSrOffshoreResources: 0,
    replatformAWSOffshoreResources: 0,
    replatformPartnerSrResources: 0,
    replatformPartnerResources: 0,
    replatformPartnerSrOffshoreResources: 0,
    replatformPartnerOffshoreResources: 0,
    rearchitectCustomerSrResources: 0,
    rearchitectCustomerResources: 0,
    rearchitectCustomerSrOffshoreResources: 0,
    rearchitectCustomerOffshoreResources: 0,
    rearchitectAWSSrResources: 0,
    rearchitectAWSResources: 0,
    rearchitectAWSSrOffshoreResources: 0,
    rearchitectAWSOffshoreResources: 0,
    rearchitectPartnerSrResources: 0,
    rearchitectPartnerResources: 0,
    rearchitectPartnerSrOffshoreResources: 0,
    rearchitectPartnerOffshoreResources: 0,
};
const emptyVMWareCloud: VMWareCloud = {
    vmwareCloud: '',
    instanceType: '',
    computeOvercommitFactor: 0,
    memoryOvercommitFactor: 0,
    storageOvercommitFactor: 0,
    faultToleranceMode: '',
    failuresToTolerate: '',
    vmwarePricingDiscount: 0,
};
const emptyAWSStorage: AWSStorage = {
    awsStorage: '',
    applyOnDemandUptime: false,
    monthlyBackupPct: 0,
    awsInitialBackup: '',
    awsAdditionalRedundancy: '',
    totalDiskUsagePct: 0,
    awsRaid6num: 0,
    awsRaid5num: 0,
    awsRaid1num: 0,
    awsEraseCoding: 0,
    awsNoProtection: 0,
    snapshotCompressionRatio: 0,
    awsEBSTypes: [],
    awsStorageAdjustmentAmt: 0,
    awsStorageAdjustmentDesc: '',
};
const emptyAWSNetwork: AWSNetwork = {
    awsNetwork: '',
    awsOutbound: 0,
    awsNetworkAdjustmentAmt: 0,
    awsNetworkAdjustmentDesc: '',
};
const emptyAWSLaborSupport: AWSLaborSupport = {
    awsLaborSupport: '',
    awsEC2Admin: 0,
    awsRDSAdmin: 0,
    awsStorageAdmin: 0,
    awsAdminSalary: 0,
    awsSupportPlan: '',
    awsSupportBusinessPlanLevel0: 0,
    awsSupportBusinessPlanLevel1: 0,
    awsSupportBusinessPlanLevel2: 0,
    awsSupportBusinessPlanLevel3: 0,
    awsSupportBusinessPlanLevel4: 0,
    awsSupportEntPlanLevel0: 0,
    awsSupportEntPlanLevel1: 0,
    awsSupportEntPlanLevel2: 0,
    awsSupportEntPlanLevel3: 0,
    awsSupportEntPlanLevel4: 0,
    awsSupportPartnerPrice: 0,
    awsSupportLaborAdjustmentAmt: 0,
    awsSupportLaborAdjustmentDesc: '',
};
const emptyOnPremServerCost: OnPremServerCost = {
    onPremServerCost: '',
    excludeRetireServers: false,
};
const emptyOnPremDiscount: OnPremDiscount = {
    onPremDiscount: '',
    onPremHWDiscount: 0,
    onPremStorageDiscount: 0,
    onPremSWDiscount: 0,
    onPremComputeAdjustmentAmt: 0,
    onPremComputeAdjustmentDesc: '',
    onPremDatabaseAdjustmentAmt: 0,
    onPremDatabaseAdjustmentDesc: '',
};
const emptyOnPremPower: OnPremPower = {
    onPremPower: '',
    onPremPowerPricePerKW: 0,
    powerUsageEffectiveness: 0,
    coloPowerPricePerKW: 0,
};
const emptyOnPremITOperation: OnPremITOperation = {
    onPremITOperation: '',
    serverUnitPerRack: 0,
    storageSizePerRack: 0,
    rackChassisPrice: 0,
    powerDistributionUnitCost: 0,
    countofToR: 0,
    priceofToRSupport: 0,
    serverDeploymentCost: 0,
    monthlyOnpremCostperRack: 0,
    monthlyColoCostperRack: 0,
    maintenanceRatePerYear: 0,
    spareCapacityServerPerYear: 0,
};
const emptyOnPremSoftware: OnPremSoftware = {
    onPremSoftware: '',
    estimateDhOsLicenses: false,
    onPremWindowsLicense: 0,
    onPremWindowsSupport: 0,
    onPremRhelStdLicense: 0,
    onPremRhelPremLicense: 0,
    onPremSusePhyLicense: 0,
    onPremSusevirLicense: 0,
    onPremVSphereLicense: 0,
    onPremVSphereLicenseSupport: 0,
};
const emptyOnPremStorage: OnPremStorage = {
    onPremStorage: '',
    backupPct: 0,
    onPremServerBackup: '',
    onPremAdditionalRedundancy: '',
    onPremHddSANPrice: 0,
    onPremHddNASPrice: 0,
    onPremServerStoragePrice: 0,
    onPremSddSANPrice: 0,
    onPremSddNASPrice: 0,
    onPremObjectPrice: 0,
    onPremBackupDisk: '',
    onPremBackupTapePrice: 0,
    onPremStorageSW: 0,
    onPremUncompressSpeedLTO7: 0,
    onPremUncompressSpeedLTO6: 0,
    onPrembackupIntialSnapshot: '',
    onPremRaid6num: 0,
    onPremRaid5num: 0,
    onPremRaid1num: 0,
    onPremErasenum: 0,
    onPremStorageAdjustmentAmt: 0,
    onPremStorageAdjustmentDesc: '',
};
const emptyOnPremNetwork: OnPremNetwork = {
    onPremNetwork: '',
    onPremNWHardware: 0,
    onPremNWHardwareMaintenance: 0,
    onPremBandwidthPrice: 0,
    'onPremBandwidthPrice-Needtosupportrange': 0,
    multiplierDarkFiberIX: 0,
    onPremNetworkAdjustmentAmt: 0,
    onPremNetworkAdjustmentDesc: '',
};
const emptyOnPremAdmin: OnPremAdmin = {
    onPremAdmin: '',
    onPremServerperAdmin: 0,
    onPremVMperAdmin: 0,
    onPremDatabaseAdmin: 0,
    onPremStorageperAdmin: 0,
    onPremAdminSalary: 0,
    onPremNWAdmin: 0,
    onPremLaborAdjustmentAmt: 0,
    onPremLaborAdjustmentDesc: '',
};
const emptyGeneralStorage: GeneralStorage = {
    generalStorage: '',
    serverStorageVirtual: false,
    monthlyGrowthRate: 0,
    osPenaltyPct: 0,
    capacityUsagePerformanceBuffer: 0,
    overProvisioning: 0,
    awsSANRedundancy: '',
    awsNASRedundancy: '',
    awsObjectRedundancy: '',
};
const emptyAWSOptimizationAndLicensing: AWSOptimizationAndLicensing = {
    awsOptimizationAndLicensing: '',
    databaseLicensingModel: '',
};
const emptyMainframe: Mainframe = {
    mainframe: '',
    mipsPerAwsVcpuRatio: 0,
    prodEc2InstanceBatch: '',
    prodEc2InstanceOnline: '',
    prodEc2InstanceScheduler: '',
    testEc2InstanceBatch: '',
    testEc2InstanceOnline: '',
    testEc2InstanceScheduler: '',
    devEc2InstanceBatch: '',
    devEc2InstanceOnline: '',
    devEc2InstanceScheduler: '',
    elasticLB: '',
    prodAuroraInstance: '',
    testAuroraInstance: '',
    devAuroraInstance: '',
    rdsDiskWritePercentage: 0,
    s3IAStorageTier: '',
    directConnectPort: '',
    directConnectDataOut: '',
    avgOnlineTargetCpuPercent: 0,
    avgBatchOnlineTargetCpuPercent: 0,
    onlineMipsShareCompute: 0,
    onlineMipsShareDB: 0,
    batchMipsShareCompute: 0,
    batchMipsShareDB: 0,
    prodCloudWatchMetricsPerService: 0,
    nonProdCloudWatchMetricsPerService: 0,
    ec2OS: '',
    ec2Tenancy: '',
    avgSizePerEBSVolumeInGB: 0,
    putsPerTBS3Thousands: 0,
    getsPerTBS3Thousands: 0,
    totalLcus: 0,
    mainframeOnAWSAdjustmentAmt: 0,
    mainframeOnAWSAdjustmentDesc: '',
    mainframeOnAWS3rdPartyAmt: 0,
    mainframeOnAWS3rdPartyDesc: '',
    disasterRecoveryStrategy: '',
};
const emptyMainframeOnPrem: MainframeOnPrem = {
    mainframeOnPrem: '',
    totalInstalledMIPS: 0,
    smallMIPSCost: 0,
    mediumMIPSCost: 0,
    largeMIPSCost: 0,
    mainframeCostDistHW: 0,
    mainframeCostDistSW: 0,
    mainframeCostDistPersonnel: 0,
    mainframeCostDistConnectivity: 0,
    mainframeCostDistOccupancy: 0,
    mainframeCostDistDR: 0,
    mainframeCostDistUnallocated: 0,
    mainframeOnPremAdjustmentAmt: 0,
    mainframeOnPremAdjustmentDesc: '',
};
const emptyMainframeMigrationCost: MainframeMigrationCost = {
    mainframeMigrationCost: '',
    totalLinesOfCode: 0,
    locPerTestCase: 0,
    smallerTestTierLaborCost: 0,
    smallTestTierLaborCost: 0,
    mediumTestTierLaborCost: 0,
    largeTestTierLaborCost: 0,
    largerTestTierLaborCost: 0,
    largestTestTierLaborCost: 0,
    smallerMigrationTierToolCost: 0,
    smallMigrationTierToolCost: 0,
    mediumMigrationTierToolCost: 0,
    largeMigrationTierToolCost: 0,
    largerMigrationTierToolCost: 0,
    largestMigrationTierToolCost: 0,
    migrationSupportCostPerMonth: 0,
    integratedDependenciesPerEnv: 0,
    laborCostPerIntegratedDependency: 0,
    mainframeMigrationAdjustmentAmt: 0,
    mainframeMigrationAdjustmentDesc: '',
};
const emptyMigrationStrategy: MigrationStrategy = {
    migrationStrategy: '',
    optimusOn: false,
};
const emptyMigrationToolsAndSchedule: MigrationToolsAndSchedule = {
    migrationToolsAndSchedule: '',
    discoveryTool: 0,
    migrationTool: 0,
    trainingCost: 0,
    countOfResourcesToTrain: 0,
    projectDurationWeeks: '',
    sprintDuration: 0,
    workingHoursPerWeek: 0,
    managementWorkingHoursPerWeek: 0,
    otherCosts: 0,
    customerLocation: '',
};
const emptyMigrationLevelOfEffort: MigrationLevelOfEffort = {
    migrationLevelOfEffort: '',
    retire: 0,
    retain: 0,
    relocate: 0,
    repurchase: 0,
    rehost: 0,
    replatform: 0,
    rearchitect: 0,
};
const emptyMigrationResourceCosts: MigrationResourceCosts = {
    migrationResourceCosts: '',
    awsCost: 0,
    awsOffshoreCost: 0,
    awsSeniorCost: 0,
    awsSeniorOffshoreCost: 0,
    customerCost: 0,
    customerOffshoreCost: 0,
    customerSeniorCost: 0,
    customerSeniorOffshoreCost: 0,
    partnerCost: 0,
    partnerOffshoreCost: 0,
    partnerSeniorCost: 0,
    partnerSeniorOffshoreCost: 0,
};
const emptyMigrationSprintTeamComposition: MigrationSprintTeamComposition = {
    migrationSprintTeamComposition: '',
    rearchitectAWSOffshoreResources: 0,
    rearchitectAWSResources: 0,
    rearchitectAWSSrOffshoreResources: 0,
    rearchitectAWSSrResources: 0,
    rearchitectCustomerOffshoreResources: 0,
    rearchitectCustomerResources: 0,
    rearchitectCustomerSrOffshoreResources: 0,
    rearchitectCustomerSrResources: 0,
    rearchitectPartnerOffshoreResources: 0,
    rearchitectPartnerResources: 0,
    rearchitectPartnerSrOffshoreResources: 0,
    rearchitectPartnerSrResources: 0,
    rehostAWSOffshoreResources: 0,
    rehostAWSResources: 0,
    rehostAWSSrOffshoreResources: 0,
    rehostAWSSrResources: 0,
    rehostCustomerOffshoreResources: 0,
    rehostCustomerResources: 0,
    rehostCustomerSrOffshoreResources: 0,
    rehostCustomerSrResources: 0,
    rehostPartnerOffshoreResources: 0,
    rehostPartnerResources: 0,
    rehostPartnerSrOffshoreResources: 0,
    rehostPartnerSrResources: 0,
    relocateAWSOffshoreResources: 0,
    relocateAWSResources: 0,
    relocateAWSSrOffshoreResources: 0,
    relocateAWSSrResources: 0,
    relocateCustomerOffshoreResources: 0,
    relocateCustomerResources: 0,
    relocateCustomerSrOffshoreResources: 0,
    relocateCustomerSrResources: 0,
    relocatePartnerOffshoreResources: 0,
    relocatePartnerResources: 0,
    relocatePartnerSrOffshoreResources: 0,
    relocatePartnerSrResources: 0,
    replatformAWSOffshoreResources: 0,
    replatformAWSResources: 0,
    replatformAWSSrOffshoreResources: 0,
    replatformAWSSrResources: 0,
    replatformCustomerOffshoreResources: 0,
    replatformCustomerResources: 0,
    replatformCustomerSrOffshoreResources: 0,
    replatformCustomerSrResources: 0,
    replatformPartnerOffshoreResources: 0,
    replatformPartnerResources: 0,
    replatformPartnerSrOffshoreResources: 0,
    replatformPartnerSrResources: 0,
    repurchaseAWSOffshoreResources: 0,
    repurchaseAWSResources: 0,
    repurchaseAWSSrOffshoreResources: 0,
    repurchaseAWSSrResources: 0,
    repurchaseCustomerOffshoreResources: 0,
    repurchaseCustomerResources: 0,
    repurchaseCustomerSrOffshoreResources: 0,
    repurchaseCustomerSrResources: 0,
    repurchasePartnerOffshoreResources: 0,
    repurchasePartnerResources: 0,
    repurchasePartnerSrOffshoreResources: 0,
    repurchasePartnerSrResources: 0,
    retainAWSOffshoreResources: 0,
    retainAWSResources: 0,
    retainAWSSrOffshoreResources: 0,
    retainAWSSrResources: 0,
    retainCustomerOffshoreResources: 0,
    retainCustomerResources: 0,
    retainCustomerSrOffshoreResources: 0,
    retainCustomerSrResources: 0,
    retainPartnerOffshoreResources: 0,
    retainPartnerResources: 0,
    retainPartnerSrOffshoreResources: 0,
    retainPartnerSrResources: 0,
    retireAWSOffshoreResources: 0,
    retireAWSResources: 0,
    retireAWSSrOffshoreResources: 0,
    retireAWSSrResources: 0,
    retireCustomerOffshoreResources: 0,
    retireCustomerResources: 0,
    retireCustomerSrOffshoreResources: 0,
    retireCustomerSrResources: 0,
    retirePartnerOffshoreResources: 0,
    retirePartnerResources: 0,
    retirePartnerSrOffshoreResources: 0,
    retirePartnerSrResources: 0,
};
const emptyDatabaseMigrationEffort: DatabaseMigrationEffort = {
    databaseMigrationEffort: '',
    retire: 0,
    rehost: 0,
    replatform: 0,
    rearchitect: 0,
};
export const emptyAssessmentConfiguration: AssessmentConfiguration = {
    tcoAssumptions: emptyTCOAssumptions,
    awsEC2RightSize: emptyAWSEC2RightSize,
    awsEC2Pricing: emptyAWSEC2Pricing,
    awsRDSRightSize: emptyAWSRDSRightSize,
    awsRDSPricing: emptyAWSRDSPricing,
    databaseLicense: emptyDatabaseLicense,
    vmwareCloud: emptyVMWareCloud,
    awsStorage: emptyAWSStorage,
    awsNetwork: emptyAWSNetwork,
    awsLaborSupport: emptyAWSLaborSupport,
    onPremServerCost: emptyOnPremServerCost,
    onPremDiscount: emptyOnPremDiscount,
    onPremPower: emptyOnPremPower,
    onPremITOperation: emptyOnPremITOperation,
    onPremSoftware: emptyOnPremSoftware,
    onPremStorage: emptyOnPremStorage,
    onPremNetwork: emptyOnPremNetwork,
    onPremAdmin: emptyOnPremAdmin,
    generalStorage: emptyGeneralStorage,
    awsOptimizationAndLicensing: emptyAWSOptimizationAndLicensing,
    mainframe: emptyMainframe,
    mainframeOnPrem: emptyMainframeOnPrem,
    mainframeMigrationCost: emptyMainframeMigrationCost,
    migrationStrategy: emptyMigrationStrategy,
    migrationResourceCosts: emptyMigrationResourceCosts,
    migrationSprintTeamComposition: emptyMigrationSprintTeamComposition,
    databaseSprintTeamComposition: emptyDatabaseSprintTeamComposition,
    migrationToolsAndSchedule: emptyMigrationToolsAndSchedule,
    migrationLevelOfEffort: emptyMigrationLevelOfEffort,
    databaseMigrationEffort: emptyDatabaseMigrationEffort,
    amerDatabaseSprintTeamComposition: emptyDatabaseSprintTeamComposition,
    amerMigrationResourceCosts: emptyMigrationResourceCosts,
    amerMigrationSprintTeamComposition: emptyMigrationSprintTeamComposition,
    amerMigrationToolsAndSchedule: emptyMigrationToolsAndSchedule,
    apacDatabaseSprintTeamComposition: emptyDatabaseSprintTeamComposition,
    apacMigrationResourceCosts: emptyMigrationResourceCosts,
    apacMigrationSprintTeamComposition: emptyMigrationSprintTeamComposition,
    apacMigrationToolsAndSchedule: emptyMigrationToolsAndSchedule,
    chinaDatabaseSprintTeamComposition: emptyDatabaseSprintTeamComposition,
    chinaMigrationResourceCosts: emptyMigrationResourceCosts,
    chinaMigrationSprintTeamComposition: emptyMigrationSprintTeamComposition,
    chinaMigrationToolsAndSchedule: emptyMigrationToolsAndSchedule,
    emeaDatabaseSprintTeamComposition: emptyDatabaseSprintTeamComposition,
    emeaMigrationResourceCosts: emptyMigrationResourceCosts,
    emeaMigrationSprintTeamComposition: emptyMigrationSprintTeamComposition,
    emeaMigrationToolsAndSchedule: emptyMigrationToolsAndSchedule,
    japnDatabaseSprintTeamComposition: emptyDatabaseSprintTeamComposition,
    japnMigrationResourceCosts: emptyMigrationResourceCosts,
    japnMigrationSprintTeamComposition: emptyMigrationSprintTeamComposition,
    japnMigrationToolsAndSchedule: emptyMigrationToolsAndSchedule,
    latamDatabaseSprintTeamComposition: emptyDatabaseSprintTeamComposition,
    latamMigrationResourceCosts: emptyMigrationResourceCosts,
    latamMigrationSprintTeamComposition: emptyMigrationSprintTeamComposition,
    latamMigrationToolsAndSchedule: emptyMigrationToolsAndSchedule,
};

export const defaultConfiguration: AssessmentConfiguration = {
    tcoAssumptions: {
        awsRegion: 'us-east-1',
        refreshmentDurationYears: 5,
        durationYears: 5,
        onpremEnvironment: 'onprem',
        relocateOn: false,
        enableMainframes: false,
    },
    awsEC2RightSize: {
        meridianExcludedInstanceTypes: '',
        awsCPUBuffer: 0,
        awsRamBuffer: 0,
        awsAvgCpuUtilizationPct: 24,
        useAvgCpuUtilizationForAllServers: false,
        awsAvgRamUtilizationPct: 59,
        useAvgRamUtilizationForAllServers: false,
        awsPeakCpuUtilizationPct: 24,
        usePeakCpuUtilizationForAllServers: false,
        awsPeakRamUtilizationPct: 59,
        usePeakRamUtilizationForAllServers: false,
        awsThreadsPerCore: 1,
        useThreadsPerCoreForAllServers: false,
        physicalToEC2Factor: true
    },
    awsEC2Pricing: {
        awsRightSizePolicy: '503',
        awsEC2Tenancy: 'Shared',
        awsServerUptime: 100,
        awsNonProductionServerUptime: 24,
        awsEC2PaymentTypes: [
            'onDemand',
            'std3Au',
            'std3Pu',
            'std3Nu',
            'std1Au',
            'std1Pu',
            'std1Nu',
            'con3Au',
            'con3Pu',
            'con3Nu',
            'con1Au',
            'con1Pu',
            'con1Nu'
        ],
        awsEC2AdjustmentAmt: 0,
        awsEC2AdjustmentDesc: '',
        applyUnusedCapacity: true
    },
    awsRDSRightSize: {
        enableEC2Recommendations: false,
        enableRDSRightSize: false,
        excludedRDSInstanceTypes: '',
        defaultTargetDatabase: 'Aurora MySQL',
        defaultDatabaseEdition: 'Enterprise',
        defaultDatabaseLicenseModel: 'License included',
        defaultTargetDeploymentOption: 'Single-AZ',
        databaseAvgCpuPct: 24,
        useDatabaseAvgCpuForAll: false,
        databaseAvgRamPct: 59,
        useDatabaseAvgRamForAll: false,
        databasePeakCpuPct: 24,
        useDatabasePeakCpuForAll: false,
        databasePeakRamPct: 59,
        useDatabasePeakRamForAll: false,
        databaseThreadsPerCore: 1,
        useDatabaseThreadsPerCoreForAll: false
    },
    awsRDSPricing: {
        awsRDSRecommendation: 'peak',
        awsDatabaseUptime: 100,
        awsNonProdDatabaseUptime: 24,
        awsRDSPaymentTypes: [
            'ON_DEMAND',
            'ONE_YEAR_NO_UPFRONT',
            'ONE_YEAR_PARTIAL_UPFRONT',
            'ONE_YEAR_ALL_UPFRONT',
            'THREE_YEAR_PARTIAL_UPFRONT',
            'THREE_YEAR_ALL_UPFRONT'
        ],
        awsRDSAdjustmentAmt: 0,
        awsRDSAdjustmentDesc: ''
    },
    databaseLicense: {
        includeDBLicenseInTCO: false,
        oracleStandardLicenseCost: 17500,
        oracleStandardDiscount: 0,
        oracleStandardSupportCostRatio: 22,
        oracleEnterpriseLicenseCost: 47500,
        oracleEnterpriseDiscount: 0,
        oracleEnterpriseSupportCostRatio: 22,
        oracleEnterpriseCoreFactor: '1',
        useCoreFactorForAllOracle: false,
        sqlServerStandardLicenseCost: 3586,
        sqlServerStandardDiscount: 0,
        sqlServerStandardSupportCostRatio: 0,
        sqlServerEnterpriseLicenseCost: 13748,
        sqlServerEnterpriseDiscount: 0,
        sqlServerEnterpriseSupportCostRatio: 0
    },
    vmwareCloud: {
        instanceType: 'recommend',
        computeOvercommitFactor: 4,
        memoryOvercommitFactor: 1,
        storageOvercommitFactor: 1,
        faultToleranceMode: 'RAID-1',
        failuresToTolerate: '1',
        vmwarePricingDiscount: 0
    },
    awsStorage: {
        applyOnDemandUptime: false,
        monthlyBackupPct: 0,
        awsInitialBackup: 'yes',
        awsAdditionalRedundancy: '0',
        totalDiskUsagePct: 50,
        awsRaid6num: 18,
        awsRaid5num: 20,
        awsRaid1num: 50,
        awsEraseCoding: 25,
        awsNoProtection: 0,
        snapshotCompressionRatio: 1,
        awsEBSTypes: [
            'ebsGp2', 'ebsGp3'
        ],
        awsStorageAdjustmentAmt: 0,
        awsStorageAdjustmentDesc: ''
    },
    awsNetwork: {
        awsOutbound: 50,
        awsNetworkAdjustmentAmt: 0,
        awsNetworkAdjustmentDesc: ''
    },
    awsLaborSupport: {
        awsEC2Admin: 400,
        awsRDSAdmin: 400,
        awsStorageAdmin: 5000,
        awsAdminSalary: 135000,
        awsSupportPlan: 'business',
        awsSupportBusinessPlanLevel0: 100,
        awsSupportBusinessPlanLevel1: 10,
        awsSupportBusinessPlanLevel2: 7,
        awsSupportBusinessPlanLevel3: 5,
        awsSupportBusinessPlanLevel4: 3,
        awsSupportEntPlanLevel0: 15000,
        awsSupportEntPlanLevel1: 10,
        awsSupportEntPlanLevel2: 7,
        awsSupportEntPlanLevel3: 5,
        awsSupportEntPlanLevel4: 3,
        awsSupportPartnerPrice: 0,
        awsSupportLaborAdjustmentAmt: 0,
        awsSupportLaborAdjustmentDesc: ''
    },
    onPremServerCost: {
        excludeRetireServers: false
    },
    onPremDiscount: {
        onPremHWDiscount: 40,
        onPremStorageDiscount: 50,
        onPremSWDiscount: 25,
        onPremComputeAdjustmentAmt: 0,
        onPremComputeAdjustmentDesc: '',
        onPremDatabaseAdjustmentAmt: 0,
        onPremDatabaseAdjustmentDesc: ''
    },
    onPremPower: {
        onPremPowerPricePerKW: 0.107,
        powerUsageEffectiveness: 1.6,
        coloPowerPricePerKW: 0.107
    },
    onPremITOperation: {
        serverUnitPerRack: 28,
        storageSizePerRack: 2000,
        rackChassisPrice: 1850,
        powerDistributionUnitCost: 460,
        countofToR: 2,
        priceofToRSupport: 1917,
        serverDeploymentCost: 250,
        monthlyOnpremCostperRack: 1400,
        monthlyColoCostperRack: 2600,
        maintenanceRatePerYear: 15,
        spareCapacityServerPerYear: 5
    },
    onPremSoftware: {
        estimateDhOsLicenses: false,
        onPremWindowsLicense: 769,
        onPremWindowsSupport: 25,
        onPremRhelStdLicense: 799,
        onPremRhelPremLicense: 2499,
        onPremSusePhyLicense: 799,
        onPremSusevirLicense: 1598,
        onPremVSphereLicense: 3595,
        onPremVSphereLicenseSupport: 25
    },
    onPremStorage: {
        backupPct: 0,
        onPremServerBackup: 'yes',
        onPremAdditionalRedundancy: '1',
        onPremHddSANPrice: 1.1,
        onPremHddNASPrice: 0.4,
        onPremServerStoragePrice: 1.02,
        onPremSddSANPrice: 3,
        onPremSddNASPrice: 1.7,
        onPremObjectPrice: 1.1,
        onPremBackupDisk: 'lto7',
        onPremBackupTapePrice: 2300,
        onPremStorageSW: 40,
        onPremUncompressSpeedLTO7: 300,
        onPremUncompressSpeedLTO6: 160,
        onPrembackupIntialSnapshot: 'yes',
        onPremRaid6num: 18,
        onPremRaid5num: 20,
        onPremRaid1num: 50,
        onPremErasenum: 25,
        onPremStorageAdjustmentAmt: 0,
        onPremStorageAdjustmentDesc: ''
    },
    onPremNetwork: {
        onPremNWHardware: 20,
        onPremNWHardwareMaintenance: 25,
        onPremBandwidthPrice: 5,
        'onPremBandwidthPrice-Needtosupportrange': 25,
        multiplierDarkFiberIX: 1.5,
        onPremNetworkAdjustmentAmt: 0,
        onPremNetworkAdjustmentDesc: ''
    },
    onPremAdmin: {
        onPremServerperAdmin: 100,
        onPremVMperAdmin: 250,
        onPremDatabaseAdmin: 250,
        onPremStorageperAdmin: 2500,
        onPremAdminSalary: 135000,
        onPremNWAdmin: 8,
        onPremLaborAdjustmentAmt: 0,
        onPremLaborAdjustmentDesc: ''
    },
    generalStorage: {
        serverStorageVirtual: false,
        monthlyGrowthRate: 0,
        osPenaltyPct: 5,
        capacityUsagePerformanceBuffer: 15,
        overProvisioning: 15,
        awsSANRedundancy: 'raid5',
        awsNASRedundancy: 'raid5',
        awsObjectRedundancy: 'raid5'
    },
    awsOptimizationAndLicensing: {
        databaseLicensingModel: 'host'
    },
    mainframe: {
        mipsPerAwsVcpuRatio: 25,
        prodEc2InstanceBatch: 'm5.xlarge',
        prodEc2InstanceOnline: 'm5.xlarge',
        prodEc2InstanceScheduler: 'm5.xlarge',
        testEc2InstanceBatch: 't3.medium',
        testEc2InstanceOnline: 't3.medium',
        testEc2InstanceScheduler: 't3.medium',
        devEc2InstanceBatch: 't3.medium',
        devEc2InstanceOnline: 'm5.xlarge',
        devEc2InstanceScheduler: 't3.medium',
        elasticLB: 'Network LB',
        prodAuroraInstance: 'db.r5.2xlarge',
        testAuroraInstance: 'db.r5.large',
        devAuroraInstance: 'db.r5.large',
        rdsDiskWritePercentage: 20,
        s3IAStorageTier: 'S3 Standard IA',
        directConnectPort: '10G',
        directConnectDataOut: 'United States',
        avgOnlineTargetCpuPercent: 60,
        avgBatchOnlineTargetCpuPercent: 80,
        onlineMipsShareCompute: 70,
        onlineMipsShareDB: 30,
        batchMipsShareCompute: 50,
        batchMipsShareDB: 50,
        prodCloudWatchMetricsPerService: 10,
        nonProdCloudWatchMetricsPerService: 5,
        ec2OS: 'Linux',
        ec2Tenancy: 'shared',
        avgSizePerEBSVolumeInGB: 200,
        putsPerTBS3Thousands: 0,
        getsPerTBS3Thousands: 0,
        totalLcus: 0,
        mainframeOnAWSAdjustmentAmt: 0,
        mainframeOnAWSAdjustmentDesc: '',
        mainframeOnAWS3rdPartyAmt: 0,
        mainframeOnAWS3rdPartyDesc: '',
        disasterRecoveryStrategy: 'warm_standby'
    },
    mainframeOnPrem: {
        totalInstalledMIPS: 20000,
        smallMIPSCost: 5992,
        mediumMIPSCost: 2194,
        largeMIPSCost: 841,
        mainframeCostDistHW: 22,
        mainframeCostDistSW: 46,
        mainframeCostDistPersonnel: 28,
        mainframeCostDistConnectivity: 0,
        mainframeCostDistOccupancy: 1,
        mainframeCostDistDR: 1,
        mainframeCostDistUnallocated: 2,
        mainframeOnPremAdjustmentAmt: 0,
        mainframeOnPremAdjustmentDesc: ''
    },
    mainframeMigrationCost: {
        totalLinesOfCode: 3000000,
        locPerTestCase: 3000,
        smallerTestTierLaborCost: 2000,
        smallTestTierLaborCost: 1900,
        mediumTestTierLaborCost: 1800,
        largeTestTierLaborCost: 1700,
        largerTestTierLaborCost: 1600,
        largestTestTierLaborCost: 1500,
        smallerMigrationTierToolCost: 0.6,
        smallMigrationTierToolCost: 0.4,
        mediumMigrationTierToolCost: 0.3,
        largeMigrationTierToolCost: 0.2,
        largerMigrationTierToolCost: 0.15,
        largestMigrationTierToolCost: 0.13,
        migrationSupportCostPerMonth: 20000,
        integratedDependenciesPerEnv: 2,
        laborCostPerIntegratedDependency: 20000,
        mainframeMigrationAdjustmentAmt: 0,
        mainframeMigrationAdjustmentDesc: ''
    },
    migrationStrategy: {
        optimusOn: false
    },
    apacMigrationResourceCosts: {
        customerSeniorCost: 0,
        customerCost: 0,
        customerOffshoreCost: 0,
        customerSeniorOffshoreCost: 0,
        awsSeniorCost: 345,
        awsCost: 265,
        awsSeniorOffshoreCost: 175,
        awsOffshoreCost: 100,
        partnerSeniorCost: 250,
        partnerCost: 150,
        partnerOffshoreCost: 150,
        partnerSeniorOffshoreCost: 150
    },
    apacMigrationSprintTeamComposition: {
        retainPartnerOffshoreResources: 0,
        retireCustomerSrResources: 1,
        retireCustomerResources: 0,
        retireCustomerSrOffshoreResources: 0,
        retireCustomerOffshoreResources: 0,
        retireAWSSrResources: 0,
        retireAWSResources: 0,
        retireAWSSrOffshoreResources: 0,
        retireAWSOffshoreResources: 0,
        retirePartnerSrResources: 0,
        retirePartnerResources: 0,
        retirePartnerSrOffshoreResources: 0,
        retirePartnerOffshoreResources: 0,
        retainCustomerSrResources: 1,
        retainCustomerResources: 0,
        retainCustomerSrOffshoreResources: 0,
        retainCustomerOffshoreResources: 0,
        retainAWSSrResources: 0,
        retainAWSResources: 0,
        retainAWSSrOffshoreResources: 0,
        retainAWSOffshoreResources: 0,
        retainPartnerSrResources: 1,
        retainPartnerResources: 0,
        retainPartnerSrOffshoreResources: 0,
        relocateCustomerSrResources: 1,
        relocateCustomerResources: 0,
        relocateCustomerSrOffshoreResources: 0,
        relocateCustomerOffshoreResources: 0,
        relocateAWSSrResources: 1,
        relocateAWSResources: 0,
        relocateAWSSrOffshoreResources: 0,
        relocateAWSOffshoreResources: 0,
        relocatePartnerSrResources: 3,
        relocatePartnerResources: 0,
        relocatePartnerSrOffshoreResources: 0,
        relocatePartnerOffshoreResources: 0,
        repurchaseCustomerSrResources: 2,
        repurchaseCustomerResources: 0,
        repurchaseCustomerSrOffshoreResources: 0,
        repurchaseCustomerOffshoreResources: 0,
        repurchaseAWSSrResources: 1,
        repurchaseAWSResources: 0,
        repurchaseAWSSrOffshoreResources: 0,
        repurchaseAWSOffshoreResources: 0,
        repurchasePartnerSrResources: 2,
        repurchasePartnerResources: 0,
        repurchasePartnerSrOffshoreResources: 0,
        repurchasePartnerOffshoreResources: 0,
        rehostCustomerSrResources: 1,
        rehostCustomerResources: 0,
        rehostCustomerSrOffshoreResources: 0,
        rehostCustomerOffshoreResources: 0,
        rehostAWSSrResources: 1,
        rehostAWSResources: 0,
        rehostAWSSrOffshoreResources: 0,
        rehostAWSOffshoreResources: 0,
        rehostPartnerSrResources: 3,
        rehostPartnerResources: 0,
        rehostPartnerSrOffshoreResources: 0,
        rehostPartnerOffshoreResources: 0,
        replatformCustomerSrResources: 2,
        replatformCustomerResources: 0,
        replatformCustomerSrOffshoreResources: 0,
        replatformCustomerOffshoreResources: 0,
        replatformAWSSrResources: 1,
        replatformAWSResources: 0,
        replatformAWSSrOffshoreResources: 0,
        replatformAWSOffshoreResources: 0,
        replatformPartnerSrResources: 3,
        replatformPartnerResources: 0,
        replatformPartnerSrOffshoreResources: 0,
        replatformPartnerOffshoreResources: 0,
        rearchitectCustomerSrResources: 3,
        rearchitectCustomerResources: 0,
        rearchitectCustomerSrOffshoreResources: 0,
        rearchitectCustomerOffshoreResources: 0,
        rearchitectAWSSrResources: 1,
        rearchitectAWSResources: 0,
        rearchitectAWSSrOffshoreResources: 0,
        rearchitectAWSOffshoreResources: 0,
        rearchitectPartnerSrResources: 4,
        rearchitectPartnerResources: 0,
        rearchitectPartnerSrOffshoreResources: 0,
        rearchitectPartnerOffshoreResources: 0
    },
    apacMigrationToolsAndSchedule: {
        discoveryTool: 50,
        migrationTool: 0,
        trainingCost: 2500,
        countOfResourcesToTrain: 0,
        projectDurationWeeks: '104',
        sprintDuration: 2,
        workingHoursPerWeek: 40,
        managementWorkingHoursPerWeek: 10,
        otherCosts: 0,
        customerLocation: 'apac'
    },
    apacDatabaseSprintTeamComposition: {
        retainPartnerOffshoreResources: 0,
        retireCustomerSrResources: 1,
        retireCustomerResources: 0,
        retireCustomerSrOffshoreResources: 0,
        retireCustomerOffshoreResources: 0,
        retireAWSSrResources: 0,
        retireAWSResources: 0,
        retireAWSSrOffshoreResources: 0,
        retireAWSOffshoreResources: 0,
        retirePartnerSrResources: 0,
        retirePartnerResources: 0,
        retirePartnerSrOffshoreResources: 0,
        retirePartnerOffshoreResources: 0,
        retainCustomerSrResources: 1,
        retainCustomerResources: 0,
        retainCustomerSrOffshoreResources: 0,
        retainCustomerOffshoreResources: 0,
        retainAWSSrResources: 0,
        retainAWSResources: 0,
        retainAWSSrOffshoreResources: 0,
        retainAWSOffshoreResources: 0,
        retainPartnerSrResources: 1,
        retainPartnerResources: 0,
        retainPartnerSrOffshoreResources: 0,
        relocateCustomerSrResources: 1,
        relocateCustomerResources: 0,
        relocateCustomerSrOffshoreResources: 0,
        relocateCustomerOffshoreResources: 0,
        relocateAWSSrResources: 1,
        relocateAWSResources: 0,
        relocateAWSSrOffshoreResources: 0,
        relocateAWSOffshoreResources: 0,
        relocatePartnerSrResources: 3,
        relocatePartnerResources: 0,
        relocatePartnerSrOffshoreResources: 0,
        relocatePartnerOffshoreResources: 0,
        repurchaseCustomerSrResources: 2,
        repurchaseCustomerResources: 0,
        repurchaseCustomerSrOffshoreResources: 0,
        repurchaseCustomerOffshoreResources: 0,
        repurchaseAWSSrResources: 1,
        repurchaseAWSResources: 0,
        repurchaseAWSSrOffshoreResources: 0,
        repurchaseAWSOffshoreResources: 0,
        repurchasePartnerSrResources: 2,
        repurchasePartnerResources: 0,
        repurchasePartnerSrOffshoreResources: 0,
        repurchasePartnerOffshoreResources: 0,
        rehostCustomerSrResources: 1,
        rehostCustomerResources: 0,
        rehostCustomerSrOffshoreResources: 0,
        rehostCustomerOffshoreResources: 0,
        rehostAWSSrResources: 1,
        rehostAWSResources: 0,
        rehostAWSSrOffshoreResources: 0,
        rehostAWSOffshoreResources: 0,
        rehostPartnerSrResources: 3,
        rehostPartnerResources: 0,
        rehostPartnerSrOffshoreResources: 0,
        rehostPartnerOffshoreResources: 0,
        replatformCustomerSrResources: 2,
        replatformCustomerResources: 0,
        replatformCustomerSrOffshoreResources: 0,
        replatformCustomerOffshoreResources: 0,
        replatformAWSSrResources: 1,
        replatformAWSResources: 0,
        replatformAWSSrOffshoreResources: 0,
        replatformAWSOffshoreResources: 0,
        replatformPartnerSrResources: 3,
        replatformPartnerResources: 0,
        replatformPartnerSrOffshoreResources: 0,
        replatformPartnerOffshoreResources: 0,
        rearchitectCustomerSrResources: 3,
        rearchitectCustomerResources: 0,
        rearchitectCustomerSrOffshoreResources: 0,
        rearchitectCustomerOffshoreResources: 0,
        rearchitectAWSSrResources: 1,
        rearchitectAWSResources: 0,
        rearchitectAWSSrOffshoreResources: 0,
        rearchitectAWSOffshoreResources: 0,
        rearchitectPartnerSrResources: 4,
        rearchitectPartnerResources: 0,
        rearchitectPartnerSrOffshoreResources: 0,
        rearchitectPartnerOffshoreResources: 0
    },
    chinaMigrationResourceCosts: {
        customerSeniorCost: 0,
        customerCost: 0,
        customerOffshoreCost: 0,
        customerSeniorOffshoreCost: 0,
        awsSeniorCost: 345,
        awsCost: 260,
        awsSeniorOffshoreCost: 175,
        awsOffshoreCost: 100,
        partnerSeniorCost: 200,
        partnerCost: 100,
        partnerOffshoreCost: 100,
        partnerSeniorOffshoreCost: 200
    },
    chinaMigrationSprintTeamComposition: {
        retainPartnerOffshoreResources: 0,
        retireCustomerSrResources: 1,
        retireCustomerResources: 0,
        retireCustomerSrOffshoreResources: 0,
        retireCustomerOffshoreResources: 0,
        retireAWSSrResources: 0,
        retireAWSResources: 0,
        retireAWSSrOffshoreResources: 0,
        retireAWSOffshoreResources: 0,
        retirePartnerSrResources: 0,
        retirePartnerResources: 0,
        retirePartnerSrOffshoreResources: 0,
        retirePartnerOffshoreResources: 0,
        retainCustomerSrResources: 1,
        retainCustomerResources: 0,
        retainCustomerSrOffshoreResources: 0,
        retainCustomerOffshoreResources: 0,
        retainAWSSrResources: 0,
        retainAWSResources: 0,
        retainAWSSrOffshoreResources: 0,
        retainAWSOffshoreResources: 0,
        retainPartnerSrResources: 1,
        retainPartnerResources: 0,
        retainPartnerSrOffshoreResources: 0,
        relocateCustomerSrResources: 1,
        relocateCustomerResources: 0,
        relocateCustomerSrOffshoreResources: 0,
        relocateCustomerOffshoreResources: 0,
        relocateAWSSrResources: 1,
        relocateAWSResources: 0,
        relocateAWSSrOffshoreResources: 0,
        relocateAWSOffshoreResources: 0,
        relocatePartnerSrResources: 3,
        relocatePartnerResources: 0,
        relocatePartnerSrOffshoreResources: 0,
        relocatePartnerOffshoreResources: 0,
        repurchaseCustomerSrResources: 1,
        repurchaseCustomerResources: 1,
        repurchaseCustomerSrOffshoreResources: 0,
        repurchaseCustomerOffshoreResources: 0,
        repurchaseAWSSrResources: 1,
        repurchaseAWSResources: 0,
        repurchaseAWSSrOffshoreResources: 0,
        repurchaseAWSOffshoreResources: 0,
        repurchasePartnerSrResources: 0,
        repurchasePartnerResources: 2,
        repurchasePartnerSrOffshoreResources: 0,
        repurchasePartnerOffshoreResources: 0,
        rehostCustomerSrResources: 1,
        rehostCustomerResources: 0,
        rehostCustomerSrOffshoreResources: 0,
        rehostCustomerOffshoreResources: 0,
        rehostAWSSrResources: 1,
        rehostAWSResources: 1,
        rehostAWSSrOffshoreResources: 0,
        rehostAWSOffshoreResources: 0,
        rehostPartnerSrResources: 1,
        rehostPartnerResources: 2,
        rehostPartnerSrOffshoreResources: 0,
        rehostPartnerOffshoreResources: 0,
        replatformCustomerSrResources: 1,
        replatformCustomerResources: 1,
        replatformCustomerSrOffshoreResources: 0,
        replatformCustomerOffshoreResources: 0,
        replatformAWSSrResources: 1,
        replatformAWSResources: 1,
        replatformAWSSrOffshoreResources: 0,
        replatformAWSOffshoreResources: 0,
        replatformPartnerSrResources: 1,
        replatformPartnerResources: 2,
        replatformPartnerSrOffshoreResources: 0,
        replatformPartnerOffshoreResources: 0,
        rearchitectCustomerSrResources: 1,
        rearchitectCustomerResources: 2,
        rearchitectCustomerSrOffshoreResources: 0,
        rearchitectCustomerOffshoreResources: 0,
        rearchitectAWSSrResources: 1,
        rearchitectAWSResources: 1,
        rearchitectAWSSrOffshoreResources: 0,
        rearchitectAWSOffshoreResources: 0,
        rearchitectPartnerSrResources: 1,
        rearchitectPartnerResources: 3,
        rearchitectPartnerSrOffshoreResources: 0,
        rearchitectPartnerOffshoreResources: 0
    },
    chinaMigrationToolsAndSchedule: {
        discoveryTool: 50,
        migrationTool: 0,
        trainingCost: 750,
        countOfResourcesToTrain: 0,
        projectDurationWeeks: '104',
        sprintDuration: 2,
        workingHoursPerWeek: 40,
        managementWorkingHoursPerWeek: 10,
        otherCosts: 0,
        customerLocation: 'china'
    },
    chinaDatabaseSprintTeamComposition: {
        retainPartnerOffshoreResources: 0,
        retireCustomerSrResources: 1,
        retireCustomerResources: 0,
        retireCustomerSrOffshoreResources: 0,
        retireCustomerOffshoreResources: 0,
        retireAWSSrResources: 0,
        retireAWSResources: 0,
        retireAWSSrOffshoreResources: 0,
        retireAWSOffshoreResources: 0,
        retirePartnerSrResources: 0,
        retirePartnerResources: 0,
        retirePartnerSrOffshoreResources: 0,
        retirePartnerOffshoreResources: 0,
        retainCustomerSrResources: 1,
        retainCustomerResources: 0,
        retainCustomerSrOffshoreResources: 0,
        retainCustomerOffshoreResources: 0,
        retainAWSSrResources: 0,
        retainAWSResources: 0,
        retainAWSSrOffshoreResources: 0,
        retainAWSOffshoreResources: 0,
        retainPartnerSrResources: 1,
        retainPartnerResources: 0,
        retainPartnerSrOffshoreResources: 0,
        relocateCustomerSrResources: 1,
        relocateCustomerResources: 0,
        relocateCustomerSrOffshoreResources: 0,
        relocateCustomerOffshoreResources: 0,
        relocateAWSSrResources: 1,
        relocateAWSResources: 0,
        relocateAWSSrOffshoreResources: 0,
        relocateAWSOffshoreResources: 0,
        relocatePartnerSrResources: 3,
        relocatePartnerResources: 0,
        relocatePartnerSrOffshoreResources: 0,
        relocatePartnerOffshoreResources: 0,
        repurchaseCustomerSrResources: 1,
        repurchaseCustomerResources: 1,
        repurchaseCustomerSrOffshoreResources: 0,
        repurchaseCustomerOffshoreResources: 0,
        repurchaseAWSSrResources: 1,
        repurchaseAWSResources: 0,
        repurchaseAWSSrOffshoreResources: 0,
        repurchaseAWSOffshoreResources: 0,
        repurchasePartnerSrResources: 0,
        repurchasePartnerResources: 2,
        repurchasePartnerSrOffshoreResources: 0,
        repurchasePartnerOffshoreResources: 0,
        rehostCustomerSrResources: 1,
        rehostCustomerResources: 0,
        rehostCustomerSrOffshoreResources: 0,
        rehostCustomerOffshoreResources: 0,
        rehostAWSSrResources: 1,
        rehostAWSResources: 1,
        rehostAWSSrOffshoreResources: 0,
        rehostAWSOffshoreResources: 0,
        rehostPartnerSrResources: 1,
        rehostPartnerResources: 2,
        rehostPartnerSrOffshoreResources: 0,
        rehostPartnerOffshoreResources: 0,
        replatformCustomerSrResources: 1,
        replatformCustomerResources: 1,
        replatformCustomerSrOffshoreResources: 0,
        replatformCustomerOffshoreResources: 0,
        replatformAWSSrResources: 1,
        replatformAWSResources: 1,
        replatformAWSSrOffshoreResources: 0,
        replatformAWSOffshoreResources: 0,
        replatformPartnerSrResources: 1,
        replatformPartnerResources: 2,
        replatformPartnerSrOffshoreResources: 0,
        replatformPartnerOffshoreResources: 0,
        rearchitectCustomerSrResources: 1,
        rearchitectCustomerResources: 2,
        rearchitectCustomerSrOffshoreResources: 0,
        rearchitectCustomerOffshoreResources: 0,
        rearchitectAWSSrResources: 1,
        rearchitectAWSResources: 1,
        rearchitectAWSSrOffshoreResources: 0,
        rearchitectAWSOffshoreResources: 0,
        rearchitectPartnerSrResources: 1,
        rearchitectPartnerResources: 3,
        rearchitectPartnerSrOffshoreResources: 0,
        rearchitectPartnerOffshoreResources: 0
    },
    emeaMigrationResourceCosts: {
        customerSeniorCost: 0,
        customerCost: 0,
        customerOffshoreCost: 0,
        customerSeniorOffshoreCost: 0,
        awsSeniorCost: 345,
        awsCost: 266,
        awsSeniorOffshoreCost: 175,
        awsOffshoreCost: 100,
        partnerSeniorCost: 205,
        partnerCost: 103,
        partnerOffshoreCost: 37,
        partnerSeniorOffshoreCost: 66
    },
    emeaMigrationSprintTeamComposition: {
        retainPartnerOffshoreResources: 0,
        retireCustomerSrResources: 1,
        retireCustomerResources: 0,
        retireCustomerSrOffshoreResources: 0,
        retireCustomerOffshoreResources: 0,
        retireAWSSrResources: 0,
        retireAWSResources: 0,
        retireAWSSrOffshoreResources: 0,
        retireAWSOffshoreResources: 0,
        retirePartnerSrResources: 0,
        retirePartnerResources: 0,
        retirePartnerSrOffshoreResources: 0,
        retirePartnerOffshoreResources: 0,
        retainCustomerSrResources: 1,
        retainCustomerResources: 0,
        retainCustomerSrOffshoreResources: 0,
        retainCustomerOffshoreResources: 0,
        retainAWSSrResources: 0,
        retainAWSResources: 0,
        retainAWSSrOffshoreResources: 0,
        retainAWSOffshoreResources: 0,
        retainPartnerSrResources: 1,
        retainPartnerResources: 0,
        retainPartnerSrOffshoreResources: 0,
        relocateCustomerSrResources: 1,
        relocateCustomerResources: 0,
        relocateCustomerSrOffshoreResources: 0,
        relocateCustomerOffshoreResources: 0,
        relocateAWSSrResources: 1,
        relocateAWSResources: 0,
        relocateAWSSrOffshoreResources: 0,
        relocateAWSOffshoreResources: 0,
        relocatePartnerSrResources: 3,
        relocatePartnerResources: 0,
        relocatePartnerSrOffshoreResources: 0,
        relocatePartnerOffshoreResources: 0,
        repurchaseCustomerSrResources: 2,
        repurchaseCustomerResources: 0,
        repurchaseCustomerSrOffshoreResources: 0,
        repurchaseCustomerOffshoreResources: 0,
        repurchaseAWSSrResources: 1,
        repurchaseAWSResources: 0,
        repurchaseAWSSrOffshoreResources: 0,
        repurchaseAWSOffshoreResources: 0,
        repurchasePartnerSrResources: 2,
        repurchasePartnerResources: 0,
        repurchasePartnerSrOffshoreResources: 0,
        repurchasePartnerOffshoreResources: 0,
        rehostCustomerSrResources: 1,
        rehostCustomerResources: 0,
        rehostCustomerSrOffshoreResources: 0,
        rehostCustomerOffshoreResources: 0,
        rehostAWSSrResources: 1,
        rehostAWSResources: 0,
        rehostAWSSrOffshoreResources: 0,
        rehostAWSOffshoreResources: 0,
        rehostPartnerSrResources: 3,
        rehostPartnerResources: 0,
        rehostPartnerSrOffshoreResources: 0,
        rehostPartnerOffshoreResources: 0,
        replatformCustomerSrResources: 2,
        replatformCustomerResources: 0,
        replatformCustomerSrOffshoreResources: 0,
        replatformCustomerOffshoreResources: 0,
        replatformAWSSrResources: 1,
        replatformAWSResources: 0,
        replatformAWSSrOffshoreResources: 0,
        replatformAWSOffshoreResources: 0,
        replatformPartnerSrResources: 3,
        replatformPartnerResources: 0,
        replatformPartnerSrOffshoreResources: 0,
        replatformPartnerOffshoreResources: 0,
        rearchitectCustomerSrResources: 3,
        rearchitectCustomerResources: 0,
        rearchitectCustomerSrOffshoreResources: 0,
        rearchitectCustomerOffshoreResources: 0,
        rearchitectAWSSrResources: 1,
        rearchitectAWSResources: 0,
        rearchitectAWSSrOffshoreResources: 0,
        rearchitectAWSOffshoreResources: 0,
        rearchitectPartnerSrResources: 4,
        rearchitectPartnerResources: 0,
        rearchitectPartnerSrOffshoreResources: 0,
        rearchitectPartnerOffshoreResources: 0
    },
    emeaMigrationToolsAndSchedule: {
        discoveryTool: 50,
        migrationTool: 0,
        trainingCost: 2925,
        countOfResourcesToTrain: 0,
        projectDurationWeeks: '104',
        sprintDuration: 2,
        workingHoursPerWeek: 40,
        managementWorkingHoursPerWeek: 10,
        otherCosts: 0,
        customerLocation: 'emea'
    },
    emeaDatabaseSprintTeamComposition: {
        retainPartnerOffshoreResources: 0,
        retireCustomerSrResources: 1,
        retireCustomerResources: 0,
        retireCustomerSrOffshoreResources: 0,
        retireCustomerOffshoreResources: 0,
        retireAWSSrResources: 0,
        retireAWSResources: 0,
        retireAWSSrOffshoreResources: 0,
        retireAWSOffshoreResources: 0,
        retirePartnerSrResources: 0,
        retirePartnerResources: 0,
        retirePartnerSrOffshoreResources: 0,
        retirePartnerOffshoreResources: 0,
        retainCustomerSrResources: 1,
        retainCustomerResources: 0,
        retainCustomerSrOffshoreResources: 0,
        retainCustomerOffshoreResources: 0,
        retainAWSSrResources: 0,
        retainAWSResources: 0,
        retainAWSSrOffshoreResources: 0,
        retainAWSOffshoreResources: 0,
        retainPartnerSrResources: 1,
        retainPartnerResources: 0,
        retainPartnerSrOffshoreResources: 0,
        relocateCustomerSrResources: 1,
        relocateCustomerResources: 0,
        relocateCustomerSrOffshoreResources: 0,
        relocateCustomerOffshoreResources: 0,
        relocateAWSSrResources: 1,
        relocateAWSResources: 0,
        relocateAWSSrOffshoreResources: 0,
        relocateAWSOffshoreResources: 0,
        relocatePartnerSrResources: 3,
        relocatePartnerResources: 0,
        relocatePartnerSrOffshoreResources: 0,
        relocatePartnerOffshoreResources: 0,
        repurchaseCustomerSrResources: 2,
        repurchaseCustomerResources: 0,
        repurchaseCustomerSrOffshoreResources: 0,
        repurchaseCustomerOffshoreResources: 0,
        repurchaseAWSSrResources: 1,
        repurchaseAWSResources: 0,
        repurchaseAWSSrOffshoreResources: 0,
        repurchaseAWSOffshoreResources: 0,
        repurchasePartnerSrResources: 2,
        repurchasePartnerResources: 0,
        repurchasePartnerSrOffshoreResources: 0,
        repurchasePartnerOffshoreResources: 0,
        rehostCustomerSrResources: 1,
        rehostCustomerResources: 0,
        rehostCustomerSrOffshoreResources: 0,
        rehostCustomerOffshoreResources: 0,
        rehostAWSSrResources: 1,
        rehostAWSResources: 0,
        rehostAWSSrOffshoreResources: 0,
        rehostAWSOffshoreResources: 0,
        rehostPartnerSrResources: 3,
        rehostPartnerResources: 0,
        rehostPartnerSrOffshoreResources: 0,
        rehostPartnerOffshoreResources: 0,
        replatformCustomerSrResources: 2,
        replatformCustomerResources: 0,
        replatformCustomerSrOffshoreResources: 0,
        replatformCustomerOffshoreResources: 0,
        replatformAWSSrResources: 1,
        replatformAWSResources: 0,
        replatformAWSSrOffshoreResources: 0,
        replatformAWSOffshoreResources: 0,
        replatformPartnerSrResources: 3,
        replatformPartnerResources: 0,
        replatformPartnerSrOffshoreResources: 0,
        replatformPartnerOffshoreResources: 0,
        rearchitectCustomerSrResources: 3,
        rearchitectCustomerResources: 0,
        rearchitectCustomerSrOffshoreResources: 0,
        rearchitectCustomerOffshoreResources: 0,
        rearchitectAWSSrResources: 1,
        rearchitectAWSResources: 0,
        rearchitectAWSSrOffshoreResources: 0,
        rearchitectAWSOffshoreResources: 0,
        rearchitectPartnerSrResources: 4,
        rearchitectPartnerResources: 0,
        rearchitectPartnerSrOffshoreResources: 0,
        rearchitectPartnerOffshoreResources: 0
    },
    japnMigrationResourceCosts: {
        customerSeniorCost: 0,
        customerCost: 0,
        customerOffshoreCost: 0,
        customerSeniorOffshoreCost: 0,
        awsSeniorCost: 320,
        awsCost: 245,
        awsSeniorOffshoreCost: 175,
        awsOffshoreCost: 100,
        partnerSeniorCost: 200,
        partnerCost: 200,
        partnerOffshoreCost: 200,
        partnerSeniorOffshoreCost: 200
    },
    japnMigrationSprintTeamComposition: {
        retainPartnerOffshoreResources: 0,
        retireCustomerSrResources: 1,
        retireCustomerResources: 0,
        retireCustomerSrOffshoreResources: 0,
        retireCustomerOffshoreResources: 0,
        retireAWSSrResources: 0,
        retireAWSResources: 0,
        retireAWSSrOffshoreResources: 0,
        retireAWSOffshoreResources: 0,
        retirePartnerSrResources: 0,
        retirePartnerResources: 0,
        retirePartnerSrOffshoreResources: 0,
        retirePartnerOffshoreResources: 0,
        retainCustomerSrResources: 1,
        retainCustomerResources: 0,
        retainCustomerSrOffshoreResources: 0,
        retainCustomerOffshoreResources: 0,
        retainAWSSrResources: 0,
        retainAWSResources: 0,
        retainAWSSrOffshoreResources: 0,
        retainAWSOffshoreResources: 0,
        retainPartnerSrResources: 1,
        retainPartnerResources: 0,
        retainPartnerSrOffshoreResources: 0,
        relocateCustomerSrResources: 1,
        relocateCustomerResources: 0,
        relocateCustomerSrOffshoreResources: 0,
        relocateCustomerOffshoreResources: 0,
        relocateAWSSrResources: 1,
        relocateAWSResources: 0,
        relocateAWSSrOffshoreResources: 0,
        relocateAWSOffshoreResources: 0,
        relocatePartnerSrResources: 3,
        relocatePartnerResources: 0,
        relocatePartnerSrOffshoreResources: 0,
        relocatePartnerOffshoreResources: 0,
        repurchaseCustomerSrResources: 2,
        repurchaseCustomerResources: 0,
        repurchaseCustomerSrOffshoreResources: 0,
        repurchaseCustomerOffshoreResources: 0,
        repurchaseAWSSrResources: 1,
        repurchaseAWSResources: 0,
        repurchaseAWSSrOffshoreResources: 0,
        repurchaseAWSOffshoreResources: 0,
        repurchasePartnerSrResources: 2,
        repurchasePartnerResources: 0,
        repurchasePartnerSrOffshoreResources: 0,
        repurchasePartnerOffshoreResources: 0,
        rehostCustomerSrResources: 1,
        rehostCustomerResources: 0,
        rehostCustomerSrOffshoreResources: 0,
        rehostCustomerOffshoreResources: 0,
        rehostAWSSrResources: 1,
        rehostAWSResources: 0,
        rehostAWSSrOffshoreResources: 0,
        rehostAWSOffshoreResources: 0,
        rehostPartnerSrResources: 3,
        rehostPartnerResources: 0,
        rehostPartnerSrOffshoreResources: 0,
        rehostPartnerOffshoreResources: 0,
        replatformCustomerSrResources: 2,
        replatformCustomerResources: 0,
        replatformCustomerSrOffshoreResources: 0,
        replatformCustomerOffshoreResources: 0,
        replatformAWSSrResources: 1,
        replatformAWSResources: 0,
        replatformAWSSrOffshoreResources: 0,
        replatformAWSOffshoreResources: 0,
        replatformPartnerSrResources: 3,
        replatformPartnerResources: 0,
        replatformPartnerSrOffshoreResources: 0,
        replatformPartnerOffshoreResources: 0,
        rearchitectCustomerSrResources: 3,
        rearchitectCustomerResources: 0,
        rearchitectCustomerSrOffshoreResources: 0,
        rearchitectCustomerOffshoreResources: 0,
        rearchitectAWSSrResources: 1,
        rearchitectAWSResources: 0,
        rearchitectAWSSrOffshoreResources: 0,
        rearchitectAWSOffshoreResources: 0,
        rearchitectPartnerSrResources: 4,
        rearchitectPartnerResources: 0,
        rearchitectPartnerSrOffshoreResources: 0,
        rearchitectPartnerOffshoreResources: 0
    },
    japnMigrationToolsAndSchedule: {
        discoveryTool: 50,
        migrationTool: 0,
        trainingCost: 2500,
        countOfResourcesToTrain: 0,
        projectDurationWeeks: '104',
        sprintDuration: 2,
        workingHoursPerWeek: 40,
        managementWorkingHoursPerWeek: 10,
        otherCosts: 0,
        customerLocation: 'japn'
    },
    japnDatabaseSprintTeamComposition: {
        retainPartnerOffshoreResources: 0,
        retireCustomerSrResources: 1,
        retireCustomerResources: 0,
        retireCustomerSrOffshoreResources: 0,
        retireCustomerOffshoreResources: 0,
        retireAWSSrResources: 0,
        retireAWSResources: 0,
        retireAWSSrOffshoreResources: 0,
        retireAWSOffshoreResources: 0,
        retirePartnerSrResources: 0,
        retirePartnerResources: 0,
        retirePartnerSrOffshoreResources: 0,
        retirePartnerOffshoreResources: 0,
        retainCustomerSrResources: 1,
        retainCustomerResources: 0,
        retainCustomerSrOffshoreResources: 0,
        retainCustomerOffshoreResources: 0,
        retainAWSSrResources: 0,
        retainAWSResources: 0,
        retainAWSSrOffshoreResources: 0,
        retainAWSOffshoreResources: 0,
        retainPartnerSrResources: 1,
        retainPartnerResources: 0,
        retainPartnerSrOffshoreResources: 0,
        relocateCustomerSrResources: 1,
        relocateCustomerResources: 0,
        relocateCustomerSrOffshoreResources: 0,
        relocateCustomerOffshoreResources: 0,
        relocateAWSSrResources: 1,
        relocateAWSResources: 0,
        relocateAWSSrOffshoreResources: 0,
        relocateAWSOffshoreResources: 0,
        relocatePartnerSrResources: 3,
        relocatePartnerResources: 0,
        relocatePartnerSrOffshoreResources: 0,
        relocatePartnerOffshoreResources: 0,
        repurchaseCustomerSrResources: 2,
        repurchaseCustomerResources: 0,
        repurchaseCustomerSrOffshoreResources: 0,
        repurchaseCustomerOffshoreResources: 0,
        repurchaseAWSSrResources: 1,
        repurchaseAWSResources: 0,
        repurchaseAWSSrOffshoreResources: 0,
        repurchaseAWSOffshoreResources: 0,
        repurchasePartnerSrResources: 2,
        repurchasePartnerResources: 0,
        repurchasePartnerSrOffshoreResources: 0,
        repurchasePartnerOffshoreResources: 0,
        rehostCustomerSrResources: 1,
        rehostCustomerResources: 0,
        rehostCustomerSrOffshoreResources: 0,
        rehostCustomerOffshoreResources: 0,
        rehostAWSSrResources: 1,
        rehostAWSResources: 0,
        rehostAWSSrOffshoreResources: 0,
        rehostAWSOffshoreResources: 0,
        rehostPartnerSrResources: 3,
        rehostPartnerResources: 0,
        rehostPartnerSrOffshoreResources: 0,
        rehostPartnerOffshoreResources: 0,
        replatformCustomerSrResources: 2,
        replatformCustomerResources: 0,
        replatformCustomerSrOffshoreResources: 0,
        replatformCustomerOffshoreResources: 0,
        replatformAWSSrResources: 1,
        replatformAWSResources: 0,
        replatformAWSSrOffshoreResources: 0,
        replatformAWSOffshoreResources: 0,
        replatformPartnerSrResources: 3,
        replatformPartnerResources: 0,
        replatformPartnerSrOffshoreResources: 0,
        replatformPartnerOffshoreResources: 0,
        rearchitectCustomerSrResources: 3,
        rearchitectCustomerResources: 0,
        rearchitectCustomerSrOffshoreResources: 0,
        rearchitectCustomerOffshoreResources: 0,
        rearchitectAWSSrResources: 1,
        rearchitectAWSResources: 0,
        rearchitectAWSSrOffshoreResources: 0,
        rearchitectAWSOffshoreResources: 0,
        rearchitectPartnerSrResources: 4,
        rearchitectPartnerResources: 0,
        rearchitectPartnerSrOffshoreResources: 0,
        rearchitectPartnerOffshoreResources: 0
    },
    amerMigrationResourceCosts: {
        customerSeniorCost: 0,
        customerCost: 0,
        customerOffshoreCost: 0,
        customerSeniorOffshoreCost: 0,
        awsSeniorCost: 345,
        awsCost: 260,
        awsSeniorOffshoreCost: 175,
        awsOffshoreCost: 100,
        partnerSeniorCost: 200,
        partnerCost: 200,
        partnerOffshoreCost: 200,
        partnerSeniorOffshoreCost: 200
    },
    amerMigrationSprintTeamComposition: {
        retainPartnerOffshoreResources: 0,
        retireCustomerSrResources: 1,
        retireCustomerResources: 0,
        retireCustomerSrOffshoreResources: 0,
        retireCustomerOffshoreResources: 0,
        retireAWSSrResources: 0,
        retireAWSResources: 0,
        retireAWSSrOffshoreResources: 0,
        retireAWSOffshoreResources: 0,
        retirePartnerSrResources: 0,
        retirePartnerResources: 0,
        retirePartnerSrOffshoreResources: 0,
        retirePartnerOffshoreResources: 0,
        retainCustomerSrResources: 1,
        retainCustomerResources: 0,
        retainCustomerSrOffshoreResources: 0,
        retainCustomerOffshoreResources: 0,
        retainAWSSrResources: 0,
        retainAWSResources: 0,
        retainAWSSrOffshoreResources: 0,
        retainAWSOffshoreResources: 0,
        retainPartnerSrResources: 1,
        retainPartnerResources: 0,
        retainPartnerSrOffshoreResources: 0,
        relocateCustomerSrResources: 1,
        relocateCustomerResources: 0,
        relocateCustomerSrOffshoreResources: 0,
        relocateCustomerOffshoreResources: 0,
        relocateAWSSrResources: 1,
        relocateAWSResources: 0,
        relocateAWSSrOffshoreResources: 0,
        relocateAWSOffshoreResources: 0,
        relocatePartnerSrResources: 3,
        relocatePartnerResources: 0,
        relocatePartnerSrOffshoreResources: 0,
        relocatePartnerOffshoreResources: 0,
        repurchaseCustomerSrResources: 2,
        repurchaseCustomerResources: 0,
        repurchaseCustomerSrOffshoreResources: 0,
        repurchaseCustomerOffshoreResources: 0,
        repurchaseAWSSrResources: 1,
        repurchaseAWSResources: 0,
        repurchaseAWSSrOffshoreResources: 0,
        repurchaseAWSOffshoreResources: 0,
        repurchasePartnerSrResources: 2,
        repurchasePartnerResources: 0,
        repurchasePartnerSrOffshoreResources: 0,
        repurchasePartnerOffshoreResources: 0,
        rehostCustomerSrResources: 1,
        rehostCustomerResources: 0,
        rehostCustomerSrOffshoreResources: 0,
        rehostCustomerOffshoreResources: 0,
        rehostAWSSrResources: 1,
        rehostAWSResources: 0,
        rehostAWSSrOffshoreResources: 0,
        rehostAWSOffshoreResources: 0,
        rehostPartnerSrResources: 3,
        rehostPartnerResources: 0,
        rehostPartnerSrOffshoreResources: 0,
        rehostPartnerOffshoreResources: 0,
        replatformCustomerSrResources: 2,
        replatformCustomerResources: 0,
        replatformCustomerSrOffshoreResources: 0,
        replatformCustomerOffshoreResources: 0,
        replatformAWSSrResources: 1,
        replatformAWSResources: 0,
        replatformAWSSrOffshoreResources: 0,
        replatformAWSOffshoreResources: 0,
        replatformPartnerSrResources: 3,
        replatformPartnerResources: 0,
        replatformPartnerSrOffshoreResources: 0,
        replatformPartnerOffshoreResources: 0,
        rearchitectCustomerSrResources: 3,
        rearchitectCustomerResources: 0,
        rearchitectCustomerSrOffshoreResources: 0,
        rearchitectCustomerOffshoreResources: 0,
        rearchitectAWSSrResources: 1,
        rearchitectAWSResources: 0,
        rearchitectAWSSrOffshoreResources: 0,
        rearchitectAWSOffshoreResources: 0,
        rearchitectPartnerSrResources: 4,
        rearchitectPartnerResources: 0,
        rearchitectPartnerSrOffshoreResources: 0,
        rearchitectPartnerOffshoreResources: 0
    },
    amerMigrationToolsAndSchedule: {
        discoveryTool: 50,
        migrationTool: 0,
        trainingCost: 2500,
        countOfResourcesToTrain: 0,
        projectDurationWeeks: '104',
        sprintDuration: 2,
        workingHoursPerWeek: 40,
        managementWorkingHoursPerWeek: 10,
        otherCosts: 0,
        customerLocation: 'amer'
    },
    amerDatabaseSprintTeamComposition: {
        retainPartnerOffshoreResources: 0,
        retireCustomerSrResources: 1,
        retireCustomerResources: 0,
        retireCustomerSrOffshoreResources: 0,
        retireCustomerOffshoreResources: 0,
        retireAWSSrResources: 0,
        retireAWSResources: 0,
        retireAWSSrOffshoreResources: 0,
        retireAWSOffshoreResources: 0,
        retirePartnerSrResources: 0,
        retirePartnerResources: 0,
        retirePartnerSrOffshoreResources: 0,
        retirePartnerOffshoreResources: 0,
        retainCustomerSrResources: 1,
        retainCustomerResources: 0,
        retainCustomerSrOffshoreResources: 0,
        retainCustomerOffshoreResources: 0,
        retainAWSSrResources: 0,
        retainAWSResources: 0,
        retainAWSSrOffshoreResources: 0,
        retainAWSOffshoreResources: 0,
        retainPartnerSrResources: 1,
        retainPartnerResources: 0,
        retainPartnerSrOffshoreResources: 0,
        relocateCustomerSrResources: 1,
        relocateCustomerResources: 0,
        relocateCustomerSrOffshoreResources: 0,
        relocateCustomerOffshoreResources: 0,
        relocateAWSSrResources: 1,
        relocateAWSResources: 0,
        relocateAWSSrOffshoreResources: 0,
        relocateAWSOffshoreResources: 0,
        relocatePartnerSrResources: 3,
        relocatePartnerResources: 0,
        relocatePartnerSrOffshoreResources: 0,
        relocatePartnerOffshoreResources: 0,
        repurchaseCustomerSrResources: 2,
        repurchaseCustomerResources: 0,
        repurchaseCustomerSrOffshoreResources: 0,
        repurchaseCustomerOffshoreResources: 0,
        repurchaseAWSSrResources: 1,
        repurchaseAWSResources: 0,
        repurchaseAWSSrOffshoreResources: 0,
        repurchaseAWSOffshoreResources: 0,
        repurchasePartnerSrResources: 2,
        repurchasePartnerResources: 0,
        repurchasePartnerSrOffshoreResources: 0,
        repurchasePartnerOffshoreResources: 0,
        rehostCustomerSrResources: 1,
        rehostCustomerResources: 0,
        rehostCustomerSrOffshoreResources: 0,
        rehostCustomerOffshoreResources: 0,
        rehostAWSSrResources: 1,
        rehostAWSResources: 0,
        rehostAWSSrOffshoreResources: 0,
        rehostAWSOffshoreResources: 0,
        rehostPartnerSrResources: 3,
        rehostPartnerResources: 0,
        rehostPartnerSrOffshoreResources: 0,
        rehostPartnerOffshoreResources: 0,
        replatformCustomerSrResources: 2,
        replatformCustomerResources: 0,
        replatformCustomerSrOffshoreResources: 0,
        replatformCustomerOffshoreResources: 0,
        replatformAWSSrResources: 1,
        replatformAWSResources: 0,
        replatformAWSSrOffshoreResources: 0,
        replatformAWSOffshoreResources: 0,
        replatformPartnerSrResources: 3,
        replatformPartnerResources: 0,
        replatformPartnerSrOffshoreResources: 0,
        replatformPartnerOffshoreResources: 0,
        rearchitectCustomerSrResources: 3,
        rearchitectCustomerResources: 0,
        rearchitectCustomerSrOffshoreResources: 0,
        rearchitectCustomerOffshoreResources: 0,
        rearchitectAWSSrResources: 1,
        rearchitectAWSResources: 0,
        rearchitectAWSSrOffshoreResources: 0,
        rearchitectAWSOffshoreResources: 0,
        rearchitectPartnerSrResources: 4,
        rearchitectPartnerResources: 0,
        rearchitectPartnerSrOffshoreResources: 0,
        rearchitectPartnerOffshoreResources: 0
    },
    latamMigrationResourceCosts: {
        customerSeniorCost: 0,
        customerCost: 0,
        customerOffshoreCost: 0,
        customerSeniorOffshoreCost: 0,
        awsSeniorCost: 300,
        awsCost: 250,
        awsSeniorOffshoreCost: 175,
        awsOffshoreCost: 100,
        partnerSeniorCost: 120,
        partnerCost: 90,
        partnerOffshoreCost: 200,
        partnerSeniorOffshoreCost: 200
    },
    latamMigrationSprintTeamComposition: {
        retainPartnerOffshoreResources: 0,
        retireCustomerSrResources: 1,
        retireCustomerResources: 0,
        retireCustomerSrOffshoreResources: 0,
        retireCustomerOffshoreResources: 0,
        retireAWSSrResources: 0,
        retireAWSResources: 0,
        retireAWSSrOffshoreResources: 0,
        retireAWSOffshoreResources: 0,
        retirePartnerSrResources: 0,
        retirePartnerResources: 0,
        retirePartnerSrOffshoreResources: 0,
        retirePartnerOffshoreResources: 0,
        retainCustomerSrResources: 1,
        retainCustomerResources: 0,
        retainCustomerSrOffshoreResources: 0,
        retainCustomerOffshoreResources: 0,
        retainAWSSrResources: 0,
        retainAWSResources: 0,
        retainAWSSrOffshoreResources: 0,
        retainAWSOffshoreResources: 0,
        retainPartnerSrResources: 1,
        retainPartnerResources: 0,
        retainPartnerSrOffshoreResources: 0,
        relocateCustomerSrResources: 1,
        relocateCustomerResources: 0,
        relocateCustomerSrOffshoreResources: 0,
        relocateCustomerOffshoreResources: 0,
        relocateAWSSrResources: 1,
        relocateAWSResources: 0,
        relocateAWSSrOffshoreResources: 0,
        relocateAWSOffshoreResources: 0,
        relocatePartnerSrResources: 3,
        relocatePartnerResources: 0,
        relocatePartnerSrOffshoreResources: 0,
        relocatePartnerOffshoreResources: 0,
        repurchaseCustomerSrResources: 2,
        repurchaseCustomerResources: 0,
        repurchaseCustomerSrOffshoreResources: 0,
        repurchaseCustomerOffshoreResources: 0,
        repurchaseAWSSrResources: 1,
        repurchaseAWSResources: 0,
        repurchaseAWSSrOffshoreResources: 0,
        repurchaseAWSOffshoreResources: 0,
        repurchasePartnerSrResources: 2,
        repurchasePartnerResources: 0,
        repurchasePartnerSrOffshoreResources: 0,
        repurchasePartnerOffshoreResources: 0,
        rehostCustomerSrResources: 1,
        rehostCustomerResources: 0,
        rehostCustomerSrOffshoreResources: 0,
        rehostCustomerOffshoreResources: 0,
        rehostAWSSrResources: 1,
        rehostAWSResources: 0,
        rehostAWSSrOffshoreResources: 0,
        rehostAWSOffshoreResources: 0,
        rehostPartnerSrResources: 3,
        rehostPartnerResources: 0,
        rehostPartnerSrOffshoreResources: 0,
        rehostPartnerOffshoreResources: 0,
        replatformCustomerSrResources: 2,
        replatformCustomerResources: 0,
        replatformCustomerSrOffshoreResources: 0,
        replatformCustomerOffshoreResources: 0,
        replatformAWSSrResources: 1,
        replatformAWSResources: 0,
        replatformAWSSrOffshoreResources: 0,
        replatformAWSOffshoreResources: 0,
        replatformPartnerSrResources: 3,
        replatformPartnerResources: 0,
        replatformPartnerSrOffshoreResources: 0,
        replatformPartnerOffshoreResources: 0,
        rearchitectCustomerSrResources: 3,
        rearchitectCustomerResources: 0,
        rearchitectCustomerSrOffshoreResources: 0,
        rearchitectCustomerOffshoreResources: 0,
        rearchitectAWSSrResources: 1,
        rearchitectAWSResources: 0,
        rearchitectAWSSrOffshoreResources: 0,
        rearchitectAWSOffshoreResources: 0,
        rearchitectPartnerSrResources: 4,
        rearchitectPartnerResources: 0,
        rearchitectPartnerSrOffshoreResources: 0,
        rearchitectPartnerOffshoreResources: 0
    },
    latamMigrationToolsAndSchedule: {
        discoveryTool: 50,
        migrationTool: 0,
        trainingCost: 2500,
        countOfResourcesToTrain: 0,
        projectDurationWeeks: '104',
        sprintDuration: 2,
        workingHoursPerWeek: 40,
        managementWorkingHoursPerWeek: 10,
        otherCosts: 0,
        customerLocation: 'latam'
    },
    latamDatabaseSprintTeamComposition: {
        retainPartnerOffshoreResources: 0,
        retireCustomerSrResources: 1,
        retireCustomerResources: 0,
        retireCustomerSrOffshoreResources: 0,
        retireCustomerOffshoreResources: 0,
        retireAWSSrResources: 0,
        retireAWSResources: 0,
        retireAWSSrOffshoreResources: 0,
        retireAWSOffshoreResources: 0,
        retirePartnerSrResources: 0,
        retirePartnerResources: 0,
        retirePartnerSrOffshoreResources: 0,
        retirePartnerOffshoreResources: 0,
        retainCustomerSrResources: 1,
        retainCustomerResources: 0,
        retainCustomerSrOffshoreResources: 0,
        retainCustomerOffshoreResources: 0,
        retainAWSSrResources: 0,
        retainAWSResources: 0,
        retainAWSSrOffshoreResources: 0,
        retainAWSOffshoreResources: 0,
        retainPartnerSrResources: 1,
        retainPartnerResources: 0,
        retainPartnerSrOffshoreResources: 0,
        relocateCustomerSrResources: 1,
        relocateCustomerResources: 0,
        relocateCustomerSrOffshoreResources: 0,
        relocateCustomerOffshoreResources: 0,
        relocateAWSSrResources: 1,
        relocateAWSResources: 0,
        relocateAWSSrOffshoreResources: 0,
        relocateAWSOffshoreResources: 0,
        relocatePartnerSrResources: 3,
        relocatePartnerResources: 0,
        relocatePartnerSrOffshoreResources: 0,
        relocatePartnerOffshoreResources: 0,
        repurchaseCustomerSrResources: 2,
        repurchaseCustomerResources: 0,
        repurchaseCustomerSrOffshoreResources: 0,
        repurchaseCustomerOffshoreResources: 0,
        repurchaseAWSSrResources: 1,
        repurchaseAWSResources: 0,
        repurchaseAWSSrOffshoreResources: 0,
        repurchaseAWSOffshoreResources: 0,
        repurchasePartnerSrResources: 2,
        repurchasePartnerResources: 0,
        repurchasePartnerSrOffshoreResources: 0,
        repurchasePartnerOffshoreResources: 0,
        rehostCustomerSrResources: 1,
        rehostCustomerResources: 0,
        rehostCustomerSrOffshoreResources: 0,
        rehostCustomerOffshoreResources: 0,
        rehostAWSSrResources: 1,
        rehostAWSResources: 0,
        rehostAWSSrOffshoreResources: 0,
        rehostAWSOffshoreResources: 0,
        rehostPartnerSrResources: 3,
        rehostPartnerResources: 0,
        rehostPartnerSrOffshoreResources: 0,
        rehostPartnerOffshoreResources: 0,
        replatformCustomerSrResources: 2,
        replatformCustomerResources: 0,
        replatformCustomerSrOffshoreResources: 0,
        replatformCustomerOffshoreResources: 0,
        replatformAWSSrResources: 1,
        replatformAWSResources: 0,
        replatformAWSSrOffshoreResources: 0,
        replatformAWSOffshoreResources: 0,
        replatformPartnerSrResources: 3,
        replatformPartnerResources: 0,
        replatformPartnerSrOffshoreResources: 0,
        replatformPartnerOffshoreResources: 0,
        rearchitectCustomerSrResources: 3,
        rearchitectCustomerResources: 0,
        rearchitectCustomerSrOffshoreResources: 0,
        rearchitectCustomerOffshoreResources: 0,
        rearchitectAWSSrResources: 1,
        rearchitectAWSResources: 0,
        rearchitectAWSSrOffshoreResources: 0,
        rearchitectAWSOffshoreResources: 0,
        rearchitectPartnerSrResources: 4,
        rearchitectPartnerResources: 0,
        rearchitectPartnerSrOffshoreResources: 0,
        rearchitectPartnerOffshoreResources: 0
    },
    migrationResourceCosts: {
        customerSeniorCost: 0,
        customerCost: 0,
        customerOffshoreCost: 0,
        customerSeniorOffshoreCost: 0,
        awsSeniorCost: 345,
        awsCost: 260,
        awsSeniorOffshoreCost: 175,
        awsOffshoreCost: 100,
        partnerSeniorCost: 200,
        partnerCost: 200,
        partnerOffshoreCost: 200,
        partnerSeniorOffshoreCost: 200
    },
    migrationToolsAndSchedule: {
        discoveryTool: 50,
        migrationTool: 0,
        trainingCost: 2500,
        countOfResourcesToTrain: 0,
        projectDurationWeeks: '104',
        sprintDuration: 2,
        workingHoursPerWeek: 40,
        managementWorkingHoursPerWeek: 10,
        otherCosts: 0,
        customerLocation: 'amer'
    },
    migrationSprintTeamComposition: {
        retainPartnerOffshoreResources: 0,
        retireCustomerSrResources: 1,
        retireCustomerResources: 0,
        retireCustomerSrOffshoreResources: 0,
        retireCustomerOffshoreResources: 0,
        retireAWSSrResources: 0,
        retireAWSResources: 0,
        retireAWSSrOffshoreResources: 0,
        retireAWSOffshoreResources: 0,
        retirePartnerSrResources: 0,
        retirePartnerResources: 0,
        retirePartnerSrOffshoreResources: 0,
        retirePartnerOffshoreResources: 0,
        retainCustomerSrResources: 1,
        retainCustomerResources: 0,
        retainCustomerSrOffshoreResources: 0,
        retainCustomerOffshoreResources: 0,
        retainAWSSrResources: 0,
        retainAWSResources: 0,
        retainAWSSrOffshoreResources: 0,
        retainAWSOffshoreResources: 0,
        retainPartnerSrResources: 1,
        retainPartnerResources: 0,
        retainPartnerSrOffshoreResources: 0,
        relocateCustomerSrResources: 1,
        relocateCustomerResources: 0,
        relocateCustomerSrOffshoreResources: 0,
        relocateCustomerOffshoreResources: 0,
        relocateAWSSrResources: 1,
        relocateAWSResources: 0,
        relocateAWSSrOffshoreResources: 0,
        relocateAWSOffshoreResources: 0,
        relocatePartnerSrResources: 3,
        relocatePartnerResources: 0,
        relocatePartnerSrOffshoreResources: 0,
        relocatePartnerOffshoreResources: 0,
        repurchaseCustomerSrResources: 2,
        repurchaseCustomerResources: 0,
        repurchaseCustomerSrOffshoreResources: 0,
        repurchaseCustomerOffshoreResources: 0,
        repurchaseAWSSrResources: 1,
        repurchaseAWSResources: 0,
        repurchaseAWSSrOffshoreResources: 0,
        repurchaseAWSOffshoreResources: 0,
        repurchasePartnerSrResources: 2,
        repurchasePartnerResources: 0,
        repurchasePartnerSrOffshoreResources: 0,
        repurchasePartnerOffshoreResources: 0,
        rehostCustomerSrResources: 1,
        rehostCustomerResources: 0,
        rehostCustomerSrOffshoreResources: 0,
        rehostCustomerOffshoreResources: 0,
        rehostAWSSrResources: 1,
        rehostAWSResources: 0,
        rehostAWSSrOffshoreResources: 0,
        rehostAWSOffshoreResources: 0,
        rehostPartnerSrResources: 3,
        rehostPartnerResources: 0,
        rehostPartnerSrOffshoreResources: 0,
        rehostPartnerOffshoreResources: 0,
        replatformCustomerSrResources: 2,
        replatformCustomerResources: 0,
        replatformCustomerSrOffshoreResources: 0,
        replatformCustomerOffshoreResources: 0,
        replatformAWSSrResources: 1,
        replatformAWSResources: 0,
        replatformAWSSrOffshoreResources: 0,
        replatformAWSOffshoreResources: 0,
        replatformPartnerSrResources: 3,
        replatformPartnerResources: 0,
        replatformPartnerSrOffshoreResources: 0,
        replatformPartnerOffshoreResources: 0,
        rearchitectCustomerSrResources: 3,
        rearchitectCustomerResources: 0,
        rearchitectCustomerSrOffshoreResources: 0,
        rearchitectCustomerOffshoreResources: 0,
        rearchitectAWSSrResources: 1,
        rearchitectAWSResources: 0,
        rearchitectAWSSrOffshoreResources: 0,
        rearchitectAWSOffshoreResources: 0,
        rearchitectPartnerSrResources: 4,
        rearchitectPartnerResources: 0,
        rearchitectPartnerSrOffshoreResources: 0,
        rearchitectPartnerOffshoreResources: 0
    },
    databaseSprintTeamComposition: {
        retainPartnerOffshoreResources: 0,
        retireCustomerSrResources: 1,
        retireCustomerResources: 0,
        retireCustomerSrOffshoreResources: 0,
        retireCustomerOffshoreResources: 0,
        retireAWSSrResources: 0,
        retireAWSResources: 0,
        retireAWSSrOffshoreResources: 0,
        retireAWSOffshoreResources: 0,
        retirePartnerSrResources: 0,
        retirePartnerResources: 0,
        retirePartnerSrOffshoreResources: 0,
        retirePartnerOffshoreResources: 0,
        retainCustomerSrResources: 1,
        retainCustomerResources: 0,
        retainCustomerSrOffshoreResources: 0,
        retainCustomerOffshoreResources: 0,
        retainAWSSrResources: 0,
        retainAWSResources: 0,
        retainAWSSrOffshoreResources: 0,
        retainAWSOffshoreResources: 0,
        retainPartnerSrResources: 1,
        retainPartnerResources: 0,
        retainPartnerSrOffshoreResources: 0,
        relocateCustomerSrResources: 1,
        relocateCustomerResources: 0,
        relocateCustomerSrOffshoreResources: 0,
        relocateCustomerOffshoreResources: 0,
        relocateAWSSrResources: 1,
        relocateAWSResources: 0,
        relocateAWSSrOffshoreResources: 0,
        relocateAWSOffshoreResources: 0,
        relocatePartnerSrResources: 3,
        relocatePartnerResources: 0,
        relocatePartnerSrOffshoreResources: 0,
        relocatePartnerOffshoreResources: 0,
        repurchaseCustomerSrResources: 2,
        repurchaseCustomerResources: 0,
        repurchaseCustomerSrOffshoreResources: 0,
        repurchaseCustomerOffshoreResources: 0,
        repurchaseAWSSrResources: 1,
        repurchaseAWSResources: 0,
        repurchaseAWSSrOffshoreResources: 0,
        repurchaseAWSOffshoreResources: 0,
        repurchasePartnerSrResources: 2,
        repurchasePartnerResources: 0,
        repurchasePartnerSrOffshoreResources: 0,
        repurchasePartnerOffshoreResources: 0,
        rehostCustomerSrResources: 1,
        rehostCustomerResources: 0,
        rehostCustomerSrOffshoreResources: 0,
        rehostCustomerOffshoreResources: 0,
        rehostAWSSrResources: 1,
        rehostAWSResources: 0,
        rehostAWSSrOffshoreResources: 0,
        rehostAWSOffshoreResources: 0,
        rehostPartnerSrResources: 3,
        rehostPartnerResources: 0,
        rehostPartnerSrOffshoreResources: 0,
        rehostPartnerOffshoreResources: 0,
        replatformCustomerSrResources: 2,
        replatformCustomerResources: 0,
        replatformCustomerSrOffshoreResources: 0,
        replatformCustomerOffshoreResources: 0,
        replatformAWSSrResources: 1,
        replatformAWSResources: 0,
        replatformAWSSrOffshoreResources: 0,
        replatformAWSOffshoreResources: 0,
        replatformPartnerSrResources: 3,
        replatformPartnerResources: 0,
        replatformPartnerSrOffshoreResources: 0,
        replatformPartnerOffshoreResources: 0,
        rearchitectCustomerSrResources: 3,
        rearchitectCustomerResources: 0,
        rearchitectCustomerSrOffshoreResources: 0,
        rearchitectCustomerOffshoreResources: 0,
        rearchitectAWSSrResources: 1,
        rearchitectAWSResources: 0,
        rearchitectAWSSrOffshoreResources: 0,
        rearchitectAWSOffshoreResources: 0,
        rearchitectPartnerSrResources: 4,
        rearchitectPartnerResources: 0,
        rearchitectPartnerSrOffshoreResources: 0,
        rearchitectPartnerOffshoreResources: 0
    },
    migrationLevelOfEffort: {
        retire: 1,
        retain: 2,
        relocate: 3,
        repurchase: 6,
        rehost: 4,
        replatform: 12,
        rearchitect: 20
    },
    databaseMigrationEffort: {
        retire: 2,
        rehost: 8,
        replatform: 100,
        rearchitect: 240
    }
};

export const defaultDescription: DescriptionItem[] = [
    {
        'identifier': 'tcoAssumptions',
        'label': 'General',
        'type': 'object',
        'properties': [
            {
                'identifier': 'awsRegion',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'us-east-2',
                        'text': 'US East (Ohio)'
                    },
                    {
                        'value': 'us-east-1',
                        'text': 'US East (N. Virginia)'
                    },
                    {
                        'value': 'us-west-1',
                        'text': 'US West (N. California)'
                    },
                    {
                        'value': 'us-west-2',
                        'text': 'US West (Oregon)'
                    },
                    {
                        'value': 'af-south-1',
                        'text': 'Africa (Cape Town)'
                    },
                    {
                        'value': 'ap-east-1',
                        'text': 'Asia Pacific (Hong Kong)'
                    },
                    {
                        'value': 'ap-south-1',
                        'text': 'Asia Pacific (Mumbai)'
                    },
                    {
                        'value': 'ap-south-2',
                        'text': 'Asia Pacific (Hyderabad)'
                    },
                    {
                        'value': 'ap-northeast-3',
                        'text': 'Asia Pacific (Osaka)'
                    },
                    {
                        'value': 'ap-northeast-2',
                        'text': 'Asia Pacific (Seoul)'
                    },
                    {
                        'value': 'ap-southeast-1',
                        'text': 'Asia Pacific (Singapore)'
                    },
                    {
                        'value': 'ap-southeast-2',
                        'text': 'Asia Pacific (Sydney)'
                    },
                    {
                        'value': 'ap-southeast-3',
                        'text': 'Asia Pacific (Jakarta)',
                    },
                    {
                        'value': 'ap-southeast-4',
                        'text': 'Asia Pacific (Melbourne)',
                    },
                    {
                        'value': 'ap-northeast-1',
                        'text': 'Asia Pacific (Tokyo)'
                    },
                    {
                        'value': 'ca-central-1',
                        'text': 'Canada (Central)'
                    },
                    {
                        'value': 'cn-north-1',
                        'text': 'China (Beijing)'
                    },
                    {
                        'value': 'cn-northwest-1',
                        'text': 'China (Ningxia)'
                    },
                    {
                        'value': 'eu-central-1',
                        'text': 'Europe (Frankfurt)'
                    },
                    {
                        'value': 'eu-central-2',
                        'text': 'Europe (Zurich)'
                    },
                    {
                        'value': 'eu-west-1',
                        'text': 'Europe (Ireland)'
                    },
                    {
                        'value': 'eu-west-2',
                        'text': 'Europe (London)'
                    },
                    {
                        'value': 'eu-south-1',
                        'text': 'Europe (Milan)'
                    },
                    {
                        'value': 'eu-south-2',
                        'text': 'Europe (Spain)'
                    },
                    {
                        'value': 'eu-west-3',
                        'text': 'Europe (Paris)'
                    },
                    {
                        'value': 'eu-north-1',
                        'text': 'Europe (Stockholm)'
                    },
                    {
                        'value': 'me-south-1',
                        'text': 'Middle East (Bahrain)'
                    },
                    {
                        'value': 'me-central-1',
                        'text': 'Middle East (UAE)'
                    },
                    {
                        'value': 'sa-east-1',
                        'text': 'South America (São Paulo)'
                    },
                    {
                        'value': 'us-gov-east-1',
                        'text': 'AWS GovCloud (US-East)'
                    },
                    {
                        'value': 'us-gov-west-1',
                        'text': 'AWS GovCloud (US-West)'
                    }
                ],
                'defaultValue': 'us-east-1',
                'label': 'AWS Region',
                'description': 'Select AWS Region based on customer location and preference.',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'refreshmentDurationYears',
                'type': 'number',
                'defaultValue': 5,
                'label': 'Refreshment period (years)',
                'description': 'Average on-premises infrastructure refreshment period.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'durationYears',
                'type': 'number',
                'defaultValue': 5,
                'label': 'Analysis duration (years)',
                'description': 'Duration of TCO analysis. Duration should be less than refreshment period.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'onpremEnvironment',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'onprem',
                        'text': 'On-Premises'
                    },
                    {
                        'value': 'colo',
                        'text': 'Colocation'
                    }
                ],
                'defaultValue': 'onprem',
                'label': 'Environment type',
                'description': '',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'relocateOn',
                'type': 'boolean',
                'defaultValue': false,
                'label': 'Enable VMware Cloud on AWS (Relocate migration strategy)',
                'description': 'The Relocate Migration strategy (VMware Cloud on AWS) will be chosen for virtual servers with a supported hypervisor.',
                'uiHidden': false
            }
        ]
    },
    {
        'identifier': 'awsEC2RightSize',
        'label': 'AWS server recommendation',
        'type': 'object',
        'properties': [
            {
                'identifier': 'meridianExcludedInstanceTypes',
                'type': 'string',
                'defaultValue': '',
                'label': 'Do not recommend these EC2 instance types',
                'description': 'Comma separated list of EC2 instance families (t1, t3a) or types (t3a.micro); wildchars supported (ex: *a* excludes all '
                    + 'AMD instance families, *.micro excludes all micro instance types).',
                'validation': {
                    'min': 0,
                    'max': 5000
                }
            },
            {
                'identifier': 'awsCPUBuffer',
                'type': 'number',
                'defaultValue': 0,
                'label': 'CPU buffer (%)',
                'description': 'CPU buffer adds more compute capacity to peak/average utilization.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'awsRamBuffer',
                'type': 'number',
                'defaultValue': 0,
                'label': 'RAM buffer (%)',
                'description': 'RAM buffer adds more memory to peak/average utilization.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'awsAvgCpuUtilizationPct',
                'type': 'number',
                'defaultValue': 24,
                'label': 'Default average CPU utilization (%)',
                'description': 'Default value will be used whenever \'CPU-Average Utilization %\' is not mapped or has an invalid value.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'useAvgCpuUtilizationForAllServers',
                'type': 'boolean',
                'defaultValue': false,
                'label': 'Use the value above for average CPU utilization of all servers',
                'description': 'This value will be used for all servers and will override any value stored against the server.'
            },
            {
                'identifier': 'awsAvgRamUtilizationPct',
                'type': 'number',
                'defaultValue': 59,
                'label': 'Default average RAM utilization (%)',
                'description': 'Default value will be used whenever \'RAM-Average Utilization %\' is not mapped or has an invalid value.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'useAvgRamUtilizationForAllServers',
                'type': 'boolean',
                'defaultValue': false,
                'label': 'Use the value above for average RAM utilization of all servers',
                'description': 'This value will be used for all servers and will override any value stored against the server.'
            },
            {
                'identifier': 'awsPeakCpuUtilizationPct',
                'type': 'number',
                'defaultValue': 24,
                'label': 'Default peak CPU utilization (%)',
                'description': 'Default value will be used whenever \'CPU-Peak Utilization %\' is not mapped or has an invalid value.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'usePeakCpuUtilizationForAllServers',
                'type': 'boolean',
                'defaultValue': false,
                'label': 'Use the value above for peak CPU utilization of all servers',
                'description': 'This value will be used for all servers and will override any value stored against the server.'
            },
            {
                'identifier': 'awsPeakRamUtilizationPct',
                'type': 'number',
                'defaultValue': 59,
                'label': 'Default peak RAM utilization (%)',
                'description': 'Default value will be used whenever \'RAM-Peak Utilization %\' is not mapped or has an invalid value.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'usePeakRamUtilizationForAllServers',
                'type': 'boolean',
                'defaultValue': false,
                'label': 'Use the value above for peak RAM utilization of all servers',
                'description': 'This value will be used for all servers and will override any value stored against the server.'
            },
            {
                'identifier': 'awsThreadsPerCore',
                'type': 'number',
                'defaultValue': 1,
                'label': 'Default number of threads per CPU-Core',
                'description': 'Default value will be used whenever \'CPU-Number of Threads per CPU-Core\' is not mapped or has an invalid value.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 1
                }
            },
            {
                'identifier': 'useThreadsPerCoreForAllServers',
                'type': 'boolean',
                'defaultValue': false,
                'label': 'Use the value above as the \'CPU-Number of Threads per CPU-Core\' for all servers',
                'description': 'This value will be used for all servers and will override any value stored against the server.'
            },
            {
                'identifier': 'physicalToEC2Factor',
                'type': 'boolean',
                'defaultValue': true,
                'label': 'Physical to EC2 instance factor',
                'description': 'When set, the physical cores are considered 2x as powerful than the cores of EC2 instances.'
            }
        ]
    },
    {
        'identifier': 'awsEC2Pricing',
        'label': 'AWS server cost',
        'type': 'object',
        'properties': [
            {
                'identifier': 'awsRightSizePolicy',
                'type': 'enum',
                'enum': [
                    {
                        'value': '504',
                        'text': 'On-Premises capacity'
                    },
                    {
                        'value': '502',
                        'text': 'Average utilization'
                    },
                    {
                        'value': '503',
                        'text': 'Peak utilization'
                    }
                ],
                'defaultValue': '503',
                'label': 'Server recommendation',
                'description': 'Select server recommendation type for EC2 pricing.',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'awsEC2Tenancy',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'Shared',
                        'text': 'Shared'
                    },
                    {
                        'value': 'Dedicated',
                        'text': 'Dedicated Instance'
                    },
                    {
                        'value': 'Dedicated Host',
                        'text': 'Dedicated Host'
                    }
                ],
                'defaultValue': 'Shared',
                'label': 'Default tenancy',
                'description': 'Default value will be used whenever the \'Tenancy\' of the server is not mapped or has an invalid value.',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'awsServerUptime',
                'type': 'number',
                'defaultValue': 100,
                'label': 'Default production server usage (uptime) %',
                'description': 'Default value will be used whenever \'Server Usage %\' is not mapped or has an invalid value for a production server.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'awsNonProductionServerUptime',
                'type': 'number',
                'defaultValue': 24,
                'label': 'Default non-production server usage (uptime) %',
                'description': 'Default value will be used whenever \'Server Usage %\' is not mapped or has an invalid value for a non-production server.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'awsEC2PaymentTypes',
                'label': 'Desired EC2 payment types',
                'type': 'multiValueEnum',
                'selections': [
                    {
                        'value': 'onDemand',
                        'text': 'On-Demand',
                        'uiDisabled': true
                    },
                    {
                        'value': 'std1Nu',
                        'text': 'Standard 1-Year No Upfront',
                        'uiDisabled': false
                    },
                    {
                        'value': 'std1Pu',
                        'text': 'Standard 1-Year Partial Upfront',
                        'uiDisabled': false
                    },
                    {
                        'value': 'std1Au',
                        'text': 'Standard 1-Year All Upfront',
                        'uiDisabled': false
                    },
                    {
                        'value': 'con1Nu',
                        'text': 'Convertible 1-Year No Upfront',
                        'uiDisabled': false
                    },
                    {
                        'value': 'con1Pu',
                        'text': 'Convertible 1-Year Partial Upfront',
                        'uiDisabled': false
                    },
                    {
                        'value': 'con1Au',
                        'text': 'Convertible 1-Year All Upfront',
                        'uiDisabled': false
                    },
                    {
                        'value': 'std3Nu',
                        'text': 'Standard 3-Year No Upfront',
                        'uiDisabled': false
                    },
                    {
                        'value': 'std3Pu',
                        'text': 'Standard 3-Year Partial Upfront',
                        'uiDisabled': false
                    },
                    {
                        'value': 'std3Au',
                        'text': 'Standard 3-Year All Upfront',
                        'uiDisabled': false
                    },
                    {
                        'value': 'con3Nu',
                        'text': 'Convertible 3-Year No Upfront',
                        'uiDisabled': false
                    },
                    {
                        'value': 'con3Pu',
                        'text': 'Convertible 3-Year Partial Upfront',
                        'uiDisabled': false
                    },
                    {
                        'value': 'con3Au',
                        'text': 'Convertible 3-Year All Upfront',
                        'uiDisabled': false
                    }
                ],
                'defaultValue': [
                    'onDemand',
                    'std3Au',
                    'std3Pu',
                    'std3Nu',
                    'std1Au',
                    'std1Pu',
                    'std1Nu',
                    'con3Au',
                    'con3Pu',
                    'con3Nu',
                    'con1Au',
                    'con1Pu',
                    'con1Nu'
                ],
                'description': 'Unselect the EC2 payment types that are not applicable for customer. At least one payment type must be selected.',
                'uiHidden': false
            },
            {
                'identifier': 'awsEC2AdjustmentAmt',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Manual adjustment on AWS server cost ($)',
                'description': 'Entered amount will be added to the EC2 cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0
                }
            },
            {
                'identifier': 'awsEC2AdjustmentDesc',
                'type': 'string',
                'defaultValue': '',
                'label': 'Description of the manual adjustment on AWS EC2 cost',
                'description': 'Description will appear on the screen for reference.',
                'uiHidden': false,
                'validation': {
                    'max': 50
                }
            },
            {
                'identifier': 'applyUnusedCapacity',
                'type': 'boolean',
                'defaultValue': true,
                'label': 'Apply unused capacity',
                'description': 'Subtracts from AWS cost a corresponding ratio for the unused Dedicated Host capacity.'
            }
        ]
    },
    {
        'identifier': 'awsRDSRightSize',
        'label': 'AWS database recommendation',
        'type': 'object',
        'properties': [
            {
                'identifier': 'enableRDSRightSize',
                'type': 'boolean',
                'defaultValue': false,
                'label': 'Enable RDS recommendations',
                'description': 'Select this option to provide RDS recommendations for databases in your portfolio.'
            },
            {
                'identifier': 'enableEC2Recommendations',
                'type': 'boolean',
                'defaultValue': false,
                'label': 'Enable EC2 recommendations',
                'description': 'When selected MPA provides EC2 with pre-installed SQL Server recommendations for databases ' + 
                    'with SQL Server as target engine, and computes 3rd party licenses for databases with Oracle target engine. ' +
                    'Note that if both RDS and EC2 recommendations are enabled, MPA will give priority to EC2 recommendations.',
            },
            {
                'identifier': 'excludedRDSInstanceTypes',
                'type': 'string',
                'defaultValue': '',
                'label': 'Do not recommend these RDS instance types',
                'description': 'Comma separated list of RDS instance types to exclude from the recommendation. Supports partial instance names: db.t will '
                    + 'exclude all instance types that start with db.t',
                'validation': {
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'defaultTargetDatabase',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'Aurora MySQL',
                        'text': 'Aurora MySQL'
                    },
                    {
                        'value': 'Aurora PostgreSQL',
                        'text': 'Aurora PostgreSQL'
                    },
                    {
                        'value': 'MariaDB',
                        'text': 'MariaDB'
                    },
                    {
                        'value': 'MySQL',
                        'text': 'MySQL'
                    },
                    {
                        'value': 'PostgreSQL',
                        'text': 'PostgreSQL'
                    },
                    {
                        'value': 'SQL Server',
                        'text': 'SQL Server'
                    },
                    {
                        'value': 'Oracle',
                        'text': 'Oracle'
                    }
                ],
                'defaultValue': 'Aurora MySQL',
                'label': 'Default target database engine',
                'description': 'Default target database engine will be used when neither the \'Target AWS DB Service\' nor the \'DB Instance Engine/Software\''
                    + ' attributes are valid RDS options.',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'defaultDatabaseEdition',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'Enterprise',
                        'text': 'Enterprise'
                    },
                    {
                        'value': 'Standard',
                        'text': 'Standard'
                    },
                    {
                        'value': 'Standard One',
                        'text': 'Standard One'
                    },
                    {
                        'value': 'Standard Two',
                        'text': 'Standard Two'
                    },
                    {
                        'value': 'Express',
                        'text': 'Express'
                    },
                    {
                        'value': 'Web',
                        'text': 'Web'
                    }
                ],
                'defaultValue': 'Enterprise',
                'label': 'Database edition',
                'description': 'Default database edition will be used when the \'Enterprise / Standard Edition\' attribute is not provided or invalid.',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'defaultDatabaseLicenseModel',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'Bring your own license',
                        'text': 'Bring your own license'
                    },
                    {
                        'value': 'License included',
                        'text': 'License included'
                    }
                ],
                'defaultValue': 'License included',
                'label': 'Database license model',
                'description': 'Default license model will be used when the \'License Model\' attribute is not provided or invalid, for Oracle '
                    + 'and Sql Server RDS engines.',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'defaultTargetDeploymentOption',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'Single-AZ',
                        'text': 'Single-AZ'
                    },
                    {
                        'value': 'Multi-AZ',
                        'text': 'Multi-AZ'
                    }
                ],
                'defaultValue': 'Single-AZ',
                'label': 'Default deployment option',
                'description': 'Default deployment option will be used when the \'DB Instance Deployment Option\' attribute is not provided or invalid.',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'databaseAvgCpuPct',
                'type': 'number',
                'defaultValue': 24,
                'label': 'Default average CPU utilization (%)',
                'description': 'Default value will be used whenever \'CPU-Average Utilization %\' attribute is not mapped or has an invalid value.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'useDatabaseAvgCpuForAll',
                'type': 'boolean',
                'defaultValue': false,
                'label': 'Use the value above for average CPU utilization of all database servers',
                'description': 'This value will be used for all databases and will override any value stored against the database.'
            },
            {
                'identifier': 'databaseAvgRamPct',
                'type': 'number',
                'defaultValue': 59,
                'label': 'Default average RAM utilization (%)',
                'description': 'Default value will be used whenever \'RAM-Average Utilization %\' attribute is not mapped or has an invalid value.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'useDatabaseAvgRamForAll',
                'type': 'boolean',
                'defaultValue': false,
                'label': 'Use the value above for average RAM utilization of all database servers',
                'description': 'This value will be used for all databases and will override any value stored against the database.'
            },
            {
                'identifier': 'databasePeakCpuPct',
                'type': 'number',
                'defaultValue': 24,
                'label': 'Default peak CPU utilization (%)',
                'description': 'Default value will be used whenever \'CPU-Peak Utilization %\' attribute is not mapped or has an invalid value.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'useDatabasePeakCpuForAll',
                'type': 'boolean',
                'defaultValue': false,
                'label': 'Use the value above for peak CPU utilization of all database servers',
                'description': 'This value will be used for all databases and will override any value stored against the database.'
            },
            {
                'identifier': 'databasePeakRamPct',
                'type': 'number',
                'defaultValue': 59,
                'label': 'Default peak RAM utilization (%)',
                'description': 'Default value will be used whenever \'RAM-Peak Utilization %\' attribute is not mapped or has an invalid value.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'useDatabasePeakRamForAll',
                'type': 'boolean',
                'defaultValue': false,
                'label': 'Use the value above for peak RAM utilization of all database servers',
                'description': 'This value will be used for all databases and will override any value stored against the database.'
            },
            {
                'identifier': 'databaseThreadsPerCore',
                'type': 'number',
                'defaultValue': 1,
                'label': 'Default number of threads per CPU-Core',
                'description': 'Default value will be used whenever \'CPU-Number of Threads per CPU-Core\' attribute is not mapped or has an invalid value.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 1
                }
            },
            {
                'identifier': 'useDatabaseThreadsPerCoreForAll',
                'type': 'boolean',
                'defaultValue': false,
                'label': 'Use the value above for number of threads per CPU-Core of all database servers',
                'description': 'This value will be used for all databases and will override any value stored against the database.'
            }
        ]
    },
    {
        'identifier': 'awsRDSPricing',
        'label': 'AWS database cost',
        'type': 'object',
        'properties': [
            {
                'identifier': 'awsRDSRecommendation',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'onPrem',
                        'text': 'On-Premises capacity'
                    },
                    {
                        'value': 'average',
                        'text': 'Average utilization'
                    },
                    {
                        'value': 'peak',
                        'text': 'Peak utilization'
                    }
                ],
                'defaultValue': 'peak',
                'label': 'Database recommendation',
                'description': 'Select database recommendation type for RDS pricing.',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'awsDatabaseUptime',
                'type': 'number',
                'defaultValue': 100,
                'label': 'Default production database usage (uptime) %',
                'description': 'Default value will be used whenever \'Database Usage %\' is not mapped or has an invalid value for a production database.',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'awsNonProdDatabaseUptime',
                'type': 'number',
                'defaultValue': 24,
                'label': 'Default non-production database usage (uptime) %',
                'description': 'Default value will be used whenever \'Database Usage %\' is not mapped or has an invalid value for a non-production database.',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'awsRDSPaymentTypes',
                'label': 'RDS payment types',
                'type': 'multiValueEnum',
                'selections': [
                    {
                        'value': 'ON_DEMAND',
                        'text': 'On-Demand',
                        'uiDisabled': true
                    },
                    {
                        'value': 'ONE_YEAR_NO_UPFRONT',
                        'text': '1-Year No Upfront',
                        'uiDisabled': false
                    },
                    {
                        'value': 'ONE_YEAR_PARTIAL_UPFRONT',
                        'text': '1-Year Partial Upfront',
                        'uiDisabled': false
                    },
                    {
                        'value': 'ONE_YEAR_ALL_UPFRONT',
                        'text': '1-Year All Upfront',
                        'uiDisabled': false
                    },
                    {
                        'value': 'THREE_YEAR_PARTIAL_UPFRONT',
                        'text': '3-Year Partial Upfront',
                        'uiDisabled': false
                    },
                    {
                        'value': 'THREE_YEAR_ALL_UPFRONT',
                        'text': '3-Year All Upfront',
                        'uiDisabled': false
                    }
                ],
                'defaultValue': [
                    'ON_DEMAND',
                    'ONE_YEAR_NO_UPFRONT',
                    'ONE_YEAR_PARTIAL_UPFRONT',
                    'ONE_YEAR_ALL_UPFRONT',
                    'THREE_YEAR_PARTIAL_UPFRONT',
                    'THREE_YEAR_ALL_UPFRONT'
                ],
                'description': 'Unselect the RDS payment types that are not applicable for customer. At least one payment type must be selected.',
                'uiHidden': false
            },
            {
                'identifier': 'awsRDSAdjustmentAmt',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Manual adjustment on AWS database cost ($)',
                'description': 'Entered amount will be added to the RDS cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0
                }
            },
            {
                'identifier': 'awsRDSAdjustmentDesc',
                'type': 'string',
                'defaultValue': '',
                'label': 'Description of the manual adjustment on AWS database cost',
                'description': 'Description will appear on the screen for reference.',
                'uiHidden': false,
                'validation': {
                    'max': 50
                }
            }
        ]
    },
    {
        'identifier': 'databaseLicense',
        'label': 'Database licenses',
        'type': 'object',
        'properties': [
            {
                'identifier': 'includeDBLicenseInTCO',
                'type': 'boolean',
                'defaultValue': false,
                'label': 'Include database license assessment in TCO',
                'description': 'If enabled, license count and cost are computed and included in the TCO assessment. Works only when RDS recommendations is On.',
                'uiHidden': false
            },
            {
                'identifier': 'oracleStandardLicenseCost',
                'type': 'number',
                'defaultValue': 17500,
                'label': 'Oracle Standard Edition/One/Two license cost ($)',
                'description': 'Oracle Standard Edition/One/Two license cost per processor/socket.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 50000
                }
            },
            {
                'identifier': 'oracleStandardDiscount',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Oracle Standard Edition/One/Two discount (%)',
                'description': 'Oracle Standard Edition/One/Two discount percentage.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'oracleStandardSupportCostRatio',
                'type': 'number',
                'defaultValue': 22,
                'label': 'Oracle Standard Edition/One/Two annual support cost (%)',
                'description': 'Oracle Standard Edition/One/Two annual support cost as a percentage from the license cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'oracleEnterpriseLicenseCost',
                'type': 'number',
                'defaultValue': 47500,
                'label': 'Oracle Enterprise Edition license cost ($)',
                'description': 'Oracle Enterprise Edition license cost per processor/socket.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100000
                }
            },
            {
                'identifier': 'oracleEnterpriseDiscount',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Oracle Enterprise Edition discount (%)',
                'description': 'Oracle Enterprise Edition discount percentage.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'oracleEnterpriseSupportCostRatio',
                'type': 'number',
                'defaultValue': 22,
                'label': 'Oracle Enterprise Edition annual support cost (%)',
                'description': 'Oracle Enterprise Edition annual support cost as a percentage from the license cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'oracleEnterpriseCoreFactor',
                'type': 'enum',
                'enum': [
                    {
                        'value': '0.25',
                        'text': '0.25'
                    },
                    {
                        'value': '0.5',
                        'text': '0.5'
                    },
                    {
                        'value': '0.75',
                        'text': '0.75'
                    },
                    {
                        'value': '1',
                        'text': '1'
                    }
                ],
                'defaultValue': '1',
                'label': 'Oracle Enterprise Core Factor',
                'description': 'Oracle Enterprise Edition processor core factor.',
                'uiHidden': false
            },
            {
                'identifier': 'useCoreFactorForAllOracle',
                'type': 'boolean',
                'defaultValue': false,
                'label': 'Use the value above as the default Core Factor',
                'description': 'This value will be used for all Oracle Enterprise databases in your portfolio regardless of the corresponding server cpu type.'
            },
            {
                'identifier': 'sqlServerStandardLicenseCost',
                'type': 'number',
                'defaultValue': 3586,
                'label': 'SQL Server Standard Edition license cost - 2 cores pack ($)',
                'description': 'SQL Server Standard Edition license cost per core, in 2 cores packs.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 30000
                }
            },
            {
                'identifier': 'sqlServerStandardDiscount',
                'type': 'number',
                'defaultValue': 0,
                'label': 'SQL Server Standard Edition discount (%)',
                'description': 'SQL Server Standard Edition discount percentage.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'sqlServerStandardSupportCostRatio',
                'type': 'number',
                'defaultValue': 0,
                'label': 'SQL Server Standard Edition annual support cost (%)',
                'description': 'SQL Server Standard Edition annual support cost as percentage of the license cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'sqlServerEnterpriseLicenseCost',
                'type': 'number',
                'defaultValue': 13748,
                'label': 'SQL Server Enterprise Edition license cost - 2 cores pack ($)',
                'description': 'SQL Server Enterprise Edition license cost per core, in 2 cores packs.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 50000
                }
            },
            {
                'identifier': 'sqlServerEnterpriseDiscount',
                'type': 'number',
                'defaultValue': 0,
                'label': 'SQL Server Enterprise Edition discount (%)',
                'description': 'SQL Server Enterprise Edition discount percentage.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'sqlServerEnterpriseSupportCostRatio',
                'type': 'number',
                'defaultValue': 0,
                'label': 'SQL Server Enterprise Edition annual support cost (%)',
                'description': 'SQL Server Enterprise Edition annual support cost as percentage of the license cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            }
        ]
    },
    {
        'identifier': 'vmwareCloud',
        'type': 'object',
        'label': 'VMware Cloud on AWS',
        'properties': [
            {
                'identifier': 'instanceType',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'i3.metal',
                        'text': 'i3'
                    },
                    {
                        'value': 'i3en.metal',
                        'text': 'i3en'
                    },
                    {
                        'value': 'i4i.metal',
                        'text': 'i4i'
                    },
                    {
                        'value': 'recommend',
                        'text': 'Recommend'
                    }
                ],
                'defaultValue': 'recommend',
                'label': 'Instance type',
                'description': 'Use the specified instance type or recommend based on cost.',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'computeOvercommitFactor',
                'type': 'number',
                'defaultValue': 4,
                'label': 'Compute overcommit factor',
                'description': 'Default CPU overcommit factor to apply in sizing.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0.01
                }
            },
            {
                'identifier': 'memoryOvercommitFactor',
                'type': 'number',
                'defaultValue': 1,
                'label': 'Memory overcommit factor',
                'description': 'Default RAM overcommit factor to apply in sizing.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0.01
                }
            },
            {
                'identifier': 'storageOvercommitFactor',
                'type': 'number',
                'defaultValue': 1,
                'label': 'Storage overcommit factor',
                'description': 'Default Storage overcommit factor to apply in sizing.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0.01
                }
            },
            {
                'identifier': 'faultToleranceMode',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'RAID-1',
                        'text': 'RAID-1'
                    },
                    {
                        'value': 'RAID-5',
                        'text': 'RAID-5'
                    },
                    {
                        'value': 'RAID-6',
                        'text': 'RAID-6'
                    }
                ],
                'defaultValue': 'RAID-1',
                'label': 'Fault Tolerance Method',
                'description': 'Fault tolerance affects number of minimum VMware Cloud host required and the storage capacity of host.',
                'uiHidden': true,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'failuresToTolerate',
                'type': 'enum',
                'enum': [
                    {
                        'value': '1',
                        'text': '1'
                    },
                    {
                        'value': '2',
                        'text': '2'
                    }
                ],
                'defaultValue': '1',
                'label': 'Host Failures to Tolerate',
                'description': 'The number of host failures to tolerate.',
                'uiHidden': true,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'vmwarePricingDiscount',
                'type': 'number',
                'defaultValue': 0,
                'label': 'VMware pricing discount %',
                'description': 'Discount percentage applied to VMware pricing.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            }
        ]
    },
    {
        'identifier': 'awsStorage',
        'type': 'object',
        'label': 'AWS storage',
        'properties': [
            {
                'identifier': 'applyOnDemandUptime',
                'type': 'boolean',
                'defaultValue': false,
                'label': 'Apply server uptime to EBS of OnDemand instances',
                'description': 'When enabled, MPA assumes that EBS volumes are deleted when OnDemand EC2 instances are stopped/terminated, '
                    + 'and adjusts the storage cost with the server uptime.',
                'uiHidden': false
            },
            {
                'identifier': 'monthlyBackupPct',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Rate of change per month (%)',
                'description': 'Monthly storage update percentage after initial backup.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'awsInitialBackup',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'yes',
                        'text': 'Yes'
                    },
                    {
                        'value': 'no',
                        'text': 'No'
                    }
                ],
                'defaultValue': 'yes',
                'label': 'Enable initial backup',
                'description': 'Take one-time backup of current storage on AWS',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'awsAdditionalRedundancy',
                'type': 'enum',
                'enum': [
                    {
                        'value': '0',
                        'text': '0'
                    },
                    {
                        'value': '1',
                        'text': '1'
                    },
                    {
                        'value': '2',
                        'text': '2'
                    },
                    {
                        'value': '3',
                        'text': '3'
                    }
                ],
                'defaultValue': '0',
                'label': 'Additional redundancy sites',
                'description': 'AWS redundancy is built-in. Additional redundancy is not required for most business data storage.',
                'uiHidden': true,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'totalDiskUsagePct',
                'type': 'number',
                'defaultValue': 50,
                'label': 'Default Storage-Utilization %',
                'description': 'Default value will be used whenever \'Storage-Utilization %\' is not mapped or has an invalid value.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'awsRaid6num',
                'type': 'number',
                'defaultValue': 18,
                'label': 'RAID 6/60-Penalty',
                'description': 'RAID 6/60-Penalty',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 99
                }
            },
            {
                'identifier': 'awsRaid5num',
                'type': 'number',
                'defaultValue': 20,
                'label': 'RAID 5/50-Penalty',
                'description': 'RAID 5/50-Penalty',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 99
                }
            },
            {
                'identifier': 'awsRaid1num',
                'type': 'number',
                'defaultValue': 50,
                'label': 'RAID 1/10-Penalty',
                'description': 'RAID 1/10-Penalty',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 99
                }
            },
            {
                'identifier': 'awsEraseCoding',
                'type': 'number',
                'defaultValue': 25,
                'label': 'Erase Coding',
                'description': 'Erase Coding',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'awsNoProtection',
                'type': 'number',
                'defaultValue': 0,
                'label': 'No protection',
                'description': 'No protection',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'snapshotCompressionRatio',
                'type': 'number',
                'defaultValue': 1,
                'label': 'EBS snapshot compression ratio',
                'description': 'EBS Backup Snapshot compression ratio',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 1,
                    'min': 1,
                    'max': 10
                }
            },
            {
                'identifier': 'awsEBSTypes',
                'label': 'Valid EBS Types',
                'type': 'multiValueEnum',
                'selections': [
                    {
                        'value': 'ebsGp2',
                        'text': 'General Purpose SSD - gp2',
                        'uiDisabled': false
                    },
                    {
                        'value': 'ebsGp3',
                        'text': 'General Purpose SSD - gp3',
                        'uiDisabled': false
                    },
                    {
                        'value': 'ebsIOPS',
                        'text': 'Provisioned IOPS SSD',
                        'uiDisabled': false
                    },
                    {
                        'value': 'ebsThroughPut',
                        'text': 'Throughput Optimized HDD',
                        'uiDisabled': false
                    },
                    {
                        'value': 'ebsColdHdd',
                        'text': 'Cold HDD',
                        'uiDisabled': false
                    }
                ],
                'defaultValue': [
                    'ebsGp2', 'ebsGp3'
                ],
                'description': 'Select the EBS types that are applicable for the customer. GP2 will be the default recommendation whenever '
                    + 'there is no valid match.',
                'uiHidden': false
            },
            {
                'identifier': 'awsStorageAdjustmentAmt',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Manual adjustment on AWS storage cost ($)',
                'description': 'Entered amount will be added to the AWS storage cost',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0
                }
            },
            {
                'identifier': 'awsStorageAdjustmentDesc',
                'type': 'string',
                'defaultValue': '',
                'label': 'Description of the manual adjustment on AWS storage cost',
                'description': 'Description will appear on the screen for reference',
                'uiHidden': false,
                'validation': {
                    'max': 50
                }
            }
        ]
    },
    {
        'identifier': 'awsNetwork',
        'type': 'object',
        'label': 'AWS network',
        'properties': [
            {
                'identifier': 'awsOutbound',
                'type': 'number',
                'defaultValue': 50,
                'label': 'Outbound peak utilization (%)',
                'description': 'Used to calculate outbound data traffic.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'awsNetworkAdjustmentAmt',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Manual adjustment on AWS network cost ($)',
                'description': 'Entered amount will be added to the AWS network cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0
                }
            },
            {
                'identifier': 'awsNetworkAdjustmentDesc',
                'type': 'string',
                'defaultValue': '',
                'label': 'Description of the manual adjustment on AWS network cost',
                'description': 'Description will appear on the screen for reference.',
                'uiHidden': false,
                'validation': {
                    'max': 50
                }
            }
        ]
    },
    {
        'identifier': 'awsLaborSupport',
        'type': 'object',
        'label': 'AWS IT labor and support',
        'properties': [
            {
                'identifier': 'awsEC2Admin',
                'type': 'number',
                'defaultValue': 400,
                'label': 'Number of EC2 instances per admin',
                'description': 'Number of EC2 instances that one administrator can manage.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 1000
                }
            },
            {
                'identifier': 'awsRDSAdmin',
                'type': 'number',
                'defaultValue': 400,
                'label': 'Number of RDS instances per admin',
                'description': 'Number of RDS instances that one administrator can manage.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 1000
                }
            },
            {
                'identifier': 'awsStorageAdmin',
                'type': 'number',
                'defaultValue': 5000,
                'label': 'Storage size (TB) per admin',
                'description': 'Size of storage that one administrator can manage.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 50000
                }
            },
            {
                'identifier': 'awsAdminSalary',
                'type': 'number',
                'defaultValue': 135000,
                'label': 'Administrator\'s Annual Salary ($)',
                'description': 'Annual salary of a system administrator.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 200000
                }
            },
            {
                'identifier': 'awsSupportPlan',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'business',
                        'text': 'Business'
                    },
                    {
                        'value': 'enterprise',
                        'text': 'Enterprise'
                    },
                    {
                        'value': 'partner',
                        'text': 'None'
                    }
                ],
                'defaultValue': 'business',
                'label': 'AWS Support',
                'description': 'AWS Support plan options',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'awsSupportBusinessPlanLevel0',
                'type': 'number',
                'defaultValue': 100,
                'label': 'AWS-Business Support Level 0 ($)',
                'description': 'AWS Business Support plan - No Minimum',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 2000
                }
            },
            {
                'identifier': 'awsSupportBusinessPlanLevel1',
                'type': 'number',
                'defaultValue': 10,
                'label': 'AWS-Business Support Level 1 (%)',
                'description': 'AWS Business Support plan -> 0-$10K',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'awsSupportBusinessPlanLevel2',
                'type': 'number',
                'defaultValue': 7,
                'label': 'AWS-Business Support Level 2 (%)',
                'description': 'AWS Business Support plan -> Spend $10K-$80K',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'awsSupportBusinessPlanLevel3',
                'type': 'number',
                'defaultValue': 5,
                'label': 'AWS-Business Support Level 3 (%)',
                'description': 'AWS Business Support plan -> Spend $80K-$250K',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'awsSupportBusinessPlanLevel4',
                'type': 'number',
                'defaultValue': 3,
                'label': 'AWS-Business Support Level 4 (%)',
                'description': 'AWS Business Support plan -> Greater than $250K',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'awsSupportEntPlanLevel0',
                'type': 'number',
                'defaultValue': 15000,
                'label': 'AWS-Enterprise Support Level 0 ($)',
                'description': 'AWS Enterprise Support plan - No Minimum',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 25000
                }
            },
            {
                'identifier': 'awsSupportEntPlanLevel1',
                'type': 'number',
                'defaultValue': 10,
                'label': 'AWS-Business Support Level 1 (%)',
                'description': 'AWS Business Support plan -> 0-$150K',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'awsSupportEntPlanLevel2',
                'type': 'number',
                'defaultValue': 7,
                'label': 'AWS-Enterprise Support Level 2 (%)',
                'description': 'AWS Enterprise Support plan -> Spend $10K-$80K',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'awsSupportEntPlanLevel3',
                'type': 'number',
                'defaultValue': 5,
                'label': 'AWS-Enterprise Support Level 3 (%)',
                'description': 'AWS Enterprise Support plan -> Spend $80K-$250K',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'awsSupportEntPlanLevel4',
                'type': 'number',
                'defaultValue': 3,
                'label': 'AWS-Enterprise Support Level 4 (%)',
                'description': 'AWS Enterprise Support plan -> Greater than $250K',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'awsSupportPartnerPrice',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Partner\'s Monthly Support Cost ($)',
                'description': 'Partner\'s support cost will be added to the total.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 1000000
                }
            },
            {
                'identifier': 'awsSupportLaborAdjustmentAmt',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Manual adjustment on AWS IT labor and support cost ($)',
                'description': 'Entered amount will be added to the AWS IT labor and support cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0
                }
            },
            {
                'identifier': 'awsSupportLaborAdjustmentDesc',
                'type': 'string',
                'defaultValue': '',
                'label': 'Description of the manual adjustment on IT labor and support cost',
                'description': 'Description will appear on the screen for reference.',
                'uiHidden': false,
                'validation': {
                    'maxLen': 50
                }
            }
        ]
    },
    {
        'identifier': 'onPremServerCost',
        'type': 'object',
        'label': 'On-Premises server cost',
        'properties': [
            {
                'identifier': 'excludeRetireServers',
                'type': 'boolean',
                'defaultValue': false,
                'label': 'Exclude servers marked as \'Retire\'',
                'description': 'Do not calculate an on-premises cost for servers (and any associated storage / IT labor) '
                    + 'that have a Migration strategy of \'Retire\'.'
            }
        ]
    },
    {
        'identifier': 'onPremDiscount',
        'label': 'On-Premises discount/adjustment',
        'type': 'object',
        'properties': [
            {
                'identifier': 'onPremHWDiscount',
                'type': 'number',
                'defaultValue': 40,
                'label': 'Server and hardware discount (%)',
                'description': 'Discount that the customer receives on the market price.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'onPremStorageDiscount',
                'type': 'number',
                'defaultValue': 50,
                'label': 'Storage discount (%)',
                'description': 'Discount that the customer gets on the market price.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'onPremSWDiscount',
                'type': 'number',
                'defaultValue': 25,
                'label': 'Software discount (%)',
                'description': 'Discount that the customer gets on the market price.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'onPremComputeAdjustmentAmt',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Manual adjustment on server and hardware cost ($)',
                'description': 'Entered amount will be added to the server cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0
                }
            },
            {
                'identifier': 'onPremComputeAdjustmentDesc',
                'type': 'string',
                'defaultValue': '',
                'label': 'Description of the manual adjustment on server and hardware cost',
                'description': 'Description will appear on the screen for reference.',
                'uiHidden': false,
                'validation': {
                    'maxLen': 50
                }
            },
            {
                'identifier': 'onPremDatabaseAdjustmentAmt',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Manual adjustment on database cost ($)',
                'description': 'Entered amount will be added to the database cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0
                }
            },
            {
                'identifier': 'onPremDatabaseAdjustmentDesc',
                'type': 'string',
                'defaultValue': '',
                'label': 'Description of the manual adjustment on database cost',
                'description': 'Description will appear on the screen for reference.',
                'uiHidden': false,
                'validation': {
                    'maxLen': 50
                }
            }
        ]
    },
    {
        'identifier': 'onPremPower',
        'label': 'On-Premises power',
        'type': 'object',
        'properties': [
            {
                'identifier': 'onPremPowerPricePerKW',
                'type': 'number',
                'defaultValue': 0.107,
                'label': 'Power price ($) per kWh',
                'description': 'On-Premises metered power cost per kWh.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 3,
                    'min': 0,
                    'max': 5
                }
            },
            {
                'identifier': 'powerUsageEffectiveness',
                'type': 'number',
                'defaultValue': 1.6,
                'label': 'Power usage effectiveness',
                'description': 'Ratio of power used and power delivered to computing unit.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 10
                }
            },
            {
                'identifier': 'coloPowerPricePerKW',
                'type': 'number',
                'defaultValue': 0.107,
                'label': 'Colocation Power price ($) per kWh',
                'description': 'Colocation metered power cost per kWh',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 3,
                    'min': 0,
                    'max': 5
                }
            }
        ]
    },
    {
        'identifier': 'onPremITOperation',
        'label': 'On-Premises rack infrastructure',
        'type': 'object',
        'properties': [
            {
                'identifier': 'serverUnitPerRack',
                'type': 'number',
                'defaultValue': 28,
                'label': 'Number of units per rack',
                'description': 'Server space per rack.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'storageSizePerRack',
                'type': 'number',
                'defaultValue': 2000,
                'label': 'Storage size per rack (TB)',
                'description': 'Storage size per rack.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0
                }
            },
            {
                'identifier': 'rackChassisPrice',
                'type': 'number',
                'defaultValue': 1850,
                'label': 'Rack chassis cost ($)',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 5000
                }
            },
            {
                'identifier': 'powerDistributionUnitCost',
                'type': 'number',
                'defaultValue': 460,
                'label': 'Power distribution unit cost ($)',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 1000
                }
            },
            {
                'identifier': 'countofToR',
                'type': 'number',
                'defaultValue': 2,
                'label': 'Number of ToR switches per rack',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10
                }
            },
            {
                'identifier': 'priceofToRSupport',
                'type': 'number',
                'defaultValue': 1917,
                'label': 'ToR switch support cost ($) per year',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 5000
                }
            },
            {
                'identifier': 'serverDeploymentCost',
                'type': 'number',
                'defaultValue': 250,
                'label': 'Server deployment cost ($) per server',
                'description': 'One time server deployment cost per server.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 1000
                }
            },
            {
                'identifier': 'monthlyOnpremCostperRack',
                'type': 'number',
                'defaultValue': 1400,
                'label': 'On-Premises monthly cost to operate a rack ($)',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 5000
                }
            },
            {
                'identifier': 'monthlyColoCostperRack',
                'type': 'number',
                'defaultValue': 2600,
                'label': 'Colocation monthly cost to operate a rack ($)',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 5000
                }
            },
            {
                'identifier': 'maintenanceRatePerYear',
                'type': 'number',
                'defaultValue': 15,
                'label': 'Hardware maintenance rate per year (%)',
                'description': 'Hardware maintenance rate as percentage of total hardware cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'spareCapacityServerPerYear',
                'type': 'number',
                'defaultValue': 5,
                'label': 'Spare capacity for server per year (%)',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            }
        ]
    },
    {
        'identifier': 'onPremSoftware',
        'label': 'Software and licenses',
        'type': 'object',
        'properties': [
            {
                'identifier': 'estimateDhOsLicenses',
                'type': 'boolean',
                'defaultValue': false,
                'label': 'Estimate Windows licenses on Dedicated Host',
                'description': 'MPA always estimates the on-premises licenses for Windows servers and VMs; if enabled, MPA will also '
                    + 'estimate them on Dedicated Host.'
            },
            {
                'identifier': 'onPremWindowsLicense',
                'type': 'number',
                'defaultValue': 769,
                'label': 'Windows 2016 Datacenter license, 2-core pack ($)',
                'description': 'Windows server license cost for physical servers and hosts; one license per 2 cores; one-time cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10000
                }
            },
            {
                'identifier': 'onPremWindowsSupport',
                'type': 'number',
                'defaultValue': 25,
                'label': 'Windows 2016 Datacenter (Software Assurance) (%)',
                'description': 'Windows server support cost as percentage of license cost; yearly cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'onPremRhelStdLicense',
                'type': 'number',
                'defaultValue': 799,
                'label': 'RHEL (physical) license cost, per 2 processors ($)',
                'description': 'RHEL physical servers license cost; one license per 2 CPUs; yearly subscription.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10000
                }
            },
            {
                'identifier': 'onPremRhelPremLicense',
                'type': 'number',
                'defaultValue': 2499,
                'label': 'RHEL (virtual) license cost, per 2 processors ($)',
                'description': 'RHEL virtual servers license cost; one license per 2 host CPUs; yearly subscription.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10000
                }
            },
            {
                'identifier': 'onPremSusePhyLicense',
                'type': 'number',
                'defaultValue': 799,
                'label': 'SUSE (physical) license cost, per 2 processors ($)',
                'description': 'SUSE physical servers license cost; one license per 2 CPUs; yearly subscription.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10000
                }
            },
            {
                'identifier': 'onPremSusevirLicense',
                'type': 'number',
                'defaultValue': 1598,
                'label': 'SUSE (virtual) license cost, per 2 processors ($)',
                'description': 'SUSE virtual servers license cost; one license per 2 host CPUs; yearly subscription.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10000
                }
            },
            {
                'identifier': 'onPremVSphereLicense',
                'type': 'number',
                'defaultValue': 3595,
                'label': 'vSphere license cost, per processor ($)',
                'description': 'License cost for VMware vSphere; one license per CPU; one-time cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 6000
                }
            },
            {
                'identifier': 'onPremVSphereLicenseSupport',
                'type': 'number',
                'defaultValue': 25,
                'label': 'vSphere support and subscription cost (%)',
                'description': 'VMware vSphere support cost as percentage of license cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            }
        ]
    },
    {
        'identifier': 'onPremStorage',
        'label': 'On-Premises storage',
        'type': 'object',
        'properties': [
            {
                'identifier': 'backupPct',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Rate of change per month (%)',
                'description': 'Monthly storage update percentage. It is recommended to keep this value the same as AWS storage rate of change.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'onPremServerBackup',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'yes',
                        'text': 'Yes'
                    },
                    {
                        'value': 'no',
                        'text': 'No'
                    }
                ],
                'defaultValue': 'yes',
                'label': 'Enable On-Premises storage backup',
                'description': 'Take backup of On-Premises storage',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'onPremAdditionalRedundancy',
                'type': 'enum',
                'enum': [
                    {
                        'value': '0',
                        'text': '0'
                    },
                    {
                        'value': '1',
                        'text': '1'
                    },
                    {
                        'value': '2',
                        'text': '2'
                    },
                    {
                        'value': '3',
                        'text': '3'
                    }
                ],
                'defaultValue': '1',
                'label': 'Additional redundancy sites',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'onPremHddSANPrice',
                'type': 'number',
                'defaultValue': 1.1,
                'label': 'SAN HDD price ($/GB)',
                'description': 'SAN-HDD purchase price per GB.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 20
                }
            },
            {
                'identifier': 'onPremHddNASPrice',
                'type': 'number',
                'defaultValue': 0.4,
                'label': 'NAS HDD price ($/GB)',
                'description': 'NAS-HDD purchase price per GB.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 10
                }
            },
            {
                'identifier': 'onPremServerStoragePrice',
                'type': 'number',
                'defaultValue': 1.02,
                'label': 'Server storage price ($/GB)',
                'description': 'Server storage price price is different from shared storage, it is used to calculate the server disk cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 20
                }
            },
            {
                'identifier': 'onPremSddSANPrice',
                'type': 'number',
                'defaultValue': 3,
                'label': 'SAN SSD price ($/GB)',
                'description': 'SAN-SSD purchase price per GB.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 20
                }
            },
            {
                'identifier': 'onPremSddNASPrice',
                'type': 'number',
                'defaultValue': 1.7,
                'label': 'NAS SSD price ($/GB)',
                'description': 'NAS-SSD purchase price per GB.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 10
                }
            },
            {
                'identifier': 'onPremObjectPrice',
                'type': 'number',
                'defaultValue': 1.1,
                'label': 'Object storage price ($/GB)',
                'description': 'Object storage purchase price per GB.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 10
                }
            },
            {
                'identifier': 'onPremBackupDisk',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'lto7',
                        'text': 'LTO-7'
                    },
                    {
                        'value': 'lto6',
                        'text': 'LTO-6'
                    }
                ],
                'defaultValue': 'lto7',
                'label': 'Backup tape library type',
                'description': 'Tape\'s decompressing speed is dependent on Tape Type.',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'onPremBackupTapePrice',
                'type': 'number',
                'defaultValue': 2300,
                'label': 'Tape library price ($) per drive',
                'description': 'Tape library price per drive.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 5000
                }
            },
            {
                'identifier': 'onPremStorageSW',
                'type': 'number',
                'defaultValue': 40,
                'label': 'Storage software cost (%)',
                'description': 'Storage software cost as percentage of storage cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'onPremUncompressSpeedLTO7',
                'type': 'number',
                'defaultValue': 300,
                'label': 'LTO-7- Max uncompressed speed(MB/s)',
                'description': 'LTO-7- Max uncompressed speed(MB/s)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'onPremUncompressSpeedLTO6',
                'type': 'number',
                'defaultValue': 160,
                'label': 'LTO-6- Max uncompressed speed(MB/s)',
                'description': 'LTO-6- Max uncompressed speed(MB/s)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'onPrembackupIntialSnapshot',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'yes',
                        'text': 'Yes'
                    },
                    {
                        'value': 'no',
                        'text': 'No'
                    }
                ],
                'defaultValue': 'yes',
                'label': 'Enable Initial Snapshot',
                'description': 'Enable Initial Snapshot',
                'uiHidden': true,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'onPremRaid6num',
                'type': 'number',
                'defaultValue': 18,
                'label': 'RAID 6/60-Penalty',
                'description': 'RAID 6/60-Penalty',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 99
                }
            },
            {
                'identifier': 'onPremRaid5num',
                'type': 'number',
                'defaultValue': 20,
                'label': 'RAID 5/50-Penalty',
                'description': 'RAID 5/50-Penalty',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 99
                }
            },
            {
                'identifier': 'onPremRaid1num',
                'type': 'number',
                'defaultValue': 50,
                'label': 'RAID 1/10-Penalty',
                'description': 'RAID 1/10-Penalty',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 99
                }
            },
            {
                'identifier': 'onPremErasenum',
                'type': 'number',
                'defaultValue': 25,
                'label': 'Erasure coding',
                'description': 'Erasure coding',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 99
                }
            },
            {
                'identifier': 'onPremStorageAdjustmentAmt',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Manual adjustment on storage cost ($)',
                'description': 'Manual adjustment on total on-premises storage cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0
                }
            },
            {
                'identifier': 'onPremStorageAdjustmentDesc',
                'type': 'string',
                'defaultValue': '',
                'label': 'Description of the manual adjustment on storage cost',
                'description': 'Description will appear on the screen for reference.',
                'uiHidden': false,
                'validation': {
                    'maxLen': 50
                }
            }
        ]
    },
    {
        'identifier': 'onPremNetwork',
        'label': 'On-Premises network',
        'type': 'object',
        'properties': [
            {
                'identifier': 'onPremNWHardware',
                'type': 'number',
                'defaultValue': 20,
                'label': 'Network hardware and software cost (%)',
                'description': 'Network hardware and software cost as percentage of server cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'onPremNWHardwareMaintenance',
                'type': 'number',
                'defaultValue': 25,
                'label': 'Network hardware and software maintenance cost (%)',
                'description': 'Network hardware and software maintenance cost as percentage of network hardware and software cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'onPremBandwidthPrice',
                'type': 'number',
                'defaultValue': 5,
                'label': 'On-Premises bandwidth price ($) per Mbps',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 20
                }
            },
            {
                'identifier': 'onPremBandwidthPrice-Needtosupportrange',
                'type': 'number',
                'defaultValue': 25,
                'label': 'Colocation Bandwidth Price (Incomplete)',
                'description': 'Need more information xxxxxxxxxx',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'multiplierDarkFiberIX',
                'type': 'number',
                'defaultValue': 1.5,
                'label': 'Multiplier for dark fiber to Internet exchange',
                'uiHidden': false,
                'validation': {
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'onPremNetworkAdjustmentAmt',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Manual adjustment on network cost ($)',
                'description': 'Manual adjustment on total on-premises network cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0
                }
            },
            {
                'identifier': 'onPremNetworkAdjustmentDesc',
                'type': 'string',
                'defaultValue': '',
                'label': 'Description of the manual adjustment on network cost',
                'description': 'Description will appear on the screen for reference.',
                'uiHidden': false,
                'validation': {
                    'maxLen': 50
                }
            }
        ]
    },
    {
        'identifier': 'onPremAdmin',
        'label': 'On-Premises IT labor',
        'type': 'object',
        'properties': [
            {
                'identifier': 'onPremServerperAdmin',
                'type': 'number',
                'defaultValue': 100,
                'label': 'Number of servers per admin',
                'description': 'Number of servers that one administrator can manage.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 1000
                }
            },
            {
                'identifier': 'onPremVMperAdmin',
                'type': 'number',
                'defaultValue': 250,
                'label': 'Number of VMs per admin',
                'description': 'Number of VMs that one administrator can manage.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 1000
                }
            },
            {
                'identifier': 'onPremDatabaseAdmin',
                'type': 'number',
                'defaultValue': 250,
                'label': 'Number of databases per admin',
                'description': 'Number of databases that one administrator can manage.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 1000
                }
            },
            {
                'identifier': 'onPremStorageperAdmin',
                'type': 'number',
                'defaultValue': 2500,
                'label': 'Storage size (TB) per admin',
                'description': 'Size of storage (TB) that one administrator can manage.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10000
                }
            },
            {
                'identifier': 'onPremAdminSalary',
                'type': 'number',
                'defaultValue': 135000,
                'label': 'Administrator\'s Annual salary ($)',
                'description': 'Annual salary of a system administrator.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 300000
                }
            },
            {
                'identifier': 'onPremNWAdmin',
                'type': 'number',
                'defaultValue': 8,
                'label': 'Network administration (%)',
                'description': 'Network administration cost as percentage of total IT cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 20
                }
            },
            {
                'identifier': 'onPremLaborAdjustmentAmt',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Manual adjustment on IT labor cost ($)',
                'description': 'Manual adjustment for On-Premises IT labor cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0
                }
            },
            {
                'identifier': 'onPremLaborAdjustmentDesc',
                'type': 'string',
                'defaultValue': '',
                'label': 'Description of the manual adjustment on IT labor cost',
                'description': 'Description will appear on the screen for reference.',
                'uiHidden': false,
                'validation': {
                    'maxLen': 50
                }
            }
        ]
    },
    {
        'identifier': 'generalStorage',
        'type': 'object',
        'label': 'General storage',
        'properties': [
            {
                'identifier': 'serverStorageVirtual',
                'type': 'boolean',
                'defaultValue': false,
                'label': 'Consider storage of physical servers as SAN',
                'description': 'Calculate storage pricing with all server storage as SAN.'
            },
            {
                'identifier': 'monthlyGrowthRate',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Growth rate per month (%)',
                'description': 'Month over month storage growth rate.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 1,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'osPenaltyPct',
                'type': 'number',
                'defaultValue': 5,
                'label': 'Capacity penalty - OS and file share (%)',
                'description': 'Percentage will be deducted from raw storage to compute usable storage.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 99
                }
            },
            {
                'identifier': 'capacityUsagePerformanceBuffer',
                'type': 'number',
                'defaultValue': 15,
                'label': 'Capacity usage and performance buffer (%)',
                'description': 'Percentage will be deducted from raw storage to compute usable storage.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 99
                }
            },
            {
                'identifier': 'overProvisioning',
                'type': 'number',
                'defaultValue': 15,
                'label': 'Overprovisioning factor',
                'description': 'Percentage will be deducted from raw storage to compute usable storage.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 99
                }
            },
            {
                'identifier': 'awsSANRedundancy',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'raid1',
                        'text': 'RAID 1/10'
                    },
                    {
                        'value': 'raid5',
                        'text': 'RAID 5/50'
                    },
                    {
                        'value': 'raid6',
                        'text': 'RAID 6/60'
                    },
                    {
                        'value': 'erase',
                        'text': 'Erasure coding'
                    },
                    {
                        'value': 'nop',
                        'text': 'No protection'
                    }
                ],
                'defaultValue': 'raid5',
                'label': 'Capacity penalty - SAN',
                'description': 'RAID overhead will be deducted from raw SAN to compute usable SAN.',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'awsNASRedundancy',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'raid1',
                        'text': 'RAID 1/10'
                    },
                    {
                        'value': 'raid5',
                        'text': 'RAID 5/50'
                    },
                    {
                        'value': 'raid6',
                        'text': 'RAID 6/60'
                    },
                    {
                        'value': 'erase',
                        'text': 'Erasure coding'
                    },
                    {
                        'value': 'nop',
                        'text': 'No protection'
                    }
                ],
                'defaultValue': 'raid5',
                'label': 'Capacity penalty - NAS',
                'description': 'RAID overhead will be deducted from raw NAS to compute usable NAS.',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'awsObjectRedundancy',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'raid1',
                        'text': 'RAID 1/10'
                    },
                    {
                        'value': 'raid5',
                        'text': 'RAID 5/50'
                    },
                    {
                        'value': 'raid6',
                        'text': 'RAID 6/60'
                    },
                    {
                        'value': 'erase',
                        'text': 'Erasure coding'
                    },
                    {
                        'value': 'nop',
                        'text': 'No protection'
                    }
                ],
                'defaultValue': 'raid5',
                'label': 'Capacity penalty - Object',
                'description': 'RAID overhead will be deducted from raw object storage to compute usable object storage.',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            }
        ]
    },
    {
        'identifier': 'awsOptimizationAndLicensing',
        'label': 'AWS optimization and licensing',
        'type': 'object',
        'properties': [
            {
                'identifier': 'databaseLicensingModel',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'host',
                        'text': 'Host level'
                    },
                    {
                        'value': 'vm',
                        'text': 'VM level'
                    }
                ],
                'defaultValue': 'host',
                'label': 'Virtual server licensing model',
                'description': 'Indicates how database licensing is purchased in on-premises.',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            }
        ]
    },
    {
        'identifier': 'mainframe',
        'type': 'object',
        'label': 'Mainframe - AWS target architecture',
        'properties': [
            {
                'identifier': 'mipsPerAwsVcpuRatio',
                'type': 'number',
                'defaultValue': 25,
                'label': 'MIPS to EC2 vCPU ratio',
                'description': 'The number of MIPS an EC2 vCPU can handle',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 1,
                    'max': 100000
                }
            },
            {
                'identifier': 'prodEc2InstanceBatch',
                'type': 'string',
                'defaultValue': 'm5.xlarge',
                'label': 'Production EC2 instance for Batch workload',
                'description': 'Specify Dev the EC2 instance type for production batch workload',
                'uiHidden': false,
                'validation': {
                    'minLen': 1,
                    'maxLen': 1000
                }
            },
            {
                'identifier': 'prodEc2InstanceOnline',
                'type': 'string',
                'defaultValue': 'm5.xlarge',
                'label': 'Production EC2 instance for Online workload',
                'description': 'Specify the EC2 instance type for production online workload',
                'uiHidden': false,
                'validation': {
                    'minLen': 1,
                    'maxLen': 1000
                }
            },
            {
                'identifier': 'prodEc2InstanceScheduler',
                'type': 'string',
                'defaultValue': 'm5.xlarge',
                'label': 'Production EC2 instance for Scheduler workload',
                'description': 'Specify the EC2 instance type for production scheduler workload',
                'uiHidden': false,
                'validation': {
                    'minLen': 1,
                    'maxLen': 1000
                }
            },
            {
                'identifier': 'testEc2InstanceBatch',
                'type': 'string',
                'defaultValue': 't3.medium',
                'label': 'Test EC2 instance for Batch workload',
                'description': 'Specify the EC2 instance type for test batch workload',
                'uiHidden': false,
                'validation': {
                    'minLen': 1,
                    'maxLen': 1000
                }
            },
            {
                'identifier': 'testEc2InstanceOnline',
                'type': 'string',
                'defaultValue': 't3.medium',
                'label': 'Test EC2 instance for Online workload',
                'description': 'Specify the EC2 instance type for test online workload',
                'uiHidden': false,
                'validation': {
                    'minLen': 1,
                    'maxLen': 1000
                }
            },
            {
                'identifier': 'testEc2InstanceScheduler',
                'type': 'string',
                'defaultValue': 't3.medium',
                'label': 'Test EC2 instance for Scheduler workload',
                'description': 'Specify the EC2 instance type for test scheduler workload',
                'uiHidden': false,
                'validation': {
                    'minLen': 1,
                    'maxLen': 1000
                }
            },
            {
                'identifier': 'devEc2InstanceBatch',
                'type': 'string',
                'defaultValue': 't3.medium',
                'label': 'Dev EC2 instance for Batch workload',
                'description': 'Specify the EC2 instance type for development batch workload',
                'uiHidden': false,
                'validation': {
                    'minLen': 1,
                    'maxLen': 1000
                }
            },
            {
                'identifier': 'devEc2InstanceOnline',
                'type': 'string',
                'defaultValue': 'm5.xlarge',
                'label': 'Dev EC2 instance for Online workload',
                'description': 'Specify the EC2 instance type for development online workload',
                'uiHidden': false,
                'validation': {
                    'minLen': 1,
                    'maxLen': 1000
                }
            },
            {
                'identifier': 'devEc2InstanceScheduler',
                'type': 'string',
                'defaultValue': 't3.medium',
                'label': 'Dev EC2 instance for Scheduler workload',
                'description': 'Specify the EC2 instance type for development scheduler workload',
                'uiHidden': false,
                'validation': {
                    'minLen': 1,
                    'maxLen': 1000
                }
            },
            {
                'identifier': 'elasticLB',
                'type': 'enum',
                'defaultValue': 'Network LB',
                'enum': [
                    {
                        'value': 'Network LB',
                        'text': 'Network LB'
                    },
                    {
                        'value': 'Application LB',
                        'text': 'Application LB'
                    }
                ],
                'label': 'Load Balancer Type',
                'description': 'Specify the type of Load Balancer',
                'uiHidden': true
            },
            {
                'identifier': 'prodAuroraInstance',
                'type': 'string',
                'defaultValue': 'db.r5.2xlarge',
                'label': 'Production RDS database instance',
                'description': 'Specify the Aurora RDS instance type for production environments',
                'uiHidden': false,
                'validation': {
                    'minLen': 1,
                    'maxLen': 1000
                }
            },
            {
                'identifier': 'testAuroraInstance',
                'type': 'string',
                'defaultValue': 'db.r5.large',
                'label': 'Test RDS database instance',
                'description': 'Specify the Aurora RDS instance type for test environments',
                'uiHidden': false,
                'validation': {
                    'minLen': 1,
                    'maxLen': 1000
                }
            },
            {
                'identifier': 'devAuroraInstance',
                'type': 'string',
                'defaultValue': 'db.r5.large',
                'label': 'Dev RDS database instance',
                'description': 'Specify the Aurora RDS instance type for development environments',
                'uiHidden': false,
                'validation': {
                    'minLen': 1,
                    'maxLen': 1000
                }
            },
            {
                'identifier': 'rdsDiskWritePercentage',
                'type': 'number',
                'defaultValue': 20,
                'label': 'Percentage of writes on disk operations (RDS IO rate)',
                'description': 'Specify the percentage of RDS IO operations that are writes',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 's3IAStorageTier',
                'type': 'enum',
                'defaultValue': 'S3 Standard IA',
                'enum': [
                    {
                        'value': 'S3 Standard IA',
                        'text': 'S3 Standard IA'
                    },
                    {
                        'value': 'S3 One Zone IA',
                        'text': 'S3 One Zone IA'
                    }
                ],
                'label': 'S3 IA storage',
                'description': 'Specify the type of S3 Infrequent Access storage',
                'uiHidden': false
            },
            {
                'identifier': 'directConnectPort',
                'type': 'enum',
                'defaultValue': '10G',
                'enum': [
                    {
                        'value': '1G',
                        'text': '1G'
                    },
                    {
                        'value': '10G',
                        'text': '10G'
                    }
                ],
                'label': 'Direct Connect Port Capacity',
                'description': 'Specify the capacity of the Direct Connect port',
                'uiHidden': true
            },
            {
                'identifier': 'directConnectDataOut',
                'type': 'enum',
                'defaultValue': 'United States',
                'enum': [
                    {
                        'value': 'United States',
                        'text': 'United States'
                    },
                    {
                        'value': 'Canada',
                        'text': 'Canada'
                    },
                    {
                        'value': 'Europe',
                        'text': 'Europe'
                    },
                    {
                        'value': 'Japan',
                        'text': 'Japan'
                    },
                    {
                        'value': 'Hong Kong',
                        'text': 'Hong Kong'
                    },
                    {
                        'value': 'India',
                        'text': 'India'
                    },
                    {
                        'value': 'South America',
                        'text': 'South America'
                    },
                    {
                        'value': 'Australia',
                        'text': 'Australia'
                    },
                    {
                        'value': 'South Africa',
                        'text': 'South Africa'
                    },
                    {
                        'value': 'Middle East',
                        'text': 'Middle East'
                    }
                ],
                'label': 'Direct Connect Port Location',
                'description': 'Specify the Location of the Direct Connect port',
                'uiHidden': true
            },
            {
                'identifier': 'avgOnlineTargetCpuPercent',
                'type': 'number',
                'defaultValue': 60,
                'label': 'Average Online target CPU utilization (%)',
                'description': 'Specify the percentage for target average online CPU utilization',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'avgBatchOnlineTargetCpuPercent',
                'type': 'number',
                'defaultValue': 80,
                'label': 'Average Batch target CPU utilization (%)',
                'description': 'Specify the percentage for target average batch CPU utilization',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'onlineMipsShareCompute',
                'type': 'number',
                'defaultValue': 70,
                'label': 'Online MIPS share to compute (%)',
                'description': 'Specify the percentage of online MIPS used for compute',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'onlineMipsShareDB',
                'type': 'number',
                'defaultValue': 30,
                'label': 'Online MIPS share to database (%)',
                'description': 'Specify the percentage of online MIPS used for database',
                'uiHidden': false,
                'uiDisabled': true,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'batchMipsShareCompute',
                'type': 'number',
                'defaultValue': 50,
                'label': 'Batch MIPS share to compute (%)',
                'description': 'Specify the percentage of batch MIPS used for compute',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'batchMipsShareDB',
                'type': 'number',
                'defaultValue': 50,
                'label': 'Batch MIPS share to database (%)',
                'description': 'Specify the percentage of batch MIPS used for database',
                'uiHidden': false,
                'uiDisabled': true,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'prodCloudWatchMetricsPerService',
                'type': 'number',
                'defaultValue': 10,
                'label': 'Production CloudWatch Metrics Per Service',
                'description': 'Specify the number of CloudWatch metrics needed for each production environment',
                'uiHidden': true,
                'validation': {
                    'min': 0,
                    'max': 1000
                }
            },
            {
                'identifier': 'nonProdCloudWatchMetricsPerService',
                'type': 'number',
                'defaultValue': 5,
                'label': 'Non-Production CloudWatch Metrics Per Service',
                'description': 'Specify the number of CloudWatch metrics needed for each non-production environment',
                'uiHidden': true,
                'validation': {
                    'min': 0,
                    'max': 1000
                }
            },
            {
                'identifier': 'ec2OS',
                'type': 'enum',
                'defaultValue': 'Linux',
                'enum': [
                    {
                        'value': 'Linux',
                        'text': 'Linux'
                    },
                    {
                        'value': 'RHEL',
                        'text': 'RHEL'
                    },
                    {
                        'value': 'SLES',
                        'text': 'SLES'
                    },
                    {
                        'value': 'Windows',
                        'text': 'Windows'
                    }
                ],
                'label': 'EC2 instance OS',
                'description': 'Specify the operating system for EC2 instances',
                'uiHidden': false
            },
            {
                'identifier': 'ec2Tenancy',
                'type': 'enum',
                'defaultValue': 'shared',
                'enum': [
                    {
                        'value': 'shared',
                        'text': 'Shared'
                    },
                    {
                        'value': 'host',
                        'text': 'Dedicated Host'
                    }
                ],
                'label': 'EC2 tenancy',
                'description': 'Specify the tenancy type for EC2',
                'uiHidden': false
            },
            {
                'identifier': 'avgSizePerEBSVolumeInGB',
                'type': 'number',
                'defaultValue': 200,
                'label': 'Average EBS volume size (GB)',
                'description': 'Average size per EBS volume in GB',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 1,
                    'max': 10000
                }
            },
            {
                'identifier': 'putsPerTBS3Thousands',
                'type': 'number',
                'defaultValue': 0,
                'label': 'PUTs per TB of S3 IA (1000s)',
                'description': 'Average number (in thousands) of PUT operations per 1 TB of S3 Infrequent Access.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10000000000000000
                }
            },
            {
                'identifier': 'getsPerTBS3Thousands',
                'type': 'number',
                'defaultValue': 0,
                'label': 'GETs/LISTs per TB of S3 IA (1000s)',
                'description': 'Average number (in thousands) of GETs/LISTs operations per 1 TB of S3 Infrequent Access.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10000000000000000
                }
            },
            {
                'identifier': 'totalLcus',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Total LCUs (for all LBs)',
                'description': 'Total number of Load Balancer Capacity Units for all Load Balancers',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10000000000000000
                }
            },
            {
                'identifier': 'mainframeOnAWSAdjustmentAmt',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Manual adjustment for the AWS cost of the Mainframe workloads ($)',
                'description': 'Entered amount will be added to the AWS cost of the Mainframe Workloads.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0
                }
            },
            {
                'identifier': 'mainframeOnAWSAdjustmentDesc',
                'type': 'string',
                'defaultValue': '',
                'label': 'Description of the Manual adjustment to the AWS cost of the Mainframe workloads',
                'description': 'Entered description will appear on the screen for reference.',
                'uiHidden': false,
                'validation': {
                    'maxLen': 50
                }
            },
            {
                'identifier': 'mainframeOnAWS3rdPartyAmt',
                'type': 'number',
                'defaultValue': 0,
                'label': '3rd party software annual cost ($)',
                'description': 'Entered amount will be added to the AWS cost of the Mainframe workloads.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0
                }
            },
            {
                'identifier': 'mainframeOnAWS3rdPartyDesc',
                'type': 'string',
                'defaultValue': '',
                'label': 'Description of the 3rd party software annual cost',
                'description': 'Entered description will appear on the screen for reference.',
                'uiHidden': false,
                'validation': {
                    'maxLen': 50
                }
            },
            {
                'identifier': 'disasterRecoveryStrategy',
                'type': 'enum',
                'defaultValue': 'warm_standby',
                'enum': [
                    {
                        'value': 'none',
                        'text': 'None'
                    },
                    {
                        'value': 'backup_restore',
                        'text': 'Backup and Restore'
                    },
                    {
                        'value': 'pilot_light',
                        'text': 'Pilot Light'
                    },
                    {
                        'value': 'warm_standby',
                        'text': 'Warm Standby'
                    }
                ],
                'label': 'Disaster recovery strategy',
                'description': 'Specify the disaster recovery strategy',
                'uiHidden': false
            }
        ]
    },
    {
        'identifier': 'mainframeOnPrem',
        'type': 'object',
        'label': 'Mainframe - On-premises',
        'properties': [
            {
                'identifier': 'totalInstalledMIPS',
                'type': 'number',
                'defaultValue': 20000,
                'label': 'Total installed MIPS on ALL Mainframes',
                'description': 'The Total Installed MIPS on all mainframes.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 100,
                    'max': 100000
                }
            },
            {
                'identifier': 'smallMIPSCost',
                'type': 'number',
                'defaultValue': 5992,
                'label': 'Small MIPS average annual Mainframe cost per installed MIPS ($)',
                'description': 'A small MIPS installation is considered having between 0 and 1500 MIPS.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 100,
                    'max': 10000
                }
            },
            {
                'identifier': 'mediumMIPSCost',
                'type': 'number',
                'defaultValue': 2194,
                'label': 'Medium MIPS average annual Mainframe cost per installed MIPS ($)',
                'description': 'A medium MIPS installation is considered having between 1,501 and 30,000 MIPS.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 100,
                    'max': 10000
                }
            },
            {
                'identifier': 'largeMIPSCost',
                'type': 'number',
                'defaultValue': 841,
                'label': 'Large MIPS average annual Mainframe cost per installed MIPS ($)',
                'description': 'A large MIPS installation is considered having more than 30,001 MIPS.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 100,
                    'max': 10000
                }
            },
            {
                'identifier': 'mainframeCostDistHW',
                'type': 'number',
                'defaultValue': 22,
                'label': 'Mainframe cost distribution - Hardware (%)',
                'description': 'The percentage of the total mainframe cost allocated to hardware.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'mainframeCostDistSW',
                'type': 'number',
                'defaultValue': 46,
                'label': 'Mainframe cost distribution - Software (%)',
                'description': 'The percentage of the total mainframe cost allocated to software.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'mainframeCostDistPersonnel',
                'type': 'number',
                'defaultValue': 28,
                'label': 'Mainframe cost distribution - Personnel (%)',
                'description': 'The percentage of the total mainframe cost allocated to personnel.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'mainframeCostDistConnectivity',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Mainframe cost distribution - Connectivity (%)',
                'description': 'The percentage of the total mainframe cost allocated to connectivity.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'mainframeCostDistOccupancy',
                'type': 'number',
                'defaultValue': 1,
                'label': 'Mainframe cost distribution - Occupancy (%)',
                'description': 'The percentage of the total mainframe cost allocated to occupancy.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'mainframeCostDistDR',
                'type': 'number',
                'defaultValue': 1,
                'label': 'Mainframe cost distribution - Disaster Recovery (%)',
                'description': 'The percentage of the total mainframe cost allocated to disaster recovery.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'mainframeCostDistUnallocated',
                'type': 'number',
                'defaultValue': 2,
                'label': 'Mainframe cost distribution - Unallocated (%)',
                'description': 'The percentage of the total mainframe cost allocated to unallocated.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'mainframeOnPremAdjustmentAmt',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Manual adjustment for the Mainframe On-Premises cost ($)',
                'description': 'Entered amount will be added to the Mainframe On-Premises cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0
                }
            },
            {
                'identifier': 'mainframeOnPremAdjustmentDesc',
                'type': 'string',
                'defaultValue': '',
                'label': 'Description of the Manual adjustment to the Mainframe On-Premises cost',
                'description': 'Entered description will appear on the screen for reference.',
                'uiHidden': false,
                'validation': {
                    'maxLen': 50
                }
            }
        ]
    },
    {
        'identifier': 'mainframeMigrationCost',
        'type': 'object',
        'label': 'Mainframe - migration costs',
        'properties': [
            {
                'identifier': 'totalLinesOfCode',
                'type': 'number',
                'defaultValue': 3000000,
                'label': 'Total number of lines of code on ALL workloads',
                'description': 'The total number of lines of code on all mainframe workloads.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 100000,
                    'max': 100000000
                }
            },
            {
                'identifier': 'locPerTestCase',
                'type': 'number',
                'defaultValue': 3000,
                'label': 'Number of lines of code covered by each test case',
                'description': 'The number of lines of code covered by each test case (average).',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 100,
                    'max': 50000
                }
            },
            {
                'identifier': 'smallerTestTierLaborCost',
                'type': 'number',
                'defaultValue': 2000,
                'label': 'Labor cost per test case - Smaller tier ($)',
                'description': 'The smaller test case tier is considered having between 0 and 100 test cases.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 100,
                    'max': 10000
                }
            },
            {
                'identifier': 'smallTestTierLaborCost',
                'type': 'number',
                'defaultValue': 1900,
                'label': 'Labor cost per test case - Small tier ($)',
                'description': 'The small test case tier is considered having between 101 and 500 test cases.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 100,
                    'max': 10000
                }
            },
            {
                'identifier': 'mediumTestTierLaborCost',
                'type': 'number',
                'defaultValue': 1800,
                'label': 'Labor cost per test case - Medium tier ($)',
                'description': 'The medium test case tier is considered having between 501 and 1,000 test cases.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 100,
                    'max': 10000
                }
            },
            {
                'identifier': 'largeTestTierLaborCost',
                'type': 'number',
                'defaultValue': 1700,
                'label': 'Labor cost per test case - Large tier ($)',
                'description': 'The large test case tier is considered having between 1,001 and 5,000 test cases.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 100,
                    'max': 10000
                }
            },
            {
                'identifier': 'largerTestTierLaborCost',
                'type': 'number',
                'defaultValue': 1600,
                'label': 'Labor cost per test case - Larger tier ($)',
                'description': 'The larger test case tier is considered having between 5,001 and 10,000 test cases.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 100,
                    'max': 10000
                }
            },
            {
                'identifier': 'largestTestTierLaborCost',
                'type': 'number',
                'defaultValue': 1500,
                'label': 'Labor cost per test case - Largest tier ($)',
                'description': 'The largest test case tier is considered having more than 10,001 test cases.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 100,
                    'max': 10000
                }
            },
            {
                'identifier': 'smallerMigrationTierToolCost',
                'type': 'number',
                'defaultValue': 0.6,
                'label': 'Tool cost per line of code - Smaller tier ($)',
                'description': 'The smaller lines of code tier is considered having between 0 and 100,000 lines of code.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 5
                }
            },
            {
                'identifier': 'smallMigrationTierToolCost',
                'type': 'number',
                'defaultValue': 0.4,
                'label': 'Tool cost per line of code - Small tier ($)',
                'description': 'The small lines of code tier is considered having between 100,001 and 500,000 lines of code.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 5
                }
            },
            {
                'identifier': 'mediumMigrationTierToolCost',
                'type': 'number',
                'defaultValue': 0.3,
                'label': 'Tool cost per line of code - Medium tier ($)',
                'description': 'The medium lines of code tier is considered having between 500,001 and 1,000,000 lines of code.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 5
                }
            },
            {
                'identifier': 'largeMigrationTierToolCost',
                'type': 'number',
                'defaultValue': 0.2,
                'label': 'Tool cost per line of code - Large tier ($)',
                'description': 'The large lines of code tier is considered having between 1,000,001 and 5,000,000 lines of code.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 5
                }
            },
            {
                'identifier': 'largerMigrationTierToolCost',
                'type': 'number',
                'defaultValue': 0.15,
                'label': 'Tool cost per line of code - Larger tier ($)',
                'description': 'The larger lines of code tier is considered having between 5,000,001 and 10,000,000 lines of code.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 5
                }
            },
            {
                'identifier': 'largestMigrationTierToolCost',
                'type': 'number',
                'defaultValue': 0.13,
                'label': 'Tool cost per line of code - Largest tier ($)',
                'description': 'The largest lines of code tier is considered having more than 10,000,001 lines of code.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 2,
                    'min': 0,
                    'max': 5
                }
            },
            {
                'identifier': 'migrationSupportCostPerMonth',
                'type': 'number',
                'defaultValue': 20000,
                'label': 'Migration support cost per month ($)',
                'description': 'The monthly estimated labor costs to support the migration.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 1000,
                    'max': 100000
                }
            },
            {
                'identifier': 'integratedDependenciesPerEnv',
                'type': 'number',
                'defaultValue': 2,
                'label': 'Total integrated dependencies per environment',
                'description': 'Integrated dependencies are components which need to be migrated and integrated separately from the programs and data '
                    + '(security server, scheduler, reporting, printing ...',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 100
                }
            },
            {
                'identifier': 'laborCostPerIntegratedDependency',
                'type': 'number',
                'defaultValue': 20000,
                'label': 'Labor cost per integrated dependency per month ($)',
                'description': 'The monthly labor cost per integrated dependency.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 1000,
                    'max': 100000
                }
            },
            {
                'identifier': 'mainframeMigrationAdjustmentAmt',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Manual adjustment for the Mainframe migration cost ($)',
                'description': 'Entered amount will be added to the Mainframe migration cost.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0
                }
            },
            {
                'identifier': 'mainframeMigrationAdjustmentDesc',
                'type': 'string',
                'defaultValue': '',
                'label': 'Description of the Manual adjustment to the Mainframe migration cost',
                'description': 'Entered description will appear on the screen for reference.',
                'uiHidden': false,
                'validation': {
                    'maxLen': 50
                }
            }
        ]
    },
    {
        'identifier': 'migrationStrategy',
        'label': 'Migration strategy',
        'type': 'object',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'optimusOn',
                'type': 'boolean',
                'label': 'Use Optimus for migration strategy',
                'defaultValue': false,
                'uiHidden': true
            }
        ]
    },
    
    {
        'identifier': 'apacMigrationResourceCosts',
        'type': 'object',
        'label': 'Migration Resource Costs (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'customerSeniorCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Senior Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerOffshoreCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Offshore Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Senior Offshore Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'awsSeniorCost',
                'type': 'number',
                'defaultValue': 345,
                'label': 'Hourly Rate of Senior AWS Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsCost',
                'type': 'number',
                'defaultValue': 265,
                'label': 'Hourly Rate of AWS Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 175,
                'label': 'Hourly Rate of Senior AWS Offshore Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsOffshoreCost',
                'type': 'number',
                'defaultValue': 100,
                'label': 'Hourly Rate of AWS Offshore Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerSeniorCost',
                'type': 'number',
                'defaultValue': 250,
                'label': 'Hourly Rate of Senior Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerCost',
                'type': 'number',
                'defaultValue': 150,
                'label': 'Hourly Rate of Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerOffshoreCost',
                'type': 'number',
                'defaultValue': 150,
                'label': 'Hourly Rate of Offshore Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 300
                }
            },
            {
                'identifier': 'partnerSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 150,
                'label': 'Hourly Rate of Senior Offshore Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 300
                }
            }
        ]
    },
    {
        'identifier': 'apacMigrationSprintTeamComposition',
        'type': 'object',
        'label': 'Migration Sprint Team Composition (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'retainPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retain Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retire Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retire Sprint team',
                'description': 'Number of customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retire Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retire Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retire Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retire Sprint team',
                'description': 'Number of AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retire Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retire Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrResources',
                'defaultValue': 0,
                'label': 'Number of senior partner resources in Retire Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retire Sprint team',
                'description': 'Number of partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retire Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retire Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retain Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retain Sprint team',
                'description': 'Number of customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retain Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retain Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retain Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retain Sprint team',
                'description': 'Number of AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retain Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retain Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior partner resources in Retain Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retain Sprint team',
                'description': 'Number of partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retain Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Relocate Sprint team',
                'description': 'Number of senior customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Relocate Sprint team',
                'description': 'Number of customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Relocate Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Relocate Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Relocate Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Relocate Sprint team',
                'description': 'Number of AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore relocate in Retire Sprint team',
                'description': 'Number of senior AWS Offshore relocate in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Relocate Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Relocate Sprint team',
                'description': 'Number of senior partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Relocate Sprint team',
                'description': 'Number of partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Relocate Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Relocate Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Repurchase Sprint team',
                'description': 'Number of senior customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Repurchase Sprint team',
                'description': 'Number of customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Repurchase Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Repurchase Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Repurchase Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Repurchase Sprint team',
                'description': 'Number of AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior partner resources in Repurchase Sprint team',
                'description': 'Number of senior partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Repurchase Sprint team',
                'description': 'Number of partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Repurchase Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Repurchase Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Rehost Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rehost Sprint team',
                'description': 'Number of customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rehost Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Rehost Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rehost Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rehost Sprint team',
                'description': 'Number of AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Rehost Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rehost Sprint team',
                'description': 'Number of partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rehost Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rehost Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Replatform Sprint team',
                'description': 'Number of senior customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Replatform Sprint team',
                'description': 'Number of customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Replatform Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Replatform Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Replatform Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Replatform Sprint team',
                'description': 'Number of AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Replatform Sprint team',
                'description': 'Number of senior partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Replatform Sprint team',
                'description': 'Number of partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Replatform Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Replatform Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior customer resources in Rearchitect Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rearchitect Sprint team',
                'description': 'Number of AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrResources',
                'defaultValue': 4,
                'label': 'Number of senior partner resources in Rearchitect Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rearchitect Sprint team',
                'description': 'Number of partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            }
        ]
    },
    {
        'identifier': 'apacMigrationToolsAndSchedule',
        'type': 'object',
        'label': 'Migration tools and schedule',
        'properties': [
            {
                'identifier': 'discoveryTool',
                'type': 'number',
                'defaultValue': 50,
                'label': 'Discovery tool ($) / server',
                'description': 'Cost of discovery tool per server. AWS Discovery service is free.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 200
                }
            },
            {
                'identifier': 'migrationTool',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Migration tool ($) / server',
                'description': 'Cost of Migration tool per server. It will be applicable for rehost servers.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 400
                }
            },
            {
                'identifier': 'trainingCost',
                'type': 'number',
                'defaultValue': 2500,
                'label': 'Training ($) / candidate',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 5000
                }
            },
            {
                'identifier': 'countOfResourcesToTrain',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Number of training participants',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 5000
                }
            },
            {
                'identifier': 'projectDurationWeeks',
                'type': 'enum',
                'enum': [
                    {
                        'value': '26',
                        'text': '6 months'
                    },
                    {
                        'value': '52',
                        'text': '1 Year'
                    },
                    {
                        'value': '78',
                        'text': '1.5 Years'
                    },
                    {
                        'value': '104',
                        'text': '2 Years'
                    },
                    {
                        'value': '130',
                        'text': '2.5 Years'
                    },
                    {
                        'value': '156',
                        'text': '3 Years'
                    },
                    {
                        'value': '182',
                        'text': '3.5 Years'
                    },
                    {
                        'value': '208',
                        'text': '4 Years'
                    },
                    {
                        'value': '234',
                        'text': '4.5 Years'
                    },
                    {
                        'value': '260',
                        'text': '5 Years'
                    }
                ],
                'defaultValue': '104',
                'label': 'Project duration',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'sprintDuration',
                'type': 'number',
                'defaultValue': 2,
                'label': 'Sprint duration (weeks)',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10
                }
            },
            {
                'identifier': 'workingHoursPerWeek',
                'type': 'number',
                'defaultValue': 40,
                'label': 'Working hours per week',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 80
                }
            },
            {
                'identifier': 'managementWorkingHoursPerWeek',
                'type': 'number',
                'defaultValue': 10,
                'label': 'Management working hours per week',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 80
                }
            },
            {
                'identifier': 'otherCosts',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Additional migration effort costs ($)',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10000000
                }
            },
            {
                'identifier': 'customerLocation',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'apac',
                        'text': 'Asia Pacific'
                    },
                    {
                        'value': 'china',
                        'text': 'China'
                    },
                    {
                        'value': 'emea',
                        'text': 'Europe / Middle East / Africa'
                    },
                    {
                        'value': 'japn',
                        'text': 'Japan'
                    },
                    {
                        'value': 'amer',
                        'text': 'North America'
                    },
                    {
                        'value': 'latam',
                        'text': 'South America'
                    }
                ],
                'defaultValue': 'apac',
                'label': 'Project Location',
                'description': 'Geographical location where migration project will run',
                'uiHidden': true,
                'uiDisabled': false,
                'uiCtrlHint': 'dropDown'
            }
        ],
        'uiHidden': true
    },
    {
        'identifier': 'apacDatabaseSprintTeamComposition',
        'type': 'object',
        'label': 'Migration Sprint Team Composition (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'retainPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retain Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retire Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retire Sprint team',
                'description': 'Number of customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retire Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retire Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retire Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retire Sprint team',
                'description': 'Number of AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retire Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retire Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrResources',
                'defaultValue': 0,
                'label': 'Number of senior partner resources in Retire Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retire Sprint team',
                'description': 'Number of partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retire Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retire Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retain Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retain Sprint team',
                'description': 'Number of customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retain Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retain Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retain Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retain Sprint team',
                'description': 'Number of AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retain Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retain Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior partner resources in Retain Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retain Sprint team',
                'description': 'Number of partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retain Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Relocate Sprint team',
                'description': 'Number of senior customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Relocate Sprint team',
                'description': 'Number of customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Relocate Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Relocate Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Relocate Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Relocate Sprint team',
                'description': 'Number of AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore relocate in Retire Sprint team',
                'description': 'Number of senior AWS Offshore relocate in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Relocate Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Relocate Sprint team',
                'description': 'Number of senior partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Relocate Sprint team',
                'description': 'Number of partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Relocate Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Relocate Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Repurchase Sprint team',
                'description': 'Number of senior customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Repurchase Sprint team',
                'description': 'Number of customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Repurchase Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Repurchase Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Repurchase Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Repurchase Sprint team',
                'description': 'Number of AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior partner resources in Repurchase Sprint team',
                'description': 'Number of senior partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Repurchase Sprint team',
                'description': 'Number of partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Repurchase Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Repurchase Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Rehost Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rehost Sprint team',
                'description': 'Number of customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rehost Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Rehost Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rehost Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rehost Sprint team',
                'description': 'Number of AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Rehost Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rehost Sprint team',
                'description': 'Number of partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rehost Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rehost Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Replatform Sprint team',
                'description': 'Number of senior customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Replatform Sprint team',
                'description': 'Number of customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Replatform Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Replatform Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Replatform Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Replatform Sprint team',
                'description': 'Number of AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Replatform Sprint team',
                'description': 'Number of senior partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Replatform Sprint team',
                'description': 'Number of partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Replatform Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Replatform Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior customer resources in Rearchitect Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rearchitect Sprint team',
                'description': 'Number of AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrResources',
                'defaultValue': 4,
                'label': 'Number of senior partner resources in Rearchitect Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rearchitect Sprint team',
                'description': 'Number of partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            }
        ]
    },
    {
        'identifier': 'chinaMigrationResourceCosts',
        'type': 'object',
        'label': 'Migration Resource Costs (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'customerSeniorCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Senior Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerOffshoreCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Offshore Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Senior Offshore Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'awsSeniorCost',
                'type': 'number',
                'defaultValue': 345,
                'label': 'Hourly Rate of Senior AWS Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsCost',
                'type': 'number',
                'defaultValue': 260,
                'label': 'Hourly Rate of AWS Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 175,
                'label': 'Hourly Rate of Senior AWS Offshore Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsOffshoreCost',
                'type': 'number',
                'defaultValue': 100,
                'label': 'Hourly Rate of AWS Offshore Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerSeniorCost',
                'type': 'number',
                'defaultValue': 200,
                'label': 'Hourly Rate of Senior Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerCost',
                'type': 'number',
                'defaultValue': 100,
                'label': 'Hourly Rate of Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerOffshoreCost',
                'type': 'number',
                'defaultValue': 100,
                'label': 'Hourly Rate of Offshore Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 300
                }
            },
            {
                'identifier': 'partnerSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 200,
                'label': 'Hourly Rate of Senior Offshore Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 300
                }
            }
        ]
    },
    {
        'identifier': 'chinaMigrationSprintTeamComposition',
        'type': 'object',
        'label': 'Migration Sprint Team Composition (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'retainPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retain Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retire Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retire Sprint team',
                'description': 'Number of customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retire Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retire Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retire Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retire Sprint team',
                'description': 'Number of AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retire Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retire Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrResources',
                'defaultValue': 0,
                'label': 'Number of senior partner resources in Retire Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retire Sprint team',
                'description': 'Number of partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retire Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retire Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retain Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retain Sprint team',
                'description': 'Number of customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retain Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retain Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retain Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retain Sprint team',
                'description': 'Number of AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retain Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retain Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior partner resources in Retain Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retain Sprint team',
                'description': 'Number of partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retain Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Relocate Sprint team',
                'description': 'Number of senior customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Relocate Sprint team',
                'description': 'Number of customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Relocate Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Relocate Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Relocate Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Relocate Sprint team',
                'description': 'Number of AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore relocate in Retire Sprint team',
                'description': 'Number of senior AWS Offshore relocate in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Relocate Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Relocate Sprint team',
                'description': 'Number of senior partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Relocate Sprint team',
                'description': 'Number of partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Relocate Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Relocate Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Repurchase Sprint team',
                'description': 'Number of senior customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerResources',
                'defaultValue': 1,
                'label': 'Number of customer resources in Repurchase Sprint team',
                'description': 'Number of customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Repurchase Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Repurchase Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Repurchase Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Repurchase Sprint team',
                'description': 'Number of AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrResources',
                'defaultValue': 0,
                'label': 'Number of senior partner resources in Repurchase Sprint team',
                'description': 'Number of senior partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerResources',
                'defaultValue': 2,
                'label': 'Number of partner resources in Repurchase Sprint team',
                'description': 'Number of partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Repurchase Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Repurchase Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Rehost Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rehost Sprint team',
                'description': 'Number of customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rehost Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Rehost Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rehost Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSResources',
                'defaultValue': 1,
                'label': 'Number of AWS resources in Rehost Sprint team',
                'description': 'Number of AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior partner resources in Rehost Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerResources',
                'defaultValue': 2,
                'label': 'Number of partner resources in Rehost Sprint team',
                'description': 'Number of partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rehost Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rehost Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Replatform Sprint team',
                'description': 'Number of senior customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerResources',
                'defaultValue': 1,
                'label': 'Number of customer resources in Replatform Sprint team',
                'description': 'Number of customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Replatform Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Replatform Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Replatform Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSResources',
                'defaultValue': 1,
                'label': 'Number of AWS resources in Replatform Sprint team',
                'description': 'Number of AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior partner resources in Replatform Sprint team',
                'description': 'Number of senior partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerResources',
                'defaultValue': 2,
                'label': 'Number of partner resources in Replatform Sprint team',
                'description': 'Number of partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Replatform Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Replatform Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Rearchitect Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerResources',
                'defaultValue': 2,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSResources',
                'defaultValue': 1,
                'label': 'Number of AWS resources in Rearchitect Sprint team',
                'description': 'Number of AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior partner resources in Rearchitect Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerResources',
                'defaultValue': 3,
                'label': 'Number of partner resources in Rearchitect Sprint team',
                'description': 'Number of partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            }
        ]
    },
    {
        'identifier': 'chinaMigrationToolsAndSchedule',
        'type': 'object',
        'label': 'Migration tools and schedule',
        'properties': [
            {
                'identifier': 'discoveryTool',
                'type': 'number',
                'defaultValue': 50,
                'label': 'Discovery tool ($) / server',
                'description': 'Cost of discovery tool per server. AWS Discovery service is free.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 200
                }
            },
            {
                'identifier': 'migrationTool',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Migration tool ($) / server',
                'description': 'Cost of Migration tool per server. It will be applicable for rehost servers.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 400
                }
            },
            {
                'identifier': 'trainingCost',
                'type': 'number',
                'defaultValue': 750,
                'label': 'Training ($) / candidate',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 5000
                }
            },
            {
                'identifier': 'countOfResourcesToTrain',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Number of training participants',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 5000
                }
            },
            {
                'identifier': 'projectDurationWeeks',
                'type': 'enum',
                'enum': [
                    {
                        'value': '26',
                        'text': '6 months'
                    },
                    {
                        'value': '52',
                        'text': '1 Year'
                    },
                    {
                        'value': '78',
                        'text': '1.5 Years'
                    },
                    {
                        'value': '104',
                        'text': '2 Years'
                    },
                    {
                        'value': '130',
                        'text': '2.5 Years'
                    },
                    {
                        'value': '156',
                        'text': '3 Years'
                    },
                    {
                        'value': '182',
                        'text': '3.5 Years'
                    },
                    {
                        'value': '208',
                        'text': '4 Years'
                    },
                    {
                        'value': '234',
                        'text': '4.5 Years'
                    },
                    {
                        'value': '260',
                        'text': '5 Years'
                    }
                ],
                'defaultValue': '104',
                'label': 'Project duration',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'sprintDuration',
                'type': 'number',
                'defaultValue': 2,
                'label': 'Sprint duration (weeks)',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10
                }
            },
            {
                'identifier': 'workingHoursPerWeek',
                'type': 'number',
                'defaultValue': 40,
                'label': 'Working hours per week',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 80
                }
            },
            {
                'identifier': 'managementWorkingHoursPerWeek',
                'type': 'number',
                'defaultValue': 10,
                'label': 'Management working hours per week',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 80
                }
            },
            {
                'identifier': 'otherCosts',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Additional migration effort costs ($)',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10000000
                }
            },
            {
                'identifier': 'customerLocation',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'apac',
                        'text': 'Asia Pacific'
                    },
                    {
                        'value': 'china',
                        'text': 'China'
                    },
                    {
                        'value': 'emea',
                        'text': 'Europe / Middle East / Africa'
                    },
                    {
                        'value': 'japn',
                        'text': 'Japan'
                    },
                    {
                        'value': 'amer',
                        'text': 'North America'
                    },
                    {
                        'value': 'latam',
                        'text': 'South America'
                    }
                ],
                'defaultValue': 'china',
                'label': 'Project Location',
                'description': 'Geographical location where migration project will run',
                'uiHidden': true,
                'uiDisabled': false,
                'uiCtrlHint': 'dropDown'
            }
        ],
        'uiHidden': true
    },
    {
        'identifier': 'chinaDatabaseSprintTeamComposition',
        'type': 'object',
        'label': 'Migration Sprint Team Composition (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'retainPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retain Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retire Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retire Sprint team',
                'description': 'Number of customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retire Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retire Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retire Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retire Sprint team',
                'description': 'Number of AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retire Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retire Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrResources',
                'defaultValue': 0,
                'label': 'Number of senior partner resources in Retire Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retire Sprint team',
                'description': 'Number of partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retire Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retire Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retain Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retain Sprint team',
                'description': 'Number of customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retain Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retain Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retain Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retain Sprint team',
                'description': 'Number of AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retain Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retain Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior partner resources in Retain Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retain Sprint team',
                'description': 'Number of partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retain Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Relocate Sprint team',
                'description': 'Number of senior customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Relocate Sprint team',
                'description': 'Number of customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Relocate Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Relocate Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Relocate Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Relocate Sprint team',
                'description': 'Number of AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore relocate in Retire Sprint team',
                'description': 'Number of senior AWS Offshore relocate in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Relocate Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Relocate Sprint team',
                'description': 'Number of senior partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Relocate Sprint team',
                'description': 'Number of partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Relocate Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Relocate Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Repurchase Sprint team',
                'description': 'Number of senior customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerResources',
                'defaultValue': 1,
                'label': 'Number of customer resources in Repurchase Sprint team',
                'description': 'Number of customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Repurchase Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Repurchase Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Repurchase Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Repurchase Sprint team',
                'description': 'Number of AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrResources',
                'defaultValue': 0,
                'label': 'Number of senior partner resources in Repurchase Sprint team',
                'description': 'Number of senior partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerResources',
                'defaultValue': 2,
                'label': 'Number of partner resources in Repurchase Sprint team',
                'description': 'Number of partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Repurchase Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Repurchase Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Rehost Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rehost Sprint team',
                'description': 'Number of customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rehost Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Rehost Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rehost Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSResources',
                'defaultValue': 1,
                'label': 'Number of AWS resources in Rehost Sprint team',
                'description': 'Number of AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior partner resources in Rehost Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerResources',
                'defaultValue': 2,
                'label': 'Number of partner resources in Rehost Sprint team',
                'description': 'Number of partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rehost Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rehost Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Replatform Sprint team',
                'description': 'Number of senior customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerResources',
                'defaultValue': 1,
                'label': 'Number of customer resources in Replatform Sprint team',
                'description': 'Number of customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Replatform Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Replatform Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Replatform Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSResources',
                'defaultValue': 1,
                'label': 'Number of AWS resources in Replatform Sprint team',
                'description': 'Number of AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior partner resources in Replatform Sprint team',
                'description': 'Number of senior partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerResources',
                'defaultValue': 2,
                'label': 'Number of partner resources in Replatform Sprint team',
                'description': 'Number of partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Replatform Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Replatform Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Rearchitect Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerResources',
                'defaultValue': 2,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSResources',
                'defaultValue': 1,
                'label': 'Number of AWS resources in Rearchitect Sprint team',
                'description': 'Number of AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior partner resources in Rearchitect Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerResources',
                'defaultValue': 3,
                'label': 'Number of partner resources in Rearchitect Sprint team',
                'description': 'Number of partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            }
        ]
    },
    {
        'identifier': 'emeaMigrationResourceCosts',
        'type': 'object',
        'label': 'Migration Resource Costs (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'customerSeniorCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Senior Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerOffshoreCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Offshore Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Senior Offshore Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'awsSeniorCost',
                'type': 'number',
                'defaultValue': 345,
                'label': 'Hourly Rate of Senior AWS Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsCost',
                'type': 'number',
                'defaultValue': 266,
                'label': 'Hourly Rate of AWS Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 175,
                'label': 'Hourly Rate of Senior AWS Offshore Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsOffshoreCost',
                'type': 'number',
                'defaultValue': 100,
                'label': 'Hourly Rate of AWS Offshore Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerSeniorCost',
                'type': 'number',
                'defaultValue': 205,
                'label': 'Hourly Rate of Senior Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerCost',
                'type': 'number',
                'defaultValue': 103,
                'label': 'Hourly Rate of Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerOffshoreCost',
                'type': 'number',
                'defaultValue': 37,
                'label': 'Hourly Rate of Offshore Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 300
                }
            },
            {
                'identifier': 'partnerSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 66,
                'label': 'Hourly Rate of Senior Offshore Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 300
                }
            }
        ]
    },
    {
        'identifier': 'emeaMigrationSprintTeamComposition',
        'type': 'object',
        'label': 'Migration Sprint Team Composition (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'retainPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retain Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retire Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retire Sprint team',
                'description': 'Number of customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retire Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retire Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retire Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retire Sprint team',
                'description': 'Number of AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retire Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retire Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrResources',
                'defaultValue': 0,
                'label': 'Number of senior partner resources in Retire Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retire Sprint team',
                'description': 'Number of partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retire Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retire Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retain Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retain Sprint team',
                'description': 'Number of customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retain Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retain Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retain Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retain Sprint team',
                'description': 'Number of AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retain Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retain Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior partner resources in Retain Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retain Sprint team',
                'description': 'Number of partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retain Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Relocate Sprint team',
                'description': 'Number of senior customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Relocate Sprint team',
                'description': 'Number of customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Relocate Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Relocate Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Relocate Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Relocate Sprint team',
                'description': 'Number of AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore relocate in Retire Sprint team',
                'description': 'Number of senior AWS Offshore relocate in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Relocate Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Relocate Sprint team',
                'description': 'Number of senior partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Relocate Sprint team',
                'description': 'Number of partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Relocate Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Relocate Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Repurchase Sprint team',
                'description': 'Number of senior customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Repurchase Sprint team',
                'description': 'Number of customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Repurchase Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Repurchase Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Repurchase Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Repurchase Sprint team',
                'description': 'Number of AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior partner resources in Repurchase Sprint team',
                'description': 'Number of senior partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Repurchase Sprint team',
                'description': 'Number of partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Repurchase Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Repurchase Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Rehost Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rehost Sprint team',
                'description': 'Number of customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rehost Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Rehost Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rehost Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rehost Sprint team',
                'description': 'Number of AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Rehost Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rehost Sprint team',
                'description': 'Number of partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rehost Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rehost Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Replatform Sprint team',
                'description': 'Number of senior customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Replatform Sprint team',
                'description': 'Number of customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Replatform Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Replatform Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Replatform Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Replatform Sprint team',
                'description': 'Number of AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Replatform Sprint team',
                'description': 'Number of senior partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Replatform Sprint team',
                'description': 'Number of partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Replatform Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Replatform Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior customer resources in Rearchitect Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rearchitect Sprint team',
                'description': 'Number of AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrResources',
                'defaultValue': 4,
                'label': 'Number of senior partner resources in Rearchitect Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rearchitect Sprint team',
                'description': 'Number of partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            }
        ]
    },
    {
        'identifier': 'emeaMigrationToolsAndSchedule',
        'type': 'object',
        'label': 'Migration tools and schedule',
        'properties': [
            {
                'identifier': 'discoveryTool',
                'type': 'number',
                'defaultValue': 50,
                'label': 'Discovery tool ($) / server',
                'description': 'Cost of discovery tool per server. AWS Discovery service is free.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 200
                }
            },
            {
                'identifier': 'migrationTool',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Migration tool ($) / server',
                'description': 'Cost of Migration tool per server. It will be applicable for rehost servers.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 400
                }
            },
            {
                'identifier': 'trainingCost',
                'type': 'number',
                'defaultValue': 2925,
                'label': 'Training ($) / candidate',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 5000
                }
            },
            {
                'identifier': 'countOfResourcesToTrain',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Number of training participants',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 5000
                }
            },
            {
                'identifier': 'projectDurationWeeks',
                'type': 'enum',
                'enum': [
                    {
                        'value': '26',
                        'text': '6 months'
                    },
                    {
                        'value': '52',
                        'text': '1 Year'
                    },
                    {
                        'value': '78',
                        'text': '1.5 Years'
                    },
                    {
                        'value': '104',
                        'text': '2 Years'
                    },
                    {
                        'value': '130',
                        'text': '2.5 Years'
                    },
                    {
                        'value': '156',
                        'text': '3 Years'
                    },
                    {
                        'value': '182',
                        'text': '3.5 Years'
                    },
                    {
                        'value': '208',
                        'text': '4 Years'
                    },
                    {
                        'value': '234',
                        'text': '4.5 Years'
                    },
                    {
                        'value': '260',
                        'text': '5 Years'
                    }
                ],
                'defaultValue': '104',
                'label': 'Project duration',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'sprintDuration',
                'type': 'number',
                'defaultValue': 2,
                'label': 'Sprint duration (weeks)',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10
                }
            },
            {
                'identifier': 'workingHoursPerWeek',
                'type': 'number',
                'defaultValue': 40,
                'label': 'Working hours per week',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 80
                }
            },
            {
                'identifier': 'managementWorkingHoursPerWeek',
                'type': 'number',
                'defaultValue': 10,
                'label': 'Management working hours per week',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 80
                }
            },
            {
                'identifier': 'otherCosts',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Additional migration effort costs ($)',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10000000
                }
            },
            {
                'identifier': 'customerLocation',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'apac',
                        'text': 'Asia Pacific'
                    },
                    {
                        'value': 'china',
                        'text': 'China'
                    },
                    {
                        'value': 'emea',
                        'text': 'Europe / Middle East / Africa'
                    },
                    {
                        'value': 'japn',
                        'text': 'Japan'
                    },
                    {
                        'value': 'amer',
                        'text': 'North America'
                    },
                    {
                        'value': 'latam',
                        'text': 'South America'
                    }
                ],
                'defaultValue': 'emea',
                'label': 'Project Location',
                'description': 'Geographical location where migration project will run',
                'uiHidden': true,
                'uiDisabled': false,
                'uiCtrlHint': 'dropDown'
            }
        ],
        'uiHidden': true
    },
    {
        'identifier': 'emeaDatabaseSprintTeamComposition',
        'type': 'object',
        'label': 'Migration Sprint Team Composition (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'retainPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retain Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retire Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retire Sprint team',
                'description': 'Number of customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retire Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retire Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retire Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retire Sprint team',
                'description': 'Number of AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retire Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retire Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrResources',
                'defaultValue': 0,
                'label': 'Number of senior partner resources in Retire Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retire Sprint team',
                'description': 'Number of partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retire Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retire Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retain Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retain Sprint team',
                'description': 'Number of customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retain Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retain Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retain Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retain Sprint team',
                'description': 'Number of AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retain Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retain Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior partner resources in Retain Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retain Sprint team',
                'description': 'Number of partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retain Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Relocate Sprint team',
                'description': 'Number of senior customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Relocate Sprint team',
                'description': 'Number of customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Relocate Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Relocate Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Relocate Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Relocate Sprint team',
                'description': 'Number of AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore relocate in Retire Sprint team',
                'description': 'Number of senior AWS Offshore relocate in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Relocate Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Relocate Sprint team',
                'description': 'Number of senior partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Relocate Sprint team',
                'description': 'Number of partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Relocate Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Relocate Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Repurchase Sprint team',
                'description': 'Number of senior customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Repurchase Sprint team',
                'description': 'Number of customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Repurchase Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Repurchase Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Repurchase Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Repurchase Sprint team',
                'description': 'Number of AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior partner resources in Repurchase Sprint team',
                'description': 'Number of senior partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Repurchase Sprint team',
                'description': 'Number of partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Repurchase Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Repurchase Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Rehost Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rehost Sprint team',
                'description': 'Number of customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rehost Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Rehost Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rehost Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rehost Sprint team',
                'description': 'Number of AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Rehost Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rehost Sprint team',
                'description': 'Number of partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rehost Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rehost Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Replatform Sprint team',
                'description': 'Number of senior customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Replatform Sprint team',
                'description': 'Number of customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Replatform Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Replatform Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Replatform Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Replatform Sprint team',
                'description': 'Number of AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Replatform Sprint team',
                'description': 'Number of senior partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Replatform Sprint team',
                'description': 'Number of partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Replatform Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Replatform Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior customer resources in Rearchitect Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rearchitect Sprint team',
                'description': 'Number of AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrResources',
                'defaultValue': 4,
                'label': 'Number of senior partner resources in Rearchitect Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rearchitect Sprint team',
                'description': 'Number of partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            }
        ]
    },
    {
        'identifier': 'japnMigrationResourceCosts',
        'type': 'object',
        'label': 'Migration Resource Costs (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'customerSeniorCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Senior Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerOffshoreCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Offshore Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Senior Offshore Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'awsSeniorCost',
                'type': 'number',
                'defaultValue': 320,
                'label': 'Hourly Rate of Senior AWS Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsCost',
                'type': 'number',
                'defaultValue': 245,
                'label': 'Hourly Rate of AWS Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 175,
                'label': 'Hourly Rate of Senior AWS Offshore Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsOffshoreCost',
                'type': 'number',
                'defaultValue': 100,
                'label': 'Hourly Rate of AWS Offshore Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerSeniorCost',
                'type': 'number',
                'defaultValue': 200,
                'label': 'Hourly Rate of Senior Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerCost',
                'type': 'number',
                'defaultValue': 200,
                'label': 'Hourly Rate of Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerOffshoreCost',
                'type': 'number',
                'defaultValue': 200,
                'label': 'Hourly Rate of Offshore Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 300
                }
            },
            {
                'identifier': 'partnerSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 200,
                'label': 'Hourly Rate of Senior Offshore Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 300
                }
            }
        ]
    },
    {
        'identifier': 'japnMigrationSprintTeamComposition',
        'type': 'object',
        'label': 'Migration Sprint Team Composition (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'retainPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retain Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retire Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retire Sprint team',
                'description': 'Number of customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retire Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retire Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retire Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retire Sprint team',
                'description': 'Number of AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retire Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retire Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrResources',
                'defaultValue': 0,
                'label': 'Number of senior partner resources in Retire Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retire Sprint team',
                'description': 'Number of partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retire Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retire Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retain Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retain Sprint team',
                'description': 'Number of customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retain Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retain Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retain Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retain Sprint team',
                'description': 'Number of AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retain Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retain Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior partner resources in Retain Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retain Sprint team',
                'description': 'Number of partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retain Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Relocate Sprint team',
                'description': 'Number of senior customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Relocate Sprint team',
                'description': 'Number of customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Relocate Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Relocate Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Relocate Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Relocate Sprint team',
                'description': 'Number of AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore relocate in Retire Sprint team',
                'description': 'Number of senior AWS Offshore relocate in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Relocate Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Relocate Sprint team',
                'description': 'Number of senior partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Relocate Sprint team',
                'description': 'Number of partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Relocate Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Relocate Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Repurchase Sprint team',
                'description': 'Number of senior customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Repurchase Sprint team',
                'description': 'Number of customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Repurchase Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Repurchase Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Repurchase Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Repurchase Sprint team',
                'description': 'Number of AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior partner resources in Repurchase Sprint team',
                'description': 'Number of senior partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Repurchase Sprint team',
                'description': 'Number of partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Repurchase Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Repurchase Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Rehost Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rehost Sprint team',
                'description': 'Number of customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rehost Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Rehost Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rehost Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rehost Sprint team',
                'description': 'Number of AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Rehost Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rehost Sprint team',
                'description': 'Number of partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rehost Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rehost Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Replatform Sprint team',
                'description': 'Number of senior customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Replatform Sprint team',
                'description': 'Number of customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Replatform Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Replatform Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Replatform Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Replatform Sprint team',
                'description': 'Number of AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Replatform Sprint team',
                'description': 'Number of senior partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Replatform Sprint team',
                'description': 'Number of partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Replatform Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Replatform Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior customer resources in Rearchitect Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rearchitect Sprint team',
                'description': 'Number of AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrResources',
                'defaultValue': 4,
                'label': 'Number of senior partner resources in Rearchitect Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rearchitect Sprint team',
                'description': 'Number of partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            }
        ]
    },
    {
        'identifier': 'japnMigrationToolsAndSchedule',
        'type': 'object',
        'label': 'Migration tools and schedule',
        'properties': [
            {
                'identifier': 'discoveryTool',
                'type': 'number',
                'defaultValue': 50,
                'label': 'Discovery tool ($) / server',
                'description': 'Cost of discovery tool per server. AWS Discovery service is free.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 200
                }
            },
            {
                'identifier': 'migrationTool',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Migration tool ($) / server',
                'description': 'Cost of Migration tool per server. It will be applicable for rehost servers.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 400
                }
            },
            {
                'identifier': 'trainingCost',
                'type': 'number',
                'defaultValue': 2500,
                'label': 'Training ($) / candidate',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 5000
                }
            },
            {
                'identifier': 'countOfResourcesToTrain',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Number of training participants',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 5000
                }
            },
            {
                'identifier': 'projectDurationWeeks',
                'type': 'enum',
                'enum': [
                    {
                        'value': '26',
                        'text': '6 months'
                    },
                    {
                        'value': '52',
                        'text': '1 Year'
                    },
                    {
                        'value': '78',
                        'text': '1.5 Years'
                    },
                    {
                        'value': '104',
                        'text': '2 Years'
                    },
                    {
                        'value': '130',
                        'text': '2.5 Years'
                    },
                    {
                        'value': '156',
                        'text': '3 Years'
                    },
                    {
                        'value': '182',
                        'text': '3.5 Years'
                    },
                    {
                        'value': '208',
                        'text': '4 Years'
                    },
                    {
                        'value': '234',
                        'text': '4.5 Years'
                    },
                    {
                        'value': '260',
                        'text': '5 Years'
                    }
                ],
                'defaultValue': '104',
                'label': 'Project duration',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'sprintDuration',
                'type': 'number',
                'defaultValue': 2,
                'label': 'Sprint duration (weeks)',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10
                }
            },
            {
                'identifier': 'workingHoursPerWeek',
                'type': 'number',
                'defaultValue': 40,
                'label': 'Working hours per week',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 80
                }
            },
            {
                'identifier': 'managementWorkingHoursPerWeek',
                'type': 'number',
                'defaultValue': 10,
                'label': 'Management working hours per week',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 80
                }
            },
            {
                'identifier': 'otherCosts',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Additional migration effort costs ($)',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10000000
                }
            },
            {
                'identifier': 'customerLocation',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'apac',
                        'text': 'Asia Pacific'
                    },
                    {
                        'value': 'china',
                        'text': 'China'
                    },
                    {
                        'value': 'emea',
                        'text': 'Europe / Middle East / Africa'
                    },
                    {
                        'value': 'japn',
                        'text': 'Japan'
                    },
                    {
                        'value': 'amer',
                        'text': 'North America'
                    },
                    {
                        'value': 'latam',
                        'text': 'South America'
                    }
                ],
                'defaultValue': 'japn',
                'label': 'Project Location',
                'description': 'Geographical location where migration project will run',
                'uiHidden': true,
                'uiDisabled': false,
                'uiCtrlHint': 'dropDown'
            }
        ],
        'uiHidden': true
    },
    {
        'identifier': 'japnDatabaseSprintTeamComposition',
        'type': 'object',
        'label': 'Migration Sprint Team Composition (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'retainPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retain Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retire Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retire Sprint team',
                'description': 'Number of customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retire Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retire Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retire Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retire Sprint team',
                'description': 'Number of AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retire Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retire Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrResources',
                'defaultValue': 0,
                'label': 'Number of senior partner resources in Retire Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retire Sprint team',
                'description': 'Number of partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retire Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retire Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retain Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retain Sprint team',
                'description': 'Number of customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retain Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retain Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retain Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retain Sprint team',
                'description': 'Number of AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retain Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retain Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior partner resources in Retain Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retain Sprint team',
                'description': 'Number of partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retain Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Relocate Sprint team',
                'description': 'Number of senior customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Relocate Sprint team',
                'description': 'Number of customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Relocate Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Relocate Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Relocate Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Relocate Sprint team',
                'description': 'Number of AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore relocate in Retire Sprint team',
                'description': 'Number of senior AWS Offshore relocate in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Relocate Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Relocate Sprint team',
                'description': 'Number of senior partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Relocate Sprint team',
                'description': 'Number of partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Relocate Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Relocate Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Repurchase Sprint team',
                'description': 'Number of senior customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Repurchase Sprint team',
                'description': 'Number of customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Repurchase Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Repurchase Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Repurchase Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Repurchase Sprint team',
                'description': 'Number of AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior partner resources in Repurchase Sprint team',
                'description': 'Number of senior partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Repurchase Sprint team',
                'description': 'Number of partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Repurchase Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Repurchase Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Rehost Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rehost Sprint team',
                'description': 'Number of customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rehost Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Rehost Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rehost Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rehost Sprint team',
                'description': 'Number of AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Rehost Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rehost Sprint team',
                'description': 'Number of partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rehost Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rehost Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Replatform Sprint team',
                'description': 'Number of senior customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Replatform Sprint team',
                'description': 'Number of customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Replatform Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Replatform Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Replatform Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Replatform Sprint team',
                'description': 'Number of AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Replatform Sprint team',
                'description': 'Number of senior partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Replatform Sprint team',
                'description': 'Number of partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Replatform Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Replatform Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior customer resources in Rearchitect Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rearchitect Sprint team',
                'description': 'Number of AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrResources',
                'defaultValue': 4,
                'label': 'Number of senior partner resources in Rearchitect Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rearchitect Sprint team',
                'description': 'Number of partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            }
        ]
    },
    {
        'identifier': 'amerMigrationResourceCosts',
        'type': 'object',
        'label': 'Migration Resource Costs (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'customerSeniorCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Senior Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerOffshoreCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Offshore Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Senior Offshore Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'awsSeniorCost',
                'type': 'number',
                'defaultValue': 345,
                'label': 'Hourly Rate of Senior AWS Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsCost',
                'type': 'number',
                'defaultValue': 260,
                'label': 'Hourly Rate of AWS Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 175,
                'label': 'Hourly Rate of Senior AWS Offshore Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsOffshoreCost',
                'type': 'number',
                'defaultValue': 100,
                'label': 'Hourly Rate of AWS Offshore Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerSeniorCost',
                'type': 'number',
                'defaultValue': 200,
                'label': 'Hourly Rate of Senior Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerCost',
                'type': 'number',
                'defaultValue': 200,
                'label': 'Hourly Rate of Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerOffshoreCost',
                'type': 'number',
                'defaultValue': 200,
                'label': 'Hourly Rate of Offshore Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 300
                }
            },
            {
                'identifier': 'partnerSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 200,
                'label': 'Hourly Rate of Senior Offshore Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 300
                }
            }
        ]
    },
    {
        'identifier': 'amerMigrationSprintTeamComposition',
        'type': 'object',
        'label': 'Migration Sprint Team Composition (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'retainPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retain Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retire Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retire Sprint team',
                'description': 'Number of customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retire Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retire Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retire Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retire Sprint team',
                'description': 'Number of AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retire Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retire Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrResources',
                'defaultValue': 0,
                'label': 'Number of senior partner resources in Retire Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retire Sprint team',
                'description': 'Number of partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retire Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retire Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retain Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retain Sprint team',
                'description': 'Number of customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retain Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retain Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retain Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retain Sprint team',
                'description': 'Number of AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retain Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retain Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior partner resources in Retain Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retain Sprint team',
                'description': 'Number of partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retain Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Relocate Sprint team',
                'description': 'Number of senior customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Relocate Sprint team',
                'description': 'Number of customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Relocate Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Relocate Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Relocate Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Relocate Sprint team',
                'description': 'Number of AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore relocate in Retire Sprint team',
                'description': 'Number of senior AWS Offshore relocate in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Relocate Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Relocate Sprint team',
                'description': 'Number of senior partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Relocate Sprint team',
                'description': 'Number of partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Relocate Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Relocate Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Repurchase Sprint team',
                'description': 'Number of senior customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Repurchase Sprint team',
                'description': 'Number of customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Repurchase Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Repurchase Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Repurchase Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Repurchase Sprint team',
                'description': 'Number of AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior partner resources in Repurchase Sprint team',
                'description': 'Number of senior partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Repurchase Sprint team',
                'description': 'Number of partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Repurchase Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Repurchase Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Rehost Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rehost Sprint team',
                'description': 'Number of customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rehost Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Rehost Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rehost Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rehost Sprint team',
                'description': 'Number of AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Rehost Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rehost Sprint team',
                'description': 'Number of partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rehost Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rehost Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Replatform Sprint team',
                'description': 'Number of senior customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Replatform Sprint team',
                'description': 'Number of customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Replatform Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Replatform Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Replatform Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Replatform Sprint team',
                'description': 'Number of AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Replatform Sprint team',
                'description': 'Number of senior partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Replatform Sprint team',
                'description': 'Number of partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Replatform Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Replatform Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior customer resources in Rearchitect Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rearchitect Sprint team',
                'description': 'Number of AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrResources',
                'defaultValue': 4,
                'label': 'Number of senior partner resources in Rearchitect Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rearchitect Sprint team',
                'description': 'Number of partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            }
        ]
    },
    {
        'identifier': 'amerMigrationToolsAndSchedule',
        'type': 'object',
        'label': 'Migration tools and schedule',
        'properties': [
            {
                'identifier': 'discoveryTool',
                'type': 'number',
                'defaultValue': 50,
                'label': 'Discovery tool ($) / server',
                'description': 'Cost of discovery tool per server. AWS Discovery service is free.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 200
                }
            },
            {
                'identifier': 'migrationTool',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Migration tool ($) / server',
                'description': 'Cost of Migration tool per server. It will be applicable for rehost servers.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 400
                }
            },
            {
                'identifier': 'trainingCost',
                'type': 'number',
                'defaultValue': 2500,
                'label': 'Training ($) / candidate',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 5000
                }
            },
            {
                'identifier': 'countOfResourcesToTrain',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Number of training participants',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 5000
                }
            },
            {
                'identifier': 'projectDurationWeeks',
                'type': 'enum',
                'enum': [
                    {
                        'value': '26',
                        'text': '6 months'
                    },
                    {
                        'value': '52',
                        'text': '1 Year'
                    },
                    {
                        'value': '78',
                        'text': '1.5 Years'
                    },
                    {
                        'value': '104',
                        'text': '2 Years'
                    },
                    {
                        'value': '130',
                        'text': '2.5 Years'
                    },
                    {
                        'value': '156',
                        'text': '3 Years'
                    },
                    {
                        'value': '182',
                        'text': '3.5 Years'
                    },
                    {
                        'value': '208',
                        'text': '4 Years'
                    },
                    {
                        'value': '234',
                        'text': '4.5 Years'
                    },
                    {
                        'value': '260',
                        'text': '5 Years'
                    }
                ],
                'defaultValue': '104',
                'label': 'Project duration',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'sprintDuration',
                'type': 'number',
                'defaultValue': 2,
                'label': 'Sprint duration (weeks)',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10
                }
            },
            {
                'identifier': 'workingHoursPerWeek',
                'type': 'number',
                'defaultValue': 40,
                'label': 'Working hours per week',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 80
                }
            },
            {
                'identifier': 'managementWorkingHoursPerWeek',
                'type': 'number',
                'defaultValue': 10,
                'label': 'Management working hours per week',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 80
                }
            },
            {
                'identifier': 'otherCosts',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Additional migration effort costs ($)',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10000000
                }
            },
            {
                'identifier': 'customerLocation',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'apac',
                        'text': 'Asia Pacific'
                    },
                    {
                        'value': 'china',
                        'text': 'China'
                    },
                    {
                        'value': 'emea',
                        'text': 'Europe / Middle East / Africa'
                    },
                    {
                        'value': 'japn',
                        'text': 'Japan'
                    },
                    {
                        'value': 'amer',
                        'text': 'North America'
                    },
                    {
                        'value': 'latam',
                        'text': 'South America'
                    }
                ],
                'defaultValue': 'amer',
                'label': 'Project Location',
                'description': 'Geographical location where migration project will run',
                'uiHidden': true,
                'uiDisabled': false,
                'uiCtrlHint': 'dropDown'
            }
        ],
        'uiHidden': true
    },
    {
        'identifier': 'amerDatabaseSprintTeamComposition',
        'type': 'object',
        'label': 'Migration Sprint Team Composition (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'retainPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retain Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retire Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retire Sprint team',
                'description': 'Number of customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retire Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retire Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retire Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retire Sprint team',
                'description': 'Number of AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retire Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retire Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrResources',
                'defaultValue': 0,
                'label': 'Number of senior partner resources in Retire Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retire Sprint team',
                'description': 'Number of partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retire Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retire Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retain Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retain Sprint team',
                'description': 'Number of customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retain Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retain Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retain Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retain Sprint team',
                'description': 'Number of AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retain Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retain Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior partner resources in Retain Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retain Sprint team',
                'description': 'Number of partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retain Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Relocate Sprint team',
                'description': 'Number of senior customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Relocate Sprint team',
                'description': 'Number of customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Relocate Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Relocate Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Relocate Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Relocate Sprint team',
                'description': 'Number of AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore relocate in Retire Sprint team',
                'description': 'Number of senior AWS Offshore relocate in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Relocate Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Relocate Sprint team',
                'description': 'Number of senior partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Relocate Sprint team',
                'description': 'Number of partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Relocate Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Relocate Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Repurchase Sprint team',
                'description': 'Number of senior customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Repurchase Sprint team',
                'description': 'Number of customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Repurchase Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Repurchase Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Repurchase Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Repurchase Sprint team',
                'description': 'Number of AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior partner resources in Repurchase Sprint team',
                'description': 'Number of senior partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Repurchase Sprint team',
                'description': 'Number of partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Repurchase Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Repurchase Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Rehost Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rehost Sprint team',
                'description': 'Number of customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rehost Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Rehost Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rehost Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rehost Sprint team',
                'description': 'Number of AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Rehost Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rehost Sprint team',
                'description': 'Number of partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rehost Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rehost Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Replatform Sprint team',
                'description': 'Number of senior customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Replatform Sprint team',
                'description': 'Number of customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Replatform Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Replatform Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Replatform Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Replatform Sprint team',
                'description': 'Number of AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Replatform Sprint team',
                'description': 'Number of senior partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Replatform Sprint team',
                'description': 'Number of partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Replatform Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Replatform Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior customer resources in Rearchitect Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rearchitect Sprint team',
                'description': 'Number of AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrResources',
                'defaultValue': 4,
                'label': 'Number of senior partner resources in Rearchitect Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rearchitect Sprint team',
                'description': 'Number of partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            }
        ]
    },
    {
        'identifier': 'latamMigrationResourceCosts',
        'type': 'object',
        'label': 'Migration Resource Costs (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'customerSeniorCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Senior Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerOffshoreCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Offshore Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Senior Offshore Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'awsSeniorCost',
                'type': 'number',
                'defaultValue': 300,
                'label': 'Hourly Rate of Senior AWS Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsCost',
                'type': 'number',
                'defaultValue': 250,
                'label': 'Hourly Rate of AWS Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 175,
                'label': 'Hourly Rate of Senior AWS Offshore Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsOffshoreCost',
                'type': 'number',
                'defaultValue': 100,
                'label': 'Hourly Rate of AWS Offshore Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerSeniorCost',
                'type': 'number',
                'defaultValue': 120,
                'label': 'Hourly Rate of Senior Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerCost',
                'type': 'number',
                'defaultValue': 90,
                'label': 'Hourly Rate of Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerOffshoreCost',
                'type': 'number',
                'defaultValue': 200,
                'label': 'Hourly Rate of Offshore Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 300
                }
            },
            {
                'identifier': 'partnerSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 200,
                'label': 'Hourly Rate of Senior Offshore Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 300
                }
            }
        ]
    },
    {
        'identifier': 'latamMigrationSprintTeamComposition',
        'type': 'object',
        'label': 'Migration Sprint Team Composition (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'retainPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retain Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retire Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retire Sprint team',
                'description': 'Number of customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retire Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retire Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retire Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retire Sprint team',
                'description': 'Number of AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retire Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retire Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrResources',
                'defaultValue': 0,
                'label': 'Number of senior partner resources in Retire Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retire Sprint team',
                'description': 'Number of partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retire Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retire Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retain Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retain Sprint team',
                'description': 'Number of customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retain Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retain Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retain Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retain Sprint team',
                'description': 'Number of AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retain Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retain Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior partner resources in Retain Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retain Sprint team',
                'description': 'Number of partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retain Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Relocate Sprint team',
                'description': 'Number of senior customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Relocate Sprint team',
                'description': 'Number of customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Relocate Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Relocate Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Relocate Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Relocate Sprint team',
                'description': 'Number of AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore relocate in Retire Sprint team',
                'description': 'Number of senior AWS Offshore relocate in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Relocate Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Relocate Sprint team',
                'description': 'Number of senior partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Relocate Sprint team',
                'description': 'Number of partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Relocate Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Relocate Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Repurchase Sprint team',
                'description': 'Number of senior customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Repurchase Sprint team',
                'description': 'Number of customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Repurchase Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Repurchase Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Repurchase Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Repurchase Sprint team',
                'description': 'Number of AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior partner resources in Repurchase Sprint team',
                'description': 'Number of senior partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Repurchase Sprint team',
                'description': 'Number of partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Repurchase Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Repurchase Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Rehost Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rehost Sprint team',
                'description': 'Number of customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rehost Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Rehost Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rehost Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rehost Sprint team',
                'description': 'Number of AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Rehost Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rehost Sprint team',
                'description': 'Number of partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rehost Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rehost Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Replatform Sprint team',
                'description': 'Number of senior customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Replatform Sprint team',
                'description': 'Number of customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Replatform Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Replatform Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Replatform Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Replatform Sprint team',
                'description': 'Number of AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Replatform Sprint team',
                'description': 'Number of senior partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Replatform Sprint team',
                'description': 'Number of partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Replatform Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Replatform Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior customer resources in Rearchitect Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rearchitect Sprint team',
                'description': 'Number of AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrResources',
                'defaultValue': 4,
                'label': 'Number of senior partner resources in Rearchitect Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rearchitect Sprint team',
                'description': 'Number of partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            }
        ]
    },
    {
        'identifier': 'latamMigrationToolsAndSchedule',
        'type': 'object',
        'label': 'Migration tools and schedule',
        'properties': [
            {
                'identifier': 'discoveryTool',
                'type': 'number',
                'defaultValue': 50,
                'label': 'Discovery tool ($) / server',
                'description': 'Cost of discovery tool per server. AWS Discovery service is free.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 200
                }
            },
            {
                'identifier': 'migrationTool',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Migration tool ($) / server',
                'description': 'Cost of Migration tool per server. It will be applicable for rehost servers.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 400
                }
            },
            {
                'identifier': 'trainingCost',
                'type': 'number',
                'defaultValue': 2500,
                'label': 'Training ($) / candidate',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 5000
                }
            },
            {
                'identifier': 'countOfResourcesToTrain',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Number of training participants',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 5000
                }
            },
            {
                'identifier': 'projectDurationWeeks',
                'type': 'enum',
                'enum': [
                    {
                        'value': '26',
                        'text': '6 months'
                    },
                    {
                        'value': '52',
                        'text': '1 Year'
                    },
                    {
                        'value': '78',
                        'text': '1.5 Years'
                    },
                    {
                        'value': '104',
                        'text': '2 Years'
                    },
                    {
                        'value': '130',
                        'text': '2.5 Years'
                    },
                    {
                        'value': '156',
                        'text': '3 Years'
                    },
                    {
                        'value': '182',
                        'text': '3.5 Years'
                    },
                    {
                        'value': '208',
                        'text': '4 Years'
                    },
                    {
                        'value': '234',
                        'text': '4.5 Years'
                    },
                    {
                        'value': '260',
                        'text': '5 Years'
                    }
                ],
                'defaultValue': '104',
                'label': 'Project duration',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'sprintDuration',
                'type': 'number',
                'defaultValue': 2,
                'label': 'Sprint duration (weeks)',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10
                }
            },
            {
                'identifier': 'workingHoursPerWeek',
                'type': 'number',
                'defaultValue': 40,
                'label': 'Working hours per week',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 80
                }
            },
            {
                'identifier': 'managementWorkingHoursPerWeek',
                'type': 'number',
                'defaultValue': 10,
                'label': 'Management working hours per week',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 80
                }
            },
            {
                'identifier': 'otherCosts',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Additional migration effort costs ($)',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10000000
                }
            },
            {
                'identifier': 'customerLocation',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'apac',
                        'text': 'Asia Pacific'
                    },
                    {
                        'value': 'china',
                        'text': 'China'
                    },
                    {
                        'value': 'emea',
                        'text': 'Europe / Middle East / Africa'
                    },
                    {
                        'value': 'japn',
                        'text': 'Japan'
                    },
                    {
                        'value': 'amer',
                        'text': 'North America'
                    },
                    {
                        'value': 'latam',
                        'text': 'South America'
                    }
                ],
                'defaultValue': 'latam',
                'label': 'Project Location',
                'description': 'Geographical location where migration project will run',
                'uiHidden': true,
                'uiDisabled': false,
                'uiCtrlHint': 'dropDown'
            }
        ],
        'uiHidden': true
    },
    {
        'identifier': 'latamDatabaseSprintTeamComposition',
        'type': 'object',
        'label': 'Migration Sprint Team Composition (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'retainPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retain Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retire Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retire Sprint team',
                'description': 'Number of customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retire Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retire Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retire Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retire Sprint team',
                'description': 'Number of AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retire Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retire Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrResources',
                'defaultValue': 0,
                'label': 'Number of senior partner resources in Retire Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retire Sprint team',
                'description': 'Number of partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retire Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retire Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retain Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retain Sprint team',
                'description': 'Number of customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retain Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retain Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retain Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retain Sprint team',
                'description': 'Number of AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retain Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retain Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior partner resources in Retain Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retain Sprint team',
                'description': 'Number of partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retain Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Relocate Sprint team',
                'description': 'Number of senior customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Relocate Sprint team',
                'description': 'Number of customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Relocate Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Relocate Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Relocate Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Relocate Sprint team',
                'description': 'Number of AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore relocate in Retire Sprint team',
                'description': 'Number of senior AWS Offshore relocate in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Relocate Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Relocate Sprint team',
                'description': 'Number of senior partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Relocate Sprint team',
                'description': 'Number of partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Relocate Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Relocate Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Repurchase Sprint team',
                'description': 'Number of senior customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Repurchase Sprint team',
                'description': 'Number of customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Repurchase Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Repurchase Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Repurchase Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Repurchase Sprint team',
                'description': 'Number of AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior partner resources in Repurchase Sprint team',
                'description': 'Number of senior partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Repurchase Sprint team',
                'description': 'Number of partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Repurchase Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Repurchase Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Rehost Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rehost Sprint team',
                'description': 'Number of customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rehost Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Rehost Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rehost Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rehost Sprint team',
                'description': 'Number of AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Rehost Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rehost Sprint team',
                'description': 'Number of partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rehost Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rehost Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Replatform Sprint team',
                'description': 'Number of senior customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Replatform Sprint team',
                'description': 'Number of customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Replatform Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Replatform Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Replatform Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Replatform Sprint team',
                'description': 'Number of AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Replatform Sprint team',
                'description': 'Number of senior partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Replatform Sprint team',
                'description': 'Number of partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Replatform Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Replatform Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior customer resources in Rearchitect Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rearchitect Sprint team',
                'description': 'Number of AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrResources',
                'defaultValue': 4,
                'label': 'Number of senior partner resources in Rearchitect Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rearchitect Sprint team',
                'description': 'Number of partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            }
        ]
    },
    {
        'identifier': 'migrationResourceCosts',
        'type': 'object',
        'label': 'Migration Resource Costs (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'customerSeniorCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Senior Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerOffshoreCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Offshore Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'customerSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Hourly Rate of Senior Offshore Customer Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 250
                }
            },
            {
                'identifier': 'awsSeniorCost',
                'type': 'number',
                'defaultValue': 345,
                'label': 'Hourly Rate of Senior AWS Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsCost',
                'type': 'number',
                'defaultValue': 260,
                'label': 'Hourly Rate of AWS Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 175,
                'label': 'Hourly Rate of Senior AWS Offshore Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'awsOffshoreCost',
                'type': 'number',
                'defaultValue': 100,
                'label': 'Hourly Rate of AWS Offshore Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerSeniorCost',
                'type': 'number',
                'defaultValue': 200,
                'label': 'Hourly Rate of Senior Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerCost',
                'type': 'number',
                'defaultValue': 200,
                'label': 'Hourly Rate of Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 500
                }
            },
            {
                'identifier': 'partnerOffshoreCost',
                'type': 'number',
                'defaultValue': 200,
                'label': 'Hourly Rate of Offshore Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 300
                }
            },
            {
                'identifier': 'partnerSeniorOffshoreCost',
                'type': 'number',
                'defaultValue': 200,
                'label': 'Hourly Rate of Senior Offshore Partner Resource (USD/Hr)',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 300
                }
            }
        ]
    },
    {
        'identifier': 'migrationToolsAndSchedule',
        'type': 'object',
        'label': 'Migration tools and schedule',
        'properties': [
            {
                'identifier': 'discoveryTool',
                'type': 'number',
                'defaultValue': 50,
                'label': 'Discovery tool ($) / server',
                'description': 'Cost of discovery tool per server. AWS Discovery service is free.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 200
                }
            },
            {
                'identifier': 'migrationTool',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Migration tool ($) / server',
                'description': 'Cost of Migration tool per server. It will be applicable for rehost servers.',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 400
                }
            },
            {
                'identifier': 'trainingCost',
                'type': 'number',
                'defaultValue': 2500,
                'label': 'Training ($) / candidate',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 5000
                }
            },
            {
                'identifier': 'countOfResourcesToTrain',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Number of training participants',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 5000
                }
            },
            {
                'identifier': 'projectDurationWeeks',
                'type': 'enum',
                'enum': [
                    {
                        'value': '26',
                        'text': '6 months'
                    },
                    {
                        'value': '52',
                        'text': '1 Year'
                    },
                    {
                        'value': '78',
                        'text': '1.5 Years'
                    },
                    {
                        'value': '104',
                        'text': '2 Years'
                    },
                    {
                        'value': '130',
                        'text': '2.5 Years'
                    },
                    {
                        'value': '156',
                        'text': '3 Years'
                    },
                    {
                        'value': '182',
                        'text': '3.5 Years'
                    },
                    {
                        'value': '208',
                        'text': '4 Years'
                    },
                    {
                        'value': '234',
                        'text': '4.5 Years'
                    },
                    {
                        'value': '260',
                        'text': '5 Years'
                    }
                ],
                'defaultValue': '104',
                'label': 'Project duration',
                'uiHidden': false,
                'uiCtrlHint': 'dropDown'
            },
            {
                'identifier': 'sprintDuration',
                'type': 'number',
                'defaultValue': 2,
                'label': 'Sprint duration (weeks)',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10
                }
            },
            {
                'identifier': 'workingHoursPerWeek',
                'type': 'number',
                'defaultValue': 40,
                'label': 'Working hours per week',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 80
                }
            },
            {
                'identifier': 'managementWorkingHoursPerWeek',
                'type': 'number',
                'defaultValue': 10,
                'label': 'Management working hours per week',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 80
                }
            },
            {
                'identifier': 'otherCosts',
                'type': 'number',
                'defaultValue': 0,
                'label': 'Additional migration effort costs ($)',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 0,
                    'min': 0,
                    'max': 10000000
                }
            },
            {
                'identifier': 'customerLocation',
                'type': 'enum',
                'enum': [
                    {
                        'value': 'apac',
                        'text': 'Asia Pacific'
                    },
                    {
                        'value': 'china',
                        'text': 'China'
                    },
                    {
                        'value': 'emea',
                        'text': 'Europe / Middle East / Africa'
                    },
                    {
                        'value': 'japn',
                        'text': 'Japan'
                    },
                    {
                        'value': 'amer',
                        'text': 'North America'
                    },
                    {
                        'value': 'latam',
                        'text': 'South America'
                    }
                ],
                'defaultValue': 'amer',
                'label': 'Project Location',
                'description': 'Geographical location where migration project will run',
                'uiHidden': true,
                'uiDisabled': false,
                'uiCtrlHint': 'dropDown'
            }
        ]
    },
    {
        'identifier': 'migrationSprintTeamComposition',
        'type': 'object',
        'label': 'Migration Sprint Team Composition (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'retainPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retain Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retire Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retire Sprint team',
                'description': 'Number of customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retire Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retire Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retire Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retire Sprint team',
                'description': 'Number of AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retire Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retire Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrResources',
                'defaultValue': 0,
                'label': 'Number of senior partner resources in Retire Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retire Sprint team',
                'description': 'Number of partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retire Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retire Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retain Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retain Sprint team',
                'description': 'Number of customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retain Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retain Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retain Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retain Sprint team',
                'description': 'Number of AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retain Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retain Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior partner resources in Retain Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retain Sprint team',
                'description': 'Number of partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retain Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Relocate Sprint team',
                'description': 'Number of senior customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Relocate Sprint team',
                'description': 'Number of customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Relocate Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Relocate Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Relocate Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Relocate Sprint team',
                'description': 'Number of AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore relocate in Retire Sprint team',
                'description': 'Number of senior AWS Offshore relocate in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Relocate Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Relocate Sprint team',
                'description': 'Number of senior partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Relocate Sprint team',
                'description': 'Number of partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Relocate Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Relocate Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Repurchase Sprint team',
                'description': 'Number of senior customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Repurchase Sprint team',
                'description': 'Number of customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Repurchase Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Repurchase Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Repurchase Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Repurchase Sprint team',
                'description': 'Number of AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior partner resources in Repurchase Sprint team',
                'description': 'Number of senior partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Repurchase Sprint team',
                'description': 'Number of partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Repurchase Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Repurchase Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Rehost Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rehost Sprint team',
                'description': 'Number of customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rehost Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Rehost Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rehost Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rehost Sprint team',
                'description': 'Number of AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Rehost Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rehost Sprint team',
                'description': 'Number of partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rehost Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rehost Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Replatform Sprint team',
                'description': 'Number of senior customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Replatform Sprint team',
                'description': 'Number of customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Replatform Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Replatform Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Replatform Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Replatform Sprint team',
                'description': 'Number of AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Replatform Sprint team',
                'description': 'Number of senior partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Replatform Sprint team',
                'description': 'Number of partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Replatform Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Replatform Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior customer resources in Rearchitect Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rearchitect Sprint team',
                'description': 'Number of AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrResources',
                'defaultValue': 4,
                'label': 'Number of senior partner resources in Rearchitect Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rearchitect Sprint team',
                'description': 'Number of partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            }
        ]
    },
    {
        'identifier': 'databaseSprintTeamComposition',
        'type': 'object',
        'label': 'Migration Sprint Team Composition (Now configurable on Migration Cost page)',
        'uiHidden': true,
        'properties': [
            {
                'identifier': 'retainPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retain Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retire Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retire Sprint team',
                'description': 'Number of customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retire Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retire Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retire Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retire Sprint team',
                'description': 'Number of AWS resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retire Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retireAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retire Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrResources',
                'defaultValue': 0,
                'label': 'Number of senior partner resources in Retire Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retire Sprint team',
                'description': 'Number of partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retire Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retirePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Retire Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Retain Sprint team',
                'description': 'Number of senior customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Retain Sprint team',
                'description': 'Number of customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Retain Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Retain Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS resources in Retain Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Retain Sprint team',
                'description': 'Number of AWS resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Retain Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Retain Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior partner resources in Retain Sprint team',
                'description': 'Number of senior partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Retain Sprint team',
                'description': 'Number of partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'retainPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Retain Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for retaining the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Relocate Sprint team',
                'description': 'Number of senior customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Relocate Sprint team',
                'description': 'Number of customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Relocate Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Relocate Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Relocate Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Relocate Sprint team',
                'description': 'Number of AWS resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore relocate in Retire Sprint team',
                'description': 'Number of senior AWS Offshore relocate in the team responsible for retiring the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocateAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Relocate Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Relocate Sprint team',
                'description': 'Number of senior partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Relocate Sprint team',
                'description': 'Number of partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Relocate Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'relocatePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Relocate Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for relocating the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Repurchase Sprint team',
                'description': 'Number of senior customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Repurchase Sprint team',
                'description': 'Number of customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Repurchase Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Repurchase Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Repurchase Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Repurchase Sprint team',
                'description': 'Number of AWS resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchaseAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Repurchase Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior partner resources in Repurchase Sprint team',
                'description': 'Number of senior partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Repurchase Sprint team',
                'description': 'Number of partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Repurchase Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'repurchasePartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Repurchase Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for Repurchasing the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrResources',
                'defaultValue': 1,
                'label': 'Number of senior customer resources in Rehost Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rehost Sprint team',
                'description': 'Number of customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rehost Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Rehost Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rehost Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rehost Sprint team',
                'description': 'Number of AWS resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rehost Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Rehost Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rehost Sprint team',
                'description': 'Number of partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rehost Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rehostPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rehost Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rehosting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrResources',
                'defaultValue': 2,
                'label': 'Number of senior customer resources in Replatform Sprint team',
                'description': 'Number of senior customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Replatform Sprint team',
                'description': 'Number of customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Replatform Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore customer resources in Replatform Sprint team',
                'description': 'Number of offshore customer resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Replatform Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Replatform Sprint team',
                'description': 'Number of AWS resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Replatform Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior partner resources in Replatform Sprint team',
                'description': 'Number of senior partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Replatform Sprint team',
                'description': 'Number of partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Replatform Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'replatformPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Replatform Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for replatforming the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrResources',
                'defaultValue': 3,
                'label': 'Number of senior customer resources in Rearchitect Sprint team',
                'description': 'Number of senior customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore customer resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectCustomerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of customer resources in Rearchitect Sprint team',
                'description': 'Number of customer resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrResources',
                'defaultValue': 1,
                'label': 'Number of senior AWS resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSResources',
                'defaultValue': 0,
                'label': 'Number of AWS resources in Rearchitect Sprint team',
                'description': 'Number of AWS resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of senior AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectAWSOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of AWS Offshore resources in Rearchitect Sprint team',
                'description': 'Number of AWS Offshore resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrResources',
                'defaultValue': 4,
                'label': 'Number of senior partner resources in Rearchitect Sprint team',
                'description': 'Number of senior partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerResources',
                'defaultValue': 0,
                'label': 'Number of partner resources in Rearchitect Sprint team',
                'description': 'Number of partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerSrOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of senior offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of senior offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            },
            {
                'identifier': 'rearchitectPartnerOffshoreResources',
                'defaultValue': 0,
                'label': 'Number of offshore partner resources in Rearchitect Sprint team',
                'description': 'Number of offshore partner resources in the team responsible for rearchitecting the servers',
                'type': 'number',
                'uiHidden': true,
                'validation': {
                    'decimalPlaces': 1,
                    'max': 1000,
                    'min': 0
                }
            }
        ]
    },
    {
        'identifier': 'migrationLevelOfEffort',
        'type': 'object',
        'label': 'Server migration level of effort',
        'properties': [
            {
                'identifier': 'retire',
                'type': 'number',
                'defaultValue': 1,
                'label': 'Hours to Retire server',
                'description': 'Effort required to Retire a server',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 1,
                    'min': 0,
                    'max': 10000
                }
            },
            {
                'identifier': 'retain',
                'type': 'number',
                'defaultValue': 2,
                'label': 'Hours to Retain server',
                'description': 'Effort required to Retain a server',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 1,
                    'min': 0,
                    'max': 10000
                }
            },
            {
                'identifier': 'relocate',
                'type': 'number',
                'defaultValue': 3,
                'label': 'Hours to Relocate server',
                'description': 'Effort required to Relocate a server',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 1,
                    'min': 0,
                    'max': 10000
                }
            },
            {
                'identifier': 'repurchase',
                'type': 'number',
                'defaultValue': 6,
                'label': 'Hours to Repurchase server',
                'description': 'Effort required to Repurchase a server',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 1,
                    'min': 0,
                    'max': 10000
                }
            },
            {
                'identifier': 'rehost',
                'type': 'number',
                'defaultValue': 4,
                'label': 'Hours to Rehost server',
                'description': 'Effort required to Rehost a server',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 1,
                    'min': 0,
                    'max': 10000
                }
            },
            {
                'identifier': 'replatform',
                'type': 'number',
                'defaultValue': 12,
                'label': 'Hours to Replatform server',
                'description': 'Effort required to Replatform a server',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 1,
                    'min': 0,
                    'max': 10000
                }
            },
            {
                'identifier': 'rearchitect',
                'type': 'number',
                'defaultValue': 20,
                'label': 'Hours to Rearchitect server',
                'description': 'Effort required to Rearchitect a server',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 1,
                    'min': 0,
                    'max': 10000
                }
            }
        ]
    },
    {
        'identifier': 'databaseMigrationEffort',
        'type': 'object',
        'label': 'Database migration level of effort',
        'properties': [
            {
                'identifier': 'retire',
                'type': 'number',
                'defaultValue': 2,
                'label': 'Hours to Retire database',
                'description': 'Effort required to Retire a database',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 1,
                    'min': 0,
                    'max': 10000
                }
            },
            {
                'identifier': 'rehost',
                'type': 'number',
                'defaultValue': 8,
                'label': 'Hours to Rehost database',
                'description': 'Effort required to Rehost a database',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 1,
                    'min': 0,
                    'max': 10000
                }
            },
            {
                'identifier': 'replatform',
                'type': 'number',
                'defaultValue': 100,
                'label': 'Hours to Replatform database',
                'description': 'Effort required to Replatform a database',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 1,
                    'min': 0,
                    'max': 10000
                }
            },
            {
                'identifier': 'rearchitect',
                'type': 'number',
                'defaultValue': 240,
                'label': 'Hours to Rearchitect database',
                'description': 'Effort required to Rearchitect a database',
                'uiHidden': false,
                'validation': {
                    'decimalPlaces': 1,
                    'min': 0,
                    'max': 10000
                }
            }
        ]
    }
];
